import Vue from 'vue'
import App from './App.vue'
import "@/assets/fonts/iconfont.css"
import VueI18n from 'vue-i18n'

import store from './store'
import router from './router'; // 确保路径正确

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


Vue.use(VueI18n);

const messages = {
    en: {
        footertitile: "Copyright © Jiangsu Haikang Borui Electronics Co., Ltd. ICP Registration Number: Su ICP Bei 19071766-0",
        menu: "Menu",
        adress: "Building 2, Jingran Mingju, Yunlong District, Xuzhou, Jiangsu, China",
        home: "Home",
        Viewdocument: "View document",
        Viewdocument2: "Product Introduction of HIKBOREI",
        Technical: "Technical documentation",
        productsdectitle: "Product details ",
        newsdectitle: "News details",
        solutions: "Solutions",
        solutionssub1: "Asset Management",
        solutionssub2: "Exhibition Personnel Management",
        solutionssub3: "Library Management",
        solutionssub4: "Animal Husbandry Management",
        products: "Products",
        productssub1: "RFID Tags",
        productssub2: "Smart Hardware",
        productssub3: "Software Platforms",
        support: "Support",
        ServiceProcess1: "Service Process",
        ServiceProcess2: "Requirement Analysis and Design",
        ServiceProcess3: "Implementation and Deployment",
        ServiceProcess4: "Operation and Optimization",
        ServiceProcess5: "Requirement Sorting and Analysis",
        ServiceProcess6: "Professional Consulting Services",
        ServiceProcess7: "Requirement Verification Services",
        ServiceProcess8: "Deep Communication with You to Identify Core Needs and Evaluate Feasibility.",
        ServiceProcess9: "Provide Reliable RFID Solutions Based on Industry Best Practices and Professional Knowledge.",
        ServiceProcess10: "Collaborate with You to Repeatedly Confirm Scheme Requirements for Accuracy.",
        ServiceProcess11: "Implementation Process",
        ServiceProcess12: "Assistance with Acceptance",
        ServiceProcess13: "Professional Training",
        ServiceProcess14: "Install RFID Smart Hardware and Develop Software According to Requirements.",
        ServiceProcess15: "Professional Personnel Assist You with Functional and Performance Acceptance and Rectification as Required.",
        ServiceProcess16: "Provide Professional Training to Relevant Personnel to Ensure Proficient Use of the Solution in Real Scenarios.",
        ServiceProcess17: "Problem Tracking",
        ServiceProcess18: "Performance Optimization",
        ServiceProcess19: "Provide a Technical Support Hotline to Ensure Quick Response and Timely Resolution of Issues in the Application of the Solution.",
        ServiceProcess20: "Follow Up on Software Operation and User Feedback, Updating and Optimizing Software Performance.",
        ServiceProcess21: "If You Wish to Learn More About Our Products and RFID Solutions, Please Fill Out the Form and We Will Arrange a Specialist to Contact You Soon.",
        ServiceProcess22: "Company Name",
        ServiceProcess23: "Contact Person",
        ServiceProcess24: "Contact Information",
        ServiceProcess25: "Your Requirements",
        ServiceProcess26: "Submit",
        news: "News",
        about: "About Us",
        slidetitle: "Provider of smart IoT solutions centered around RFID technology",
        slidesubtitle: "",
        slidebuttonText: "View Details",
        solutiontitle: "RFID Industry Solutions",
        solution: {
            items: [{
                    title: 'Asset Management',
                    description: 'One-stop, full-life-cycle asset management to help businesses reduce costs and improve efficiency.'
                },
                {
                    title: 'Exhibition Personnel Management',
                    description: "Intelligent and refined management of exhibition personnel to enhance event management efficiency and participant experience."
                },
                {
                    title: 'Library Management',
                    description: 'Full-life-cycle management of library resources, comprehensively enhancing the integrated utilization value of libraries.'
                },
                {
                    title: 'Animal Husbandry Management',
                    description: 'Intelligent supervision of biological assets, improving breeding benefits, and achieving precise insurance underwriting and rapid claims settlement.'
                },
            ],
        },
        producttile: {
            items: [{
                    title: 'RFID Tags',
                    description: 'Adhesive Labels/Anti-Metal Labels/Laundry Labels/Hang Tags'
                },
                {
                    title: 'Smart Hardware',
                    description: 'Handheld/Inventory cabinet/Channel/Gantry'
                },
                {
                    title: 'Software Platforms',
                    description: 'Qingting Asset Cloud/Hikvision Agricultural Cloud'
                },
            ],
        },
        serviceprovider: "Leading provider of RFID and IoT technology solutions",
        producttitle: "Product Center",
        cooperativetitle: "Partners",
        homedec: "Jiangsu Haikang Borui Electronics Co., Ltd.（HIKBOREI） was established by the subsidiary of Cethik Group, we focus on the Internet of Things RFID tags, RFID modules and read-write products, RFID chip design and development, as well as the research and development of the RFID industry integration software, is a RFID application solutions provider. HIKBOREI is committed to building the Huaihai region RFID Internet of Things Industrial Park, is a high-tech Internet of Things enterprise with broad market prospects and development space.",
        serviceprovidertitle: {
            label1: 'Annual label production capacity exceeds 800 million',
            label2: 'Strategic cooperative customers for labels exceed 500',
            label3: 'Industry solution service customers exceed 100',
            label4: 'Business coverage in over 30 countries and regions',
            dec1: 'billion+',
            dec2: '+',
        },
        bannertitle: 'Service & Support',
        bannerdescription: 'We have a professional service team that provides a one-stop service system covering product/solution consulting, demonstration, development and deployment, and user training, helping you easily start your digital experience.',
        newbannertitle: 'News & Updates',
        newbannerdescription: 'Providing you with the latest news and information about HIKBOREI',
        aboutbannertitle: 'About Us',
        aboutbannerdescription: 'Leading Supplier of RFID and IoT Technology Solutions',
        companyprofile: 'Company Profile',
        companyIntroduction: "Jiangsu Haikang Borui Electronics Co., Ltd.（HIKBOREI） was established by the subsidiary of Cethik Group, we focus on the Internet of Things RFID tags, RFID modules and read-write products, RFID chip design and development, as well as the research and development of the RFID industry integration software, is a RFID application solutions provider. HIKBOREI is committed to building the Huaihai region RFID Internet of Things Industrial Park, is a high-tech Internet of Things enterprise with broad market prospects and development space.",
        capacity: "800 million+: Annual production capacity of over 800 million tags",
        strategicPartners: "500+: More than 500 strategic partners for tag solutions",
        industrySolutions: "100+: More than 100 clients served with industry-specific solutions",
        globalCoverage: "30+: Business coverage in over 30 countries and regions worldwide",
        technologyCombination: "With continuous technological research and innovation, HIKBOREI seamlessly combines its strong RFID tag R&D and manufacturing capabilities with IoT and big data technologies to provide high-value solutions for asset management, livestock management, library management, smart healthcare, warehousing and logistics, anti-counterfeiting and traceability, and more.",
        smartProductionBase: "Smart RFID Production Base",
        productionBaseDescription: "The HIKBOREI RFID production base is located in the Semiconductor Industry Park of Gulou District, Xuzhou City, Jiangsu Province, covering an area of 15000 square meters. The factory covers an area of 8000 square meters and has completed the construction of a 100000 level clean workshop, enterprise smart exhibition hall, and intelligent warehouse. It has advanced production equipment such as binding and compounding, as well as quality inspection equipment, to meet the production of various RFID tags (NFC, low frequency, high frequency, ultra-high frequency).",
        honors: "Honors and Awards",
        partners: "Partners",
        contactUs: "Contact Us",
        phone: "Phone: 0516-8300 0001",
        marketingDepartment: "Marketing Department:+86 19961919596",
        salesDepartment: "Sales Department: +86 19051668932",

        WhatsApp: " WhatsApp",
        WhatsApp2: " WhatsApp",
        email: "Email:info@haikangborui.com",
        address: "Address:Xuzhou Gulou Semiconductor Industrial Park, Jiangsu Province",
        WhatsAppvalue: "+86 193 0573 0833",
        WhatsApp2value: " +86 175 9736 3813",


        codedec: "Scan the QR code to contact us",
        companyNews: 'Company News',
        industryNews: 'Industry News',
        newsTitle: 'News Title',
        newsSummary: 'News Summary',
        newsTime: 'News Time',
        hardwarelistone: {
            items: [{
                id: 1,
                title: "UHF RFID Handheld",
                image: require("./assets/img/ying1.jpg"),
                model: "HKBR-RH-C5",
            }, {
                id: 2,
                title: "UHF RFID Handheld",
                image: require("./assets/img/ying2.jpg"),
                model: "HKBR-RH-MC50",
            }, {
                id: 3,
                title: "UHF RFID Bluetooth Reader",
                image: require("./assets/img/ying3.jpg"),
                model: "HKBR-RB-R2",
            }, {
                id: 4,
                title: "RFID Forklift Inventory Cabinet",
                image: require("./assets/img/ying4.jpg"),
                model: "HKBR-RInventory-S02DR",
            }, {
                id: 5,
                title: "RFID Weighing and Inventory Cabinet",
                image: require("./assets/img/ying5.jpg"),
                model: "HKBR-RInventory-W06R",
            }, {
                id: 6,
                title: "RFID Electric Inventory",
                image: require("./assets/img/ying6.jpg"),
                model: "HKBR-RInventory-09D ",
            }, {
                id: 7,
                title: "RFID Gate",
                image: require("./assets/img/ying7.jpg"),
                model: "HKBR-RG-T10",
            }, {
                id: 8,
                title: "RFID Gantry",
                image: require("./assets/img/ying8.jpg"),
                model: "HKBR-RL-L08",
            }, ]
        },
        newsone: {
            items: [{
                    "id": 16,
                    "title": "Accelerating the Focus on Intelligent Industry Layout, Collaboratively Drawing a Development Blueprint!",
                    "summary": "On June 20th, an inspection team composed of members from the Jining Taihu Lake New District Party Working Committee, Management Committee, New District Financial Bureau, and New District Investment Promotion Department visited Jiangsu Haikan Borui for an on-site investigation.",
                    image: require("./assets/img/anews16.jpg"),
                    createTime: "2025-06-20",
                }, {
                    "id": 15,
                    "title": "Municipal People's Congress Leaders Visit Hikvision-Bore: Witnessing the Innovation Potential of Smart IoT",
                    "summary": "On May 23, leaders of the Xuzhou Municipal People's Congress Work Theory Research Association, including Zhang Funing, Feng Qipu, Yuan Jianfen, Zhou Jianhong, and Wang Lifeng, led all council members to visit Hikvision-Bore, accompanied by district leaders.",
                    image: require("./assets/img/anews15.jpg"),
                    createTime: "2025-05-23",
                },
                {
                    "id": 14,
                    "title": "Tech Empowerment: Joint Delegation from Government, Enterprises and Academia Visits HIKBOREI Innovation Hub",
                    "summary": "On May 20, a delegation led by Rui Guoqiang, Party Secretary of Jiangsu Normal University, visited HIKBOREI for technological exchange. The delegation included Zhao Yusu (Director of the Party Committee Office), Gu Zhenzhong (Director of Domestic Cooperation), Wu Di (Director of Graduate Affairs), and Han Hongzheng (Deputy Director of Student Affairs), accompanied by district officials. Liu Jinpeng, General Manager of HIKBOREI, hosted the visit and presented the company's technological advancements.",
                    image: require("./assets/img/anews14.jpg"),
                    createTime: "2025-05-20",
                },
                {
                    "id": 13,
                    "title": "China-Saudi Business Exchange: Saudi Delegation Visits HIKBOREI to Strengthen Global Partnership",
                    "summary": "On May 15, a delegation of Saudi clients visited HIKBOREI's headquarters and production facilities. General Manager Liu Jinpeng and senior executives welcomed the delegation, with both parties holding substantive discussions on enhancing industrial cooperation and exploring new opportunities in smart technologies.",
                    image: require("./assets/img/anews13.jpg"),
                    createTime: "2025-05-12",
                },
                {
                    "id": 12,
                    "title": "Gulou District Officials Tour HIKBOREI: Policy Support for Tech Innovation",
                    "summary": "On May 7, a government delegation led by Luo Deqing (Gulou District Party Secretary), Cheng Feng (Deputy Secretary), and Liu Yi (Executive Deputy District Mayor) conducted an inspection tour of HIKBOREI's operations. The visit focused on understanding corporate development needs and providing targeted policy support. General Manager Liu Jinpeng presented the company's innovation roadmap during the meeting.",
                    image: require("./assets/img/anews12.jpg"),
                    createTime: "2025-05-07",
                },
                {
                    id: 11,
                    title: 'Kick Off the New Year, Embrace the New Chapter, and Win the Battle for 2025 - HIKBOREI’s 2025 New Year Gala Successfully Held',
                    summary: "On January 26th, all employees of HIKBOREI gathered together to hold a grand New Year Gala for 2025! This is not only an important moment to review the past and look forward to the future, but also a critical juncture to inspire morale and unite strength.",
                    image: require("./assets/img/anews11.jpg"),
                    createTime: "2025-01-26",
                },
                {
                    id: 10,
                    title: 'Exploring New Opportunities in Overseas Markets and Seeking Cooperative Win-Win Development - HIKBOREI’s Visit to Saudi Arabia',
                    summary: "Deeply visiting overseas customers and actively developing international markets. Recently, Liu Jinpeng, General Manager of Jiangsu HIKBOREI Electronics Co., Ltd., led a team to visit Saudi Arabian customers, yielding fruitful results and laying a solid foundation for the acceleration of HIKBOREI’s overseas market expansion.",
                    image: require("./assets/img/anews10.jpg"),
                    createTime: "2025-01-20",
                },
                {
                    id: 9,
                    title: 'Witnessing Strength! HIKBOREI Recognized as a Provincial "Specialized, Refined, and Innovative Enterprise"',
                    summary: "Recently, the Jiangsu Provincial Department of Industry and Information Technology announced the list of recognized provincial specialized, refined, and innovative enterprises for the year 2024, and HIKBOREI, with its excellent innovative capabilities and professional technical strength, made the list!",
                    image: require("./assets/img/anews9.jpg"),
                    createTime: "2024-12-31",
                },
                {
                    id: 1,
                    title: "Provincial Certification +1! Hai Kang Borui Rated as Jiangsu Province's 'Four-Star Cloud Enterprise'",
                    summary: "Recently, the Xuzhou Municipal Bureau of Industry and Information Technology announced the list of enterprises in Xuzhou City's second batch of 2024 provincial three- and four-star cloud enterprises to be recognized. After online application, preliminary review, expert review, on-site inspection, credit review, and other procedures, Jiangsu Hai Kang Borui Electronics Co., Ltd. successfully entered the list of Jiangsu Province's four-star cloud enterprises.",
                    image: require("./assets/img/anews1.jpg"),
                    createTime: "2024-12-02",
                },
                {
                    id: 2,
                    title: "RFID Tags Shipment Exceeds 100 Million! Hai Kang Borui Fully Operational, Scaling New Heights",
                    summary: "On November 1, 2024, Hai Kang Borui achieved a significant milestone with the global cumulative shipment of RFID tags exceeding 100 million.",
                    image: require("./assets/img/anews2.jpg"),
                    createTime: "2024-11-15",
                },
                {
                    id: 3,
                    title: "Saudi Arabia customer thank-you letter: Cooperative flowers bloom, gratitude and trust prevail!",
                    summary: "Thank-you letter from Saudi Arabia customer",
                    image: require("./assets/img/anews3.jpg"),
                    createTime: "2024-05-04",
                },
                {
                    id: 4,
                    title: "Hikerborai Invited to Attend the City-wide Livestock Breeding 'Prevention and Protection Cooperation, Science and Technology for Agriculture' Seminar",
                    summary: "On October 16, a seminar on 'Prevention and Protection Cooperation, Science and Technology for Agriculture' for city-wide livestock breeding was held. Zhou Wei, deputy director of the Municipal Bureau of Agriculture and Rural Affairs, attended the meeting and delivered a speech. The meeting was attended by division leaders from county and district agriculture and rural affairs bureaus, heads of epidemic prevention stations, and representatives from insurance companies.",
                    image: require("./assets/img/anews4.jpg"),
                    createTime: "2024-10-17",
                },
            ],
        },
        newsotwo: {
            items: [{
                    id: 17,
                    title: "RFID Tags: Five Key Drivers for High Growth in the Next Decade",
                    summary: "In recent years, RFID (Radio Frequency Identification) technology has evolved from an early logistics tracking tool to being widely adopted in retail, healthcare, manufacturing, smart cities, and many other fields.",
                    image: require("./assets/img/anews17.jpg"),
                    createTime: "2025-06-27"
                },

                {
                    id: 5,
                    title: "RFID Electronic Tags: A Powerful Assistant for Intelligent Production Line Management",
                    summary: "The application of RFID electronic tags has made production line management more intelligent, significantly improving work efficiency and accuracy, while reducing production costs and labor input.",
                    image: require("./assets/img/anews5.jpg"),
                    createTime: "2023-03-09",
                },
                {
                    id: 6,
                    title: "RFID Smart Warehouse Management System, Starting the Intelligent Journey of Enterprise Warehousing!",
                    summary: "Development, reform, and innovation are eternal topics in the growth of enterprises. The market's demand for products is changing rapidly, and factories' demand for personnel is becoming increasingly urgent... Many manufacturing enterprises are facing severe challenges.",
                    image: require("./assets/img/anews6.jpg"),
                    createTime: "2023-10-10",
                },
                {
                    id: 7,
                    title: "RFID Technology Transforms Retail: Improving Inventory Management Efficiency and Enhancing Customer Experience",
                    summary: "The widespread application of RFID technology in the retail industry is driving the transformation of the retail industry towards intelligent, efficient, and fine management. It enables the supply chain system to track product movements more easily and automatically in an efficient way, allowing items to achieve true automated management.",
                    image: require("./assets/img/anews7.jpg"),
                    createTime: "2023-08-03",
                },
                {
                    id: 8,
                    title: "Industry Applications and Advantages of RFID Sticker Labels",
                    summary: "RFID sticker labels are characterized by fast recognition speed, convenient and quick reading, large chip capacity, rewritable chip data, long service life, and high security. They play an important role in many industries.",
                    image: require("./assets/img/anews8.jpg"),
                    createTime: "2023-05-11",
                },
            ],
        },
        Solutiondec1: "Industry Insights",
        Solutiondec2: "Business Challenges",
        Solutiondec3: "Solution Architecture",
        Solutiondec4: "Application Scenarios",
        Solutiondec5: "Application Value",
        Solutiondec6: "Application Products",
        Solutiondec7: "Enterprise assets exist in large quantities, diverse types, and wide distribution, lacking refined management methods, leading to asset waste, idle, and low utilization efficiency.",
        Solutiondec337: "HIKBOREI provides a complete solution covering professional hardware and software, RFID tags, and services, achieving fast asset registration, efficient inventory, and easy management with 'one item, one code'",
        Solutiondec8: "Disorganized management process",
        Solutiondec9: "Low inventory efficiency",
        Solutiondec10: "Difficulty in status tracing",
        Solutiondec11: "Low asset utilization",
        Solutiondec12: "Traditional paper records are inefficient, difficult to update, and prone to errors.",
        Solutiondec13: "Inventory workload is heavy, traditional mode is slow, and errors such as mis-inventory or missing inventory often occur.",
        Solutiondec14: "Under traditional management methods, asset status changes are not timely, easy to overlook and make mistakes.",
        Solutiondec15: "Inefficient allocation and transfer of assets, leading to severe cases of redundant purchases and idle assets.",
        Solutiondec16: "HIKBOREI provides a full set of solutions covering professional hardware and software, RFID tags, and services, achieving rapid asset registration, efficient inventory, and easy management through ‘one object, one code’.",
        Solutiondec17: "Asset Entry",
        Solutiondec18: "Asset Inventory",
        Solutiondec19: "Asset Management",
        Solutiondec20: "Batch import/establish asset ledger",
        Solutiondec21: "Batch inventory/non-contact inventory/multi-person simultaneous inventory",
        Solutiondec22: "Full lifecycle management/depreciation/diversified reports/custom approval processes",
        Solutiondec23: "Management efficiency increased by 60%",
        Solutiondec24: "Inventory cost reduced by 75%",
        Solutiondec25: "Asset utilization increased by 60%",
        Solutiondec26: "Discrepancy between accounts and actual assets reduced by 80%",
        Solutiondec27: "RFID Tag",
        Solutiondec28: "Handheld Device",
        Solutiondec29: "Label Printer",
        Solutiondec30: "Security Gate",
        Solutiondec31: "Diversified RFID tags, including adhesive labels, PET labels, anti-metal labels, etc.",
        Solutiondec32: "Reading distance 5-8 meters, efficiently completing asset inventory",
        Solutiondec33: "Fully functional, meeting the needs of different label printing purposes",
        Solutiondec34: "Real-time monitoring and tracing asset change information",
        Solutiondec35: "In large trade shows or events, with the vast number of attendees, traditional management methods can no longer meet the needs of modern exhibitions. They often encounter problems such as crowd congestion and sign-in omissions, and cannot achieve dynamic management of personnel.",
        Solutiondec36: "Poor participant experience",
        Solutiondec37: "Inaccurate data recording",
        Solutiondec38: "Low personnel management efficiency",
        Solutiondec39: "Lack of data feedback",
        Solutiondec40: "Complex check-in process, long waiting time.",
        Solutiondec41: "Number statistics are incomplete, identity information is unclear.",
        Solutiondec42: "Unable to achieve dynamic personnel management, lacking effective data feedback.",
        Solutiondec43: "Unable to form effective event statistics data.",
        Solutiondec44: "HIKBOREI uses RFID technology as the foundation, combining RFID wristbands with data analysis and other technical means to achieve real-time monitoring and intelligent management of the entire process, scenarios, and all personnel in the event.",
        Solutiondec45: "Personnel Check-in",
        Solutiondec46: "Personnel Management",
        Solutiondec47: "Node Management",
        Solutiondec48: "Data Analysis",
        Solutiondec49: "Quick check-in/personnel count/identity confirmation and security screening",
        Solutiondec50: "Location tracking/checkpoint quick passage/area identity restriction",
        Solutiondec51: "Statistical information of participants at each event node",
        Solutiondec52: "Area heat map/historical trajectory, historical data queryable",
        Solutiondec53: "Enhance security",
        Solutiondec54: "Optimize participant experience",
        Solutiondec55: "Improve management efficiency",
        Solutiondec56: "Provide data support",
        Solutiondec57: "Through identity confirmation and area control, potential safety hazards are warned, improving exhibition security.",
        Solutiondec58: "Reduces waiting time and operation process in the check-in link, enhancing participant experience.",
        Solutiondec59: "Reduces manual operations, achieving refined and intelligent personnel management.",
        Solutiondec60: "Collects data on participant behavior patterns to provide strong support for future resource allocation and venue management.",
        Solutiondec61: "RFID Wristband",
        Solutiondec62: "Handheld Device",
        Solutiondec63: "Lightweight design, comfortable to wear, improving information recognition efficiency",
        Solutiondec64: "Quick and accurate reading of RFID wristband information, maximum reading distance 30 meters",
        Solutiondec65: "Library literature information is large in quantity, complex in type, and diverse in form, facing multiple challenges such as borrowing, returning, inventory, searching, and sorting misplaced books, affecting library management efficiency and reader experience.",
        Solutiondec66: "Outdated management methods",
        Solutiondec67: "Poor reader experience",
        Solutiondec68: "Poor resource integration capability",
        Solutiondec69: "Insufficient information construction",
        Solutiondec70: "Barcode management, difficult to inventory and search, books easily missed, stolen, and misplaced.",
        Solutiondec71: "The process of finding books, borrowing and returning books is cumbersome, poor reader experience, reducing borrowing enthusiasm.",
        Solutiondec72: "Paper books, periodicals, and literature cannot be integrated for unified digital management.",
        Solutiondec73: "Library circulation data cannot be collected, borrowing and circulation rates cannot be summarized.",
        Solutiondec74: "HIKBOREI integrates RFID technology with gate access, book tags, self-service borrowing and returning machines, inventory equipment, and librarian workstation system software to achieve convenient book management functions.",
        Solutiondec75: "Book Inclusion",
        Solutiondec76: "Book Borrowing and Returning",
        Solutiondec77: "Book Management",
        Solutiondec78: "Label Printing and Pasting",
        Solutiondec79: "Self-service borrowing and returning/returning and shelving/security management",
        Solutiondec80: "Book inventory/book location/book sorting",
        Solutiondec81: "Enhance circulation efficiency",
        Solutiondec82: "Increase security",
        Solutiondec83: "Improve user experience",
        Solutiondec84: "Provide data support",
        Solutiondec85: "Simplify the process of borrowing and returning books, reduce manual intervention, and improve circulation efficiency.",
        Solutiondec86: "Book security management effectively prevents book theft.",
        Solutiondec87: "Self service and intelligent management meet the efficient service needs of readers.",
        Solutiondec88: "Data statistics and analysis can better understand readers' needs and optimize management.",
        Solutiondec89: "RFID Tag",
        Solutiondec90: "Label Printer",
        Solutiondec91: "Handheld Device",
        Solutiondec92: "Smart Gate",
        Solutiondec93: "Self-service Borrowing and Returning Machine",
        Solutiondec94: "Book Tags and Shelf Tags",
        Solutiondec95: "Fully functional, meeting the needs of different label printing purposes",
        Solutiondec96: "Long-distance identification, batch high-speed inventory of books",
        Solutiondec97: "Book leaving information monitoring, anti-theft",
        Solutiondec98: "Self-service operation, improving efficiency",
        Solutiondec99: "Due to mismatches in livestock health monitoring, regulatory tracking, and other technologies, breeding risks and claims risks are often triggered, which are the key factors hindering positive benefits for breeders and insurance institutions.",
        Solutiondec100: "Farmers have a weak risk awareness and low enthusiasm for insurance.",
        Solutiondec101: "Difficulty in moral hazard prevention, serious insurance fraud.",
        Solutiondec102: "Insurance business work is challenging, information verification is difficult.",
        Solutiondec103: "Claims procedures are cumbersome, and payouts are not timely.",
        Solutiondec104: "HIKBOREI provides a comprehensive solution combining big data platform, smart hardware, and RFID electronic ear tags (temperature-sensing ear tags) to meet the dual needs of breeder risk monitoring and insurance institution data governance operations.",
        Solutiondec105: "Tagging",
        Solutiondec106: "Inspection",
        Solutiondec107: "Claims",
        Solutiondec108: "Monitoring",
        Solutiondec109: "Breeder information upload/ear tag wearing/livestock data collection",
        Solutiondec110: "Livestock insurance data review/random risk area inspection",
        Solutiondec111: "Livestock authenticity verification/remote convenient claims",
        Solutiondec112: "Livestock body temperature monitoring, real-time feedback/risk warning",
        Solutiondec113: "Protect breeder interests",
        Solutiondec114: "Achieve positive benefits for insurance institutions",
        Solutiondec115: "Achieve health monitoring and disease prevention, reducing the operational risks of the farm.",
        Solutiondec116: "Achieve precise claims, simplify the claims process, and improve claims efficiency.",
        Solutiondec117: "RFID Ear Tag",
        Solutiondec118: "Portable Tag Reader",
        Solutiondec119: "RFID Inspection Camera",
        Solutiondec120: "Electronic Ear Tag/Temperature-Sensing Ear Tag",
        Solutiondec121: "Read the ear tag during tagging to ensure the correspondence between livestock and ear tag information",
        Solutiondec122: "Long-distance reading of ear tags to review insurance data",
        image1: require("./assets/img/guanli11.png"),
        image2: require("./assets/img/guanli22.png"),
        image3: require("./assets/img/guanli33.png"),
        image4: require("./assets/img/guanli44.png"),
        image5: require("./assets/img/guanli55.png"),
        image6: require("./assets/img/ers.png"),
        product1: "Enabling Visual and Intelligent Management",
        product2: "Long-range Batch Reading / Supports Fast Read/Write / Custom Sizes/Materials/Logos / Multi-scene Applications",
        product3: "Long-range Ear Tag Reading, for Verifying Insurance Data",
        product4: "Long-range Ear Tag Reading, for Verifying Insurance Data",
        product5: "Light Asset Cloud",
        product6: "One-stop Asset Management Solution, Making Asset Management Easier",
        product7: "Hikvision AgriCloud",
        product8: "Helping the Insurance Industry Conduct Livestock Insurance for Farmers, Achieving Accurate Underwriting and Claims Processing",
        product9: "Schedule a Demo",
        product10: "We are pleased to offer the following assistance to deepen your understanding of our product.",
        product11: "Hikvision's Agricultural and Livestock Cloud provides a comprehensive solution combining big data platform, smart hardware, and RFID ear tags, enabling the identification and tracking of insured livestock, meeting core needs for insurance data governance and operations, enhancing compliance in the livestock insurance industry, improving management efficiency, and reducing risk of claims.",
        product12: "Qingting Asset Cloud, centered around RFID (Radio Frequency Identification) technology, builds a new ecosystem for intelligent asset management. It offers comprehensive, real-time, and precise asset tracking and monitoring services, helping enterprises achieve rapid collection and efficient management of asset information. Through cloud-based intelligent analysis, it provides insights into asset dynamics, optimizes resource allocation, and aids enterprises in improving operational efficiency and decision-making capabilities.",
        product13: "Requirement Analysis",
        product14: "Solution",
        product15: "Quotation",
        product16: "Professional product advisors to deeply understand usage scenarios and needs",
        product17: "Customize the best software and hardware solutions based on requirements",
        product18: "Provide the optimal pricing solution based on product requirements.",
        adhesiveLabels: 'Adhesive Labels',
        flexibleMetalLabels: 'Flexible Anti-Metal Labels',
        antiMetalLabels: 'Anti-Metal Labels',
        washingLabels: 'Washing Labels',
        hangtags: 'Hangtags',
        animalEarTags: 'Animal Ear Tags',
        wristbands: 'Wristbands',
        chip: 'chip',
        frequency: 'frequency',
        material: 'material',
        weight: 'weight',
        size: 'size',
        operatingTemperature: 'operating Temperature',
        readingDistance: 'reading Distance',
        readingDistance2: '',
        installation: 'Installation',
        AntennaSize: 'Antenna Size',
        ProductSize: 'Product Size',
        Storage: 'Storage',
        ApplicationSurface: 'Application Surface',
        Color: 'Color',
        Tensilestrength: 'Tensile strength',
        Operatingtemperature: 'Operating temperature',
        advone1: 'Advantages',
        advone2: 'Features',
        advone3: 'Application Scenarios',
        advone4: '1. Convenient pasting, no additional tools required. 2. Waterproof and oil-resistant, remains clear and readable for a long time. 3. Can withstand high-temperature environments, does not deform or fall off.',
        advone5: '1. Excellent adhesion, firmly adheres to various material surfaces. 2. Smooth texture, clear and beautiful pattern and text printing. 3. Well-suited for various ink printing, facilitates easy label production. 4. Wide range of applications, widely used across various industries.',
        advone6: 'Food and beverage industry, medical industry, logistics and transportation, apparel industry, tire industry, etc.',
        advone7: '1. Can be installed and read on curved metal surfaces. 2. Supports multi-label group reading and identification. 3. Supports printing and issuing cards using RFID printers.',
        advone8: '1. Flexible, suitable for attaching to various shaped metal objects. 2. Good antimetal performance, unaffected by metal environments. 3. Long reading distance, good directionality, easy to identify. 4. Can be printed and customized.',
        advone9: 'Equipment management, cylinder tracking, traffic control, logistics management, dangerous goods management, etc.',
        advone10: '1. Truly achieves and exceeds an industrial wash life of over 200 cycles. 2. Materials and design have undergone reliability testing. 3. Nearly 100 million units have been shipped, earning recognition from numerous global customers.',
        advone11: '1. Passed MRI detection, can pass CT and metal detection tests. 2. Passed GB18401 testing, safe for skin. 3. Passed RoHS testing, free from toxic and carcinogenic substances. 4. Passed EU SVHC testing, free from toxic and carcinogenic substances. 5. Passed EU OEKO-TEX Std 100 testing, free from toxic substances. 6. Soft, does not damage textiles.',
        advone12: 'Hotel supplies management, work uniform management, hospital linen management, linen rental management, etc.',
        advone13: '1. Paper card production, suitable for item tags and hang tags. 2. Beautiful printing, easy to print text, patterns, and other content. 3. Aligns with the latest international standards, applicable to more industries and fields. 4. Supports international protocols, suitable for use in more countries.',
        advone14: '1. Can read multiple labels simultaneously, significantly improving the speed and accuracy of inventory management. 2. Long reading distance, no direct contact required, enabling rapid scanning of items. 3. Capable of storing product information for traceability, such as batch numbers, production dates, and supply chain information.',
        advone15: 'Production line manufacturing management, brand management, logistics and warehousing inventory, and store management, etc.',
        advone16: '1. Excellent performance in electronic ear tags, with a long service life. 2. Stable signal transmission, enabling more accurate identification. 3. Stable reading distance, unaffected by farming environments.',
        advone17: 'Livestock insurance, animal epidemic prevention, intelligent identification and inventory, intelligent weighing, record keeping for livestock sales, etc.',
        advone18: '1. Lightweight design, comfortable to wear. 2. Long read distance, fast recognition speed, and strong anti-interference capability.',
        advone19: 'Exhibitions, sports events, healthcare industry, etc.',
        advone20: '1. Stable and reliable tag performance. 2. Possesses a globally unique identification code (TID code). 3. Read distance can reach up to 10 meters plus.',
        advone21: '1. High read sensitivity, 100% pass read performance test. 2. Data retention time >50 years. 3. Supports customization of size and color.',
        advone22: 'Tool management, machinery equipment management, warehouse logistics management, production process traceability, etc.',
        productlistone: {
            items: [{
                id: 1,
                title: "UHF 42*16mm",
                image: require("./assets/img/one1.jpg"),
                chip: "NXPU9/Impinj MR6",
                AntennaSize: "42*16mm",
                ProductSize: "44*19mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "6.5m~9m",
            }, {
                id: 2,
                title: "UHF 70*14mm",
                image: require("./assets/img/one2.jpg"),
                chip: "NXPU9/Impinj M730 lmpinj M750",
                AntennaSize: "70*14mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "10m~16m",
            }, {
                id: 3,
                title: "UHF 30*50mm",
                image: require("./assets/img/one3.jpg"),
                chip: "NXPU9/lmpinjM730/Kiloway",
                AntennaSize: "30*50mm",
                ProductSize: "34*54mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "11.5m~16m",
            }, {
                id: 4,
                title: "UHF 95*3mm",
                image: require("./assets/img/one4.jpg"),
                chip: "NXPU9/Alien H10",
                AntennaSize: "95*3mm",
                ProductSize: "125*7mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~15m",
            }, {
                id: 5,
                title: "UHF 10*27mm",
                image: require("./assets/img/one5.jpg"),
                chip: "NXPU9",
                AntennaSize: "10*27mm",
                ProductSize: "30*14mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "3m~4.5m",
            }, {
                id: 6,
                title: "UHF 44*44MM",
                image: require("./assets/img/one6.jpg"),
                chip: "Impinj M4E",
                AntennaSize: "44*44mm",
                ProductSize: "50*50mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "3m~7m",
            }, {
                id: 7,
                title: "UHF 11*42mm",
                image: require("./assets/img/one7.jpg"),
                chip: "NXPU9",
                AntennaSize: "11*42mm",
                ProductSize: "11*42mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "2m~3.5m",
            }, {
                id: 8,
                title: "UHF 15*40mm",
                image: require("./assets/img/one8.jpg"),
                chip: "NXPU9/ImpinjMR6P",
                AntennaSize: "15*40mm",
                ProductSize: "44*19mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~9m",
            }, {
                id: 9,
                title: "UHF 70*17mm",
                image: require("./assets/img/one9.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*17mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "9m~12m",
            }, {
                id: 10,
                title: "UHF 70*15mm",
                image: require("./assets/img/one10.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*15mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "8m~17m",
            }, {
                id: 11,
                title: "UHF 19*93mm",
                image: require("./assets/img/one11.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "19*93mm",
                ProductSize: "97*25mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~12m",
            }, {
                id: 12,
                title: "UHF 8.15*94.8mm",
                image: require("./assets/img/one12.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "8.15*94.8mm",
                ProductSize: "100*15mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "10m~12m",
            }, {
                id: 13,
                title: "HF calibre 22mm",
                image: require("./assets/img/one13.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "calibre 22mm ",
                ProductSize: "calibre 25mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "30cm~50cm",
            }, {
                id: 14,
                title: "HF calibre15mm",
                image: require("./assets/img/one14.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "calibre 15mm",
                ProductSize: "calibre 18mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "5cm~15cm",
            }, {
                id: 15,
                title: "HF 76*45mm",
                image: require("./assets/img/one15.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "76*45mm",
                ProductSize: "86*54mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, {
                id: 16,
                title: "HF 45*45mm",
                image: require("./assets/img/one16.jpg"),
                chip: "ICODE-SLIX/F01N",
                AntennaSize: "45*45mm",
                ProductSize: "50*50mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, ]
        },
        productlisttwo: {
            items: [{
                id: 1,
                title: "60*25*1.25mm",
                image: require("./assets/img/two1.jpg"),
                chip: "NXP UCODE 8",
                frequency: "920-925MHz",
                Storage: "TID 96bits EPC 128bits",
                ApplicationSurface: "Metal Surface",
                size: "60*25*1.25mm",
                readingDistance: "Fixed: 650cm; Handheld: 500cm",
            }, {
                id: 2,
                title: "60x6x1.0mm",
                image: require("./assets/img/two2.jpg"),
                chip: "NXP UCODE 8",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "EPC128bits User 0bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "60x6x1.0mm",
                readingDistance: "Fixed: 200cm; Handheld: 130cm",
            }, {
                id: 3,
                title: "70x18x1.0mm",
                image: require("./assets/img/two3.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "EPC128bits User 0bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "70x18x1.0mm",
                readingDistance: "Fixed: 400cm; Handheld: 280cm",
            }, {
                id: 4,
                title: "98x42x1.0mm",
                image: require("./assets/img/two4.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "TlD128bits  User 64bits EPC 96bits",
                ApplicationSurface: "Metal Surface",
                size: "98x42x1.0mm",
                readingDistance: "Fixed: 600cm; Handheld: 600cm",
            }, {
                id: 5,
                title: "60*25*1.25mm",
                image: require("./assets/img/two5.jpg"),
                chip: "Qstar-73GB",
                frequency: "920-925MHz",
                Storage: "TlD128bits  User 512bits EPC 160bits",
                ApplicationSurface: "Metal Surface",
                size: "60*25*1.25mm",
                readingDistance: "Fixed: 520cm; Handheld: 400cm",
            }, {
                id: 6,
                title: "60x24x1.2mm",
                image: require("./assets/img/two6.jpg"),
                chip: "NXP U CODE 8",
                frequency: "US902-928MHz",
                Storage: "EPC 128 bits",
                ApplicationSurface: "Metal Surface",
                size: "60x24x1.2mm",
                readingDistance: "Fixed: 270cm; Handheld: 130cm",
            }, {
                id: 7,
                title: "45x8x1.0mm",
                image: require("./assets/img/two7.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHz；EU865-868MHz",
                Storage: "EPC 128bits  User 64bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "45x8x1.0mm",
                readingDistance: "Fixed: 150cm; Handheld: 100cm",
            }, {
                id: 8,
                title: "45x18x1.0mm",
                image: require("./assets/img/two8.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHz；EU865-868MHz",
                Storage: "TlD128bits User 64bits EPC 96bits",
                ApplicationSurface: "Metal Surface",
                size: "45x18x1.0mm",
                readingDistance: "Fixed: 250cm; Handheld: 140cm",
            }, ]
        },
        productlistthree: {
            items: [{
                id: 1,
                title: "6*3*T3.0",
                image: require("./assets/img/three1.jpg"),
                Size: "6*3*T3.0",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-928MHz 85cm  EU：865-868MHz 80cm ",
                Readingdistance2: "Handheld Reader US：902-928MHz 50cm  EU：865-868MHz 45cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 2,
                title: "10*4*T3.0",
                image: require("./assets/img/three2.jpg"),
                Size: "10*4*T3.0",
                Installation: "Backing or screws",
                Frequency: "US：902-925MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 135cm  EU：865-868MHz 135cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 90cm  EU：865-868MHz 75cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 3,
                title: "calibre 10*T3.7",
                image: require("./assets/img/three3.jpg"),
                Size: "calibre 10*T3.7",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 150cm  EU：865-868MHz 130cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 100cm  EU：865-868MHz 95cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 4,
                title: "12*4*T1.5",
                image: require("./assets/img/three4.jpg"),
                Size: "12*4*T1.5",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "NXP U8",
                Storage: "EPC 128bit  TID96bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 150cm  EU：865-868MHz 150cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 60cm  EU：865-868MHz 60cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.2g",
            }, {
                id: 5,
                title: "calibre 20*T2.8",
                image: require("./assets/img/three5.jpg"),
                Size: "calibre 20*T2.8",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 320cm  EU：865-868MHz 280cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 240cm  EU：865-868MHz 230cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "1.9g",
            }, {
                id: 6,
                title: "30*5*T2.8",
                image: require("./assets/img/three6.jpg"),
                Size: "30*5*T2.8",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 310cm  EU：865-868MHz 280cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 210cm  EU：865-868MHz 200cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.8g",
            }, {
                id: 7,
                title: "36*13*T3.5",
                image: require("./assets/img/three7.jpg"),
                Size: "36*13*T3.5",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 470cm  EU：865-868MHz 450cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 270cm  EU：865-868MHz 250cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "4.2g",
            }, {
                id: 8,
                title: "calibre40*T3.0",
                image: require("./assets/img/three8.jpg"),
                Size: "calibre40*T3.0",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "IMPINJ RG-P",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 680cm  EU：865-868MHz 650cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 350cm  EU：865-868MHz 350cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, {
                id: 9,
                title: "90*20*T3.7",
                image: require("./assets/img/three9.jpg"),
                Size: "90*20*T3.7",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 1080cm  EU：865-868MHz 1050cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 650cm  EU：865-868MHz 630cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, ]
        },
        productlistfour: {
            items: [{
                id: 1,
                title: "70*15*1.5mm",
                image: require("./assets/img/four1.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "70*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 2,
                title: "70*10*1.5mm",
                image: require("./assets/img/four2.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "70*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 3,
                title: "35*15*1.5mm",
                image: require("./assets/img/four3.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "35*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 4,
                title: "86*16*1.5mm",
                image: require("./assets/img/four4.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "86*16*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 5,
                title: "58*15*1.5mm",
                image: require("./assets/img/four5.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "58*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 6,
                title: "60*20*1.5mm",
                image: require("./assets/img/four6.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "60*20*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, ]
        },
        productlistfive: {
            items: [{
                id: 1,
                title: "39*83mm",
                image: require("./assets/img/five1.jpg"),
                chip: "Impinj WEB M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "7m~15m",
            }, {
                id: 2,
                title: "114*49mm",
                image: require("./assets/img/five2.jpg"),
                chip: "KX2005X-S",
                frequency: "860~960MHz",
                Storage: "EPC 160 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "4m~12m",
            }, {
                id: 3,
                title: "44.45*69.85mm",
                image: require("./assets/img/five3.jpg"),
                chip: "Impinj M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TlD 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, {
                id: 4,
                title: "39*83mm",
                image: require("./assets/img/five4.jpg"),
                chip: "Alien H10",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 48 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "9m~12m",
            }, {
                id: 5,
                title: "114*49mm",
                image: require("./assets/img/five5.jpg"),
                chip: "AD-23xu9",
                frequency: "860~960MHz",
                Storage: "EPC 96 Bits TiD 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "7m~15m",
            }, {
                id: 6,
                title: "44.45*69.85mm",
                image: require("./assets/img/five6.jpg"),
                chip: "Impinj MR6P",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, ]
        },
        productlistsix: {
            items: [{
                id: 1,
                title: "UHF RFID pig ear tag",
                image: require("./assets/img/six1.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф32*13.5mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: "≥450N",
                Operatingtemperature: "-25℃~+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, {
                id: 2,
                title: "UHF RFID cattle ear tag",
                image: require("./assets/img/six2.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф56*45mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, {
                id: 3,
                title: "39*83mm",
                image: require("./assets/img/six3.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф45*17mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, ]
        },
        productlistsenven: {
            items: [{
                    id: 1,
                    title: "Recyclable silicone wristband",
                    image: require("./assets/img/wan1.jpg"),
                    chip: "Alien H3/9640",
                    frequency: "902MHZ-928MHZ ",
                    material: "Silicone",
                    weight: "17g",
                    size: "257.5*20.2*9mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "1~1.5m(handset reader)",
                },
                {
                    id: 2,
                    title: "Recyclable silicone wristband",
                    image: require("./assets/img/wan2.jpg"),
                    chip: "NXP U8",
                    frequency: "902MHz-928MHz",
                    material: "Silicone",
                    weight: "16g",
                    size: "248*32*6mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2m",
                }, {
                    id: 3,
                    title: " Disposable silicone wristbands",
                    image: require("./assets/img/wan3.jpg"),
                    chip: "Impinj",
                    frequency: "840～960MHZ  ",
                    material: "Silicone",
                    weight: "19 g",
                    size: "260*20*10mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2.6m (30db handset reader)",
                }, {
                    id: 4,
                    title: "UHF disposable silicone + fabric tape wristbands",
                    image: require("./assets/img/wan4.jpg"),
                    chip: "NXP U8",
                    frequency: "840～960MHz",
                    material: "Silicone + Fabric tape",
                    weight: "25 g",
                    size: "Tray: 50*40*10mm; Fabric tape：350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30db handset reader) ",
                }, {
                    id: 5,
                    title: "UHF disposable plastic tray + fabric tape wristbands",
                    image: require("./assets/img/wan5.jpg"),
                    chip: "NXP U8",
                    frequency: "840MHz～960MHz",
                    material: "Plastic tray + fabric tape",
                    weight: "27g",
                    size: "Plastic tray: 55*50*10mm; Fabric tape:350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30db handset reader)",
                },
            ]
        },
        newsdetailone: {
            title: 'Recently, the Xuzhou Industry and Information Technology Bureau announced the list of enterprises拟认定名单 for the second batch of 2024 provincial three and four-star cloud enterprises. After online applications, initial reviews, expert evaluations, on-site inspections, and credit checks, Jiangsu HIKBOREI Electronics Co., Ltd. successfully made it to the list of provincial four-star cloud enterprises.',
            highlight: 'Notably, HIKBOREI is the only company in Gulou District, Xuzhou City, that has been recognized as a four-star cloud enterprise in 2024!',
            description: 'A four-star cloud enterprise refers to a company that has achieved digital transformation in its management and operations by using internet technology to enable information exchange and data sharing between systems and devices, and leveraging cloud computing resources. This is a direct reflection of the company\'s innovation capabilities, operational management capabilities, and business capabilities.',
        },
        newsdetailtwo: {
            date: 'November 1st',
            title: 'Hikuborui Welcomes Its Glorious Moment',
            milestone: 'Global Cumulative Shipment of RFID Tags Exceeds 100 Million in 2024',
            milestoneDescription: 'This significant milestone marks Hikuborui as a leading provider of RFID and IoT technology solutions, further winning global market recognition with its innovative cutting-edge technology and superior product performance.',
            newAchievement: '100 Million New Milestones New Starting Point',
            achievementDescription: 'Hikuborui\'s General Manager Liu Jinpeng stated that the company\'s achievement is the result of the market, customers, and employees working together. Hikuborui has been committed to promoting the development of IoT and RFID technology. There is still a lot of growth potential for RFID chips in the future. The company will continue to strengthen product layout, build a diverse product portfolio, and continuously create strong product growth poles. Behind the market recognition is Hikuborui\'s long-term dedication to "chip" expertise.',
            technologyInnovation: 'The company has always focused on building differentiated market competitiveness through technological innovation. In recent years, the company has continuously increased R&D investment and completed core technology accumulation in the fields of IoT and RFID product development and software development, possessing mature independent R&D capabilities.',
            industryExperience: 'Currently, Hikuborui, with its accumulated strength, possesses mature RFID industry application solution research and development experience, a professional RFID tag design and R&D talent team, a leading RFID tag production manufacturing base, and a comprehensive RFID module and reader product system, forming a complete industrial chain integrating R&D, production, and sales.',
            customerRecognition: 'With its excellent technical strength and product performance, Hikuborui\'s independently developed RFID tag products and customized IoT solutions can promptly respond to the needs of domestic and international customers, gaining recognition from global customers and widely applied in retail, logistics, livestock, medical, and other fields.',
            futureVision: 'Hikuborui will continue to move forward with a forward-looking vision, focusing on IoT and RFID technology, and actively laying out the future.',
        },
        newsdetailthree: {
            title: 'Letter of Thanks from Saudi Arabian Client',
            subTitle: 'Original Text as follows:',
            greeting: 'Dear Haikangborui Team,',
            content1: 'I am writing this email with endless gratitude to express my heartfelt thanks for the warm hospitality and care you provided during my stay in China.',
            content2: 'In our collaboration, I deeply felt your enthusiasm and professionalism. Every team member I interacted with demonstrated extraordinary friendliness and dedication, making me feel at home. You not only provided me with a comfortable work environment and efficient support but also allowed me to experience the unique culture and customs of China, deepening my understanding and appreciation for this beautiful land.',
            content3: 'I sincerely thank your company for all the help and support provided. The warm hospitality of your team made me feel at home in a foreign country, allowing me to experience more human warmth and care during my spare time. I will always cherish the friendship and cooperation established with your company and hope that we can continue to work together to create a brighter future.',
            content4: 'Once again, I extend my sincere thanks and high regards to all the staff of your company. I hope our friendship can last forever and our business cooperation can prosper!',
            closing: 'Thank you! ',
            closing2: ' Sincerely',
        },
        newsdetailfour: {
            title: 'October 16: “Technology for Farmers” Forum on Livestock Breeding Held',
            content1: 'On October 16, a forum on “Prevention, Protection, and Technology for Farmers” was held for livestock breeding in the city. Zhou Wei, Deputy Director and Party Secretary of the Municipal Agricultural and Rural Affairs Bureau, attended the meeting and delivered a speech. Leaders from the Agricultural and Rural Affairs Bureaus of various counties and districts, heads of epidemic prevention stations, and representatives from insurance companies participated in the meeting. The forum aimed to build a communication platform to promote the integration of “livestock insurance + technology service support”. HIKBOREI was invited to attend the meeting and share their practical achievements in technology-driven agricultural assistance.',
            content2: 'Qi Jun, Director of RFID Technology at HIKBOREI, gave a presentation titled “Haikang Technology Assistance for Farmers”. Drawing on extensive industry experience and the latest research results, he elaborated on the unique advantages and effectiveness evaluation of Haikang’s one-stop assistance solution for livestock breeding, particularly in the field of livestock insurance. His presentation provided new ideas and inspiration for improving livestock breeding prevention work and the insurance protection system.',
            content3: 'During the exchange session, representatives from insurance companies pointed out that the main pain points in the current livestock insurance industry are concentrated in process supervision and insurance claims. Haikang’s Assisting Agriculture and Animal Husbandry Cloud Solution, with its comprehensive product model of big data platforms + intelligent hardware + RFID chips, deeply integrates technology with industry application scenarios to meet the core needs of insurance data governance and operations. It helps insurance companies achieve quick and precise claims settlement, significantly enhancing the compliance of agricultural insurance in the breeding industry and controlling operational risks.',
            content4: 'In the product display area, the rich ear tag products attracted widespread attention from attendees. Staff members demonstrated the operation and usage of intelligent tagging pliers, readers, and other intelligent equipment hardware on-site. The products were well-received and praised for their simple and user-friendly features.',
            content5: 'In his concluding remarks, Director Zhou Wei provided a detailed interpretation of the purpose and significance of conducting prevention and insurance linkage in the livestock insurance industry. He emphasized the need for cooperation among various stakeholders, reaching a consensus, and valuing the crucial role of “insurance + technology” in the development of animal husbandry. By strengthening the linkage between technological means and insurance, the benign development of the industry can be achieved.',
            content6: 'Decoding industry trends and exploring breakthrough paths, this conference not only showcased HIKBOREI’s strong technical capabilities and solution-providing abilities but also further enhanced the company’s brand influence in the industry, laying a solid foundation for future business expansion. In the future, we will continue to actively explore and practice in the areas of prevention and insurance linkage and science and technology assisting agriculture, contributing more wisdom and strength to the development of the industry.',
        },
        newsdetailfive: {
            "intro1": "The application of RFID electronic tags makes production line management more intelligent, significantly improving work efficiency and accuracy while reducing production costs and labor input.",
            "intro2": "RFID electronic tags are small in size, lightweight, and easy to carry, suitable for various types of products. These tags can be conveniently attached to the surface of items or embedded within products, providing each item with a unique identification code for precise tracking and management. This technology not only optimizes the production line operation process but also enhances product quality and customer satisfaction.",
            "application": "Applications of Electronic Tags in Production Line Management",
            "tracking": "1. Item Tracking and Management",
            "tracking_desc": "Through RFID electronic tags, real-time tracking and management of items can be achieved. Throughout the production process, information about items, including entry and exit times, current location, etc., can be obtained via RFID readers. By tracking items, the transparency and controllability of the production line can be enhanced, facilitating effective management of materials and process states.",
            "automation": "2. Automation in Production Control",
            "automation_desc": "RFID electronic tags connected to production equipment can enable automated production control. By reading the information from RFID electronic tags, production equipment can automatically adjust relevant parameters to achieve personalized production and customized services. Additionally, RFID tags can record equipment operation status and maintenance information, facilitating equipment inspection and maintenance.",
            "quality": "3. Quality Traceability and Tracing",
            "quality_desc": "RFID electronic tags can record the production process and environment of items, enabling quality traceability and tracing. In production line management, information such as production batch, supplier details, and quality inspection results can be obtained through RFID electronic tags. In case of quality issues, the root cause can be quickly identified, and appropriate corrective measures can be taken to improve product quality and supply chain management.",
            "advantages": "Advantages of RFID Electronic Tags in Intelligent Production Line Management",
            "efficiency": "1. Improve Production Efficiency",
            "efficiency_desc": "With RFID electronic tags, the production process can be automated and digitized. Items on the production line can be automatically scanned and identified, reducing manual operation time and error rates. The production process is monitored and tracked in real time, allowing for timely issue detection and adjustment, thereby improving production efficiency and capacity.",
            "cost": "2. Reduce Costs and Save Resources",
            "cost_desc": "Using RFID electronic tags can reduce labor input and material waste, lowering costs and energy consumption. Traditional production line management requires extensive manual operations and material handling, whereas RFID tags enable automated and intelligent management, reducing unnecessary labor and resource consumption.",
            "product_quality": "3. Enhance Product Quality and Safety",
            "product_quality_desc": "Through the traceability function of RFID electronic tags, raw material tracing and quality control can be achieved. During the production process, key parameters such as material quality and temperature can be monitored in real time, allowing for the timely detection of anomalies and corrective actions. Additionally, through traceability, specific production stages can be traced, enhancing product quality and safety.",
            "supply_chain": "4. Optimize Supply Chain Management",
            "supply_chain_desc": "RFID electronic tags enable end-to-end visibility and dynamic management of the supply chain. Through RFID electronic tags, real-time positions and statuses of items in the supply chain, including supplier information, inventory status, and transportation progress, can be obtained. Based on this information, supply chain delivery plans, inventory management, and production scheduling can be optimized, enhancing the flexibility and responsiveness of the supply chain.",
            "conclusion": "RFID electronic tags play a crucial role in the intelligent management of production lines, bringing significant economic benefits and competitive advantages to enterprises. With continuous technological advancements and expanding application areas, the potential of RFID electronic tags in production line management will further emerge, driving production line management towards higher levels of intelligence and automation, offering enterprises greater development opportunities and potential."
        },
        newsdetailsix: {
            development_reform_innovation: '"Development, Reform, Innovation" are eternal themes in the growth of enterprises.',
            many_enterprises_introduce_rfid: 'Many medium and large enterprises have introduced RFID smart warehouse management systems, gradually moving towards automation, informatization, and intelligence, helping enterprises achieve transformation and upgrading.',
            what_problems_can_rfid_solve: 'So, what problems can RFID smart warehousing help enterprises solve?',
            use_rfid_to_improve_efficiency: 'Utilizing the fast identification feature of RFID technology in inbound, outbound, and inventory processes, it improves the efficiency of core warehouse operations and significantly saves labor costs.',
            lean_management: '2. Lean Management',
            improve_management_accuracy: 'Improve business management, avoid manual data collection errors, enhance the accuracy of business processing and management, meeting the needs of lean enterprise management.',
            cost_saving: '3. Cost Saving',
            improve_resource_utilization: 'Improve resource utilization, reduce operational complexity, and enhance response speed to customers, thereby reducing overall operational costs.',
            build_new_rfid_system: 'Using RFID radio frequency identification technology, a new warehouse management information system platform is built, coordinating the operations of various links, ensuring timely and accurate inbound and outbound operations and real-time transparent inventory control, saving labor and inventory space, reducing operational costs, thereby enhancing the market competitiveness of enterprises.',
            system_composition: 'System Composition:',
            advantages_of_rfid_in_practice: 'Advantages of RFID Smart Warehousing in Practical Applications:',
            low_cost_high_efficiency: '1. Low-cost, high-efficiency information collection in various inbound and outbound processes',
            inventory_data_collection: '(1) Inbound Data Collection: Given the uniqueness of RFID tags and the group reading function of RFID devices, inbound data collection becomes more accurate and efficient, and the simplified operation process can reduce labor costs.',
            warehouse_inventory_data: '(2) Warehouse Inventory Data: Bulk inventory scanning products, collecting and verifying data to ensure data accuracy again.',
            outbound_data_collection: '(3) Outbound Data Collection: Packaged and verified product outbound, RFID devices only need to be invested once and can be used in multiple warehouse links, greatly increasing equipment utilization.',
            precise_location_management: '2. Precise location management in the warehouse, comprehensive state monitoring',
            control_product_information: 'Each product is attached with a unique RFID tag, through RFID labels for warehouse inventory, not only comprehensively control product information but also precisely locate product positions, fully utilize the limited warehouse space, and enhance warehouse utilization efficiency.',
            warehouse_management_flowchart: 'Warehouse Management Flowchart',
            rfid_system_applications: 'Applications of RFID Smart Warehouse Management System:',
            ensure_data_input_speed: 'Smart warehousing is a link in the logistics process. The application of RFID smart warehousing ensures the speed and accuracy of data input in various links of warehouse management, ensuring that enterprises can timely and accurately grasp the real inventory data, reasonably maintain and control enterprise inventory.'
        },
        newsdetailseven: {
            title1: 'The widespread application of RFID technology in the retail industry is driving the transformation of the retail sector towards intelligent, efficient, and refined management. It provides a highly efficient way to track the dynamics of goods in the supply chain system, enabling true automated management of items.',
            title2: 'In addition, RFID offers the retail industry advanced and convenient data collection methods, convenient customer transactions, efficient operational methods, and quick, insightful decision-making tools that barcode technology cannot match.',
            title3: 'The main applications of RFID tags in supermarket retail include:',
            item1: '1. Inventory Management: In the supermarket retail industry, RFID technology is primarily used to improve the efficiency and accuracy of inventory management. By attaching RFID tags to items, RFID readers can quickly and non-contactly identify item information, enabling rapid inventory counting and real-time updates. This significantly reduces the time and error rate of traditional manual inventory counts, improving inventory management efficiency.',
            item2: '2. Theft Prevention: RFID technology can also be used for theft prevention in supermarket retail. By attaching RFID tags to items, the RFID anti-theft system can automatically detect and alarm when items are illegally removed from the supermarket, effectively preventing theft.',
            item3: '3. Sales Management: RFID technology can be used for sales management in supermarket retail. During the sales process, RFID readers can obtain real-time sales information, including sales quantities and times, helping supermarkets better understand sales conditions and develop more reasonable sales strategies.',
            item4: '4. Customer Experience: RFID technology can also enhance the customer shopping experience. For example, by setting up self-checkout systems in supermarkets, customers can scan RFID tags on items themselves for checkout without waiting for manual checkout, improving checkout efficiency. Additionally, through RFID technology, unmanned convenience stores and other new retail models can be implemented, providing customers with a more convenient shopping experience.',
            conclusion: 'The widespread application of RFID tags in the retail industry is bringing about a transformative change, not only improving the operational efficiency and accuracy of supermarkets but also enhancing the customer shopping experience. With the continuous innovation and popularization of technology, the application of RFID in supermarket retail will become even more extensive and in-depth.',
        },
        newsdetaileight: {
            newsTitle: 'RFID Self-adhesive Labels',
            newsContent1: 'RFID self-adhesive labels offer fast identification speed, convenient and quick reading, large chip capacity, rewritable chip data, long service life, and high security, playing a significant role in many industries.',
            newsContent2: 'RFID self-adhesive labels are passive electronic tags consisting of backing paper, face paper, adhesive layer, and RFID Inlay. They can encapsulate different RFID chips and antennas, are soft, thin, easy to apply, and offer high cost-effectiveness.',
            newsContent3: 'RFID self-adhesive labels are made of materials like synthetic paper, PET, and PVC, offering good adhesion and wear resistance at a low cost. They can be printed with product information such as name, model, and production date on the tag surface.',
            newsContent4: 'The surface substrate of the adhesive material has many advantages, such as easy to tear off, strong adhesion, flexible use, heat and moisture resistance, non-aging, and non-polluting, making it suitable for various environments and usage scenarios.',
            newsSubtitle: 'Applications and Advantages of RFID Self-adhesive Labels',
            newsContent5: '1. Archive/Library Management: Applying RFID self-adhesive labels to archives and books allows for easy reception of book information, location, borrowing, and return registration, improving work efficiency and avoiding errors.',
            newsContent6: '2. Anti-counterfeiting and Traceability: Each product has a unique RFID electronic tag recording all information from the source manufacturer to the sales terminal, generating detailed records through scanning.',
            newsContent7: '3. Production Line Management: RFID self-adhesive labels can conveniently and accurately record process and operation information on production lines, meeting flexible production needs. The records of worker ID, time, operation, and quality inspection results fully achieve production traceability and avoid errors caused by handwritten or visual information in production environments.',
            newsContent8: '4. Warehouse Management: RFID self-adhesive labels effectively manage warehouse inventory information, allowing real-time understanding of cargo location and storage conditions, significantly improving warehouse efficiency and guiding production.',
            newsContent9: '5. Retail Store Management: RFID self-adhesive labels support repeated overwriting. Unlike fixed-price paper labels, RFID labels can quickly handle changing product prices without the need to destroy the label, directly reading and rewriting changes using a reader. This eliminates the need for repeated label costs and reduces manual labor for label replacement, improving work efficiency. Even if the product information on the label surface is blurred or damaged, as long as the chip is intact, it can still be correctly read and written, avoiding shopping disputes caused by work oversights and enhancing shopping experiences.',
            newsContent10: 'RFID self-adhesive labels, as a convenient printing material, are playing an increasingly important role in economic and social life. With the continuous expansion of the market and technological progress, the market outlook for RFID self-adhesive labels is very promising, with more innovative applications expected to emerge.',
        },
        newsdetailnine: {
            newsTitle: 'Witnessing Strength! HIKBOREI Recognized as a Provincial "Specialized, Refined, and Innovative Enterprise"',
            newsContent1: 'Recently, the Jiangsu Provincial Department of Industry and Information Technology announced the list of recognized provincial specialized, refined, and innovative enterprises for the year 2024, and HIKBOREI, with its excellent innovative capabilities and professional technical strength, made the list!',
            newsContent2: 'The "Specialized, Refined, Innovative, and Novel" small and medium-sized enterprises are characterized by their specialization, refinement, uniqueness, and novelty. They are model enterprises with a high market share, excellent quality and efficiency, and leaders in continuous innovation and mastery of key core technologies.',
            newsSubtitle1: 'HIKBOREI’s "Specialized, Refined, Innovative, and Novel" Qualifications',
            newsSubtitle2: 'Deep Specialization',
            newsContent3: 'Since its establishment, HIKBOREI has continuously deepened its expertise in the Internet of Things (IoT) RFID field, possessing a complete industrial chain integrating research and development, production, and sales. With its outstanding technical strength, it has been honored with multiple scientific and technological certifications such as "National High-Tech Enterprise", "Provincial Technological SMEs", and "Provincial Four-Star Cloud Enterprise".',
            newsSubtitle3: 'Refined Services',
            newsContent4: 'HIKBOREI focuses on the design and development of IoT RFID tags, RFID modules and readers, RFID chips, and RFID industry integration software. It quickly responds to global customer needs, providing products and solutions to over 30 countries and regions worldwide.',
            newsSubtitle4: 'Unique Solutions',
            newsContent5: 'As a leading provider of RFID and IoT technology solutions, HIKBOREI continuously offers customized, high-value solutions and products based on RFID technology to various industries, guided by market demands and technological frontiers.',
            newsSubtitle5: 'Innovative Leadership',
            newsContent6: 'HIKBOREI remains committed to innovation leadership, possessing mature independent R&D capabilities and a research team with both deep industry expertise and forward-looking vision. It has accumulated core technical expertise in product R&D and software development in the IoT RFID field, leading the market through professional innovation.',
            newsContent7: 'In the future, HIKBOREI will continue to focus on the research and innovative applications of IoT RFID technology, enhancing its core competitiveness to provide even higher-value products and services to more customers.',
        },
        newsdetailten: {
            newsTitle: "Exploring New Opportunities in Overseas Markets and Seeking Win-Win Development —— HIKBOREI's Saudi Arabia Visit",
            newsContent1: "Deeply engaging with overseas clients and proactively developing international markets. Recently, Liu Jinping, General Manager of Jiangsu HIKBOREI Electronics Co., Ltd., led a team on a visit to Saudi Arabia, achieving significant results, which laid a solid foundation for HIKBOREI's accelerated expansion in overseas markets.",
            newsContent2: "In the context of the rapid development of the digital economy, the IoT RFID industry in the Middle East, including Saudi Arabia, is showing strong growth potential. Saudi Arabia's ' Vision 2030 'emphasizes the ' National Transformation Program,' supporting digital entrepreneurship and investment in digital technologies. As an important component, IoT technology holds great market potential and development prospects.",
            newsContent3: "As a professional team deeply rooted in the IoT RFID field, HIKBOREI is actively advancing its overseas market layout. Leveraging its rich industry experience and strong technical advantages, the company has gained significant favor in the Saudi market. This two-week visit to Saudi Arabia was intensive and efficient, focusing on key nodes and core projects, yielding significant results.",
            newsContent4: "During the visit, the HIKBOREI team met with renowned local network service providers, RFID solution consulting companies, and RFID manufacturing service providers. They engaged in in-depth discussions on current RFID market trends, technological innovations, and product demands. The team comprehensively showcased the comprehensiveness and leadership of HIKBOREI's products and services, further enhancing client trust and understanding. The visit yielded rich market insights and cooperation opportunities, with agreements reached on multiple RFID projects.",
            newsContent5: "This trip to Saudi Arabia not only deepened the team's understanding of the local market and industry, reinforcing HIKBOREI's confidence in its continued overseas business expansion, but also demonstrated our proactive stance in exploring international markets and seeking new opportunities for international development.",
        },
        newsdetaileleven: {
            "newsTitle": "Embrace the New Year, Embark on New Chapters, Win the Battle of 2025 | HIKBOREI 2025 New Year Conference Successfully Held",
            "newsContent1": "The old year has been adorned with a thousand layers of brocade, and the new year will reach new heights. On January 26, all employees of HIKBOREI gathered together to solemnly hold the 2025 New Year Conference! This is not only a significant moment for looking back on the past and envisioning the future, but also a crucial point for boosting morale and gathering strength.",
            "newsContent2": "Day and night are the two legs of time, recording the steps HIKBOREI has taken. At the beginning of the conference, all employees jointly reviewed the development history of HIKBOREI. These precious memories not only document the company's growth path but also serve as a powerful testament to the collective efforts and continuous breakthroughs of all employees.",
            "newsContent3": "Subsequently, Vice President Zhang Xia, Sales Director Song Chi, Production Plant Manager Liang Lei, and Technology Director Qi Jun of Jiangsu HIKBOREI Electronics Co., Ltd. shared the achievements and shortcomings of HIKBOREI in R&D, production, and operation, and outlined the goals for 2025.",
            "newsContent4": "Vice President Zhang stated that the achievements of HIKBOREI today are inseparable from the unity of thought, synergy in work, and consistency in action among everyone. He also called for all employees to set firm goals in the new year, address deficiencies, strive for excellence, and work together to achieve even more remarkable success.",
            "newsContent5": "By strengthening role models, we can gather the power to forge ahead. During the sharing session, outstanding employee representatives sincerely shared their growth journeys and work insights at HIKBOREI, inspiring every employee present to strive hard and pursue excellence in the new year.",
            "newsContent6": "The award ceremony for outstanding employees raised the atmosphere to a climax, with everyone taking turns to receive their awards. The company's sincere gratitude was shown for everyone's hard work, with certificates and trophies being a high recognition of their efforts and contributions. These outstanding employees come from different departments and positions, and with their excellent work performance, strong sense of responsibility, and dedicated spirit, they have become role models for all employees to emulate.",
            "newsContent7": "Following the ceremony, General Manager Liu Jinpeng of Jiangsu HIKBOREI Electronics Co., Ltd. gave a summary speech. He reviewed and summarized the company's development in recent years, stating that despite the severe industry trends, the company has still achieved remarkable growth, which is inseparable from the hard work and outstanding contributions of all employees.",
            "newsContent8": "We are full of confidence in the future and have the ability and strength to achieve even greater success in the future. At the same time, General Manager Liu sent his New Year greetings and hoped that everyone would bring a more enthusiastic and spirited attitude to their work in the new year, working together for new development goals.",
            "newsContent9": "The successful hosting of this conference not only strengthened the cohesion and centripetal force within the company but also made every employee clearly aware of the direction HIKBOREI is heading in 2025. We believe that under the correct leadership of the company's management and the joint efforts of all employees, HIKBOREI will surely write a more glorious chapter in the new year."
        },
        "newsdetailtwelve": {
            "newsTitle": "Gulou District Leaders Visit HIKBOREI | Delivering Policies and Solving Challenges to Empower Innovation",
            "newsContent1": "On May 7th, Luo Deqing, Secretary of the Gulou District Party Committee, Cheng Feng, Deputy Secretary, and Liu Yi, Standing Deputy District Chief, led a delegation to visit Jiangsu HIKBOREI Electronics Co., Ltd. They gained firsthand insights into the company's development, listened to feedback, and discussed solutions to challenges. General Manager Liu Jinpeng accompanied the delegation and reported on the company's progress.",
            "newsContent2": "Roundtable Discussion: Addressing Challenges for Growth",
            "newsContent3": "In the meeting room, district leaders engaged in in-depth discussions with General Manager Liu Jinpeng. Secretary Luo Deqing inquired about the company's operations, R&D progress, and market expansion, with a focus on supply chain stability, talent recruitment, and policy implementation. Liu Jinpeng introduced HIKBOREI's core technologies and strategic plans while candidly raising challenges such as land expansion needs and specialized policy support.",
            "newsContent4": "On-Site Inspection: Demonstrating Care at the Frontline",
            "newsContent5": "After the meeting, the delegation toured the open-plan office. The glass walls reflected the company's red vision statement—'Technology Empowers Urban Life'—under natural light. Engineers typed attentively, their keyboard clicks blending with the hum of data center equipment into a 'symphony of technology.'",
            "newsContent6": "General Manager Liu Jinpeng expressed gratitude for the leaders' visit, stating it boosted morale and confidence. He pledged increased R&D investment to enhance competitiveness and contribute more to Gulou's digital economy."
        },
        "newsdetail13": {
            "newsTitle": "Sino-Saudi Business Exchange | Saudi Clients Visit HIKBOREI to Strengthen Global Collaboration",
            "newsContent1": "On May 15th, Saudi client representatives visited HIKBOREI and its production base. General Manager Liu Jinpeng and senior executives warmly welcomed them, engaging in discussions to deepen cooperation.",
            "newsContent2": "The clients toured the production workshop, R&D center, and product exhibition area, gaining insights into smart manufacturing, quality control, and RFID chip innovations. They highly praised the technological advancements. During talks, both sides explored strategic collaboration models, with the clients expressing eagerness to expand partnerships. This exchange laid the groundwork for international market expansion."
        },
        "newsdetail14": {
            "newsTitle": "Tech-Driven Innovation | Government, Enterprise, and Academia Visit HIKBOREI",
            "newsContent1": "On May 20th, Rui Guoqiang, Party Secretary of Jiangsu Normal University, along with directors Zhao Yusu, Gu Zhenzhong, Wu Di, and Han Hongzheng, visited HIKBOREI with district leaders. General Manager Liu Jinpeng provided a detailed introduction to the company's development.",
            "newsContent2": "In the exhibition hall, Liu Jinpeng showcased HIKBOREI's milestones, core technologies, and industry applications via displays and multimedia. The group then observed the smart production line's efficiency. District leaders highlighted HIKBOREI's role in regional innovation, sparking in-depth discussions on R&D and management, with unanimous praise for the company's achievements.",
            "newsContent3": "This event, facilitated by district leaders, bridged academia and industry. It deepened Jiangsu Normal University's understanding of HIKBOREI and laid the foundation for future university-enterprise collaboration. All parties agreed to leverage this visit to strengthen cooperation and fuel regional economic growth with technological innovation."
        },
        "newsdetail15": {
            "newsContent1": "On May 23, leaders of Xuzhou Municipal People's Congress Work Theory Research Association, including Zhang Funing, Feng Qipu, Yuan Jianfen, Zhou Jianhong, and Wang Lifeng, led all council members and associates to visit HIKBOREI, accompanied by district leaders.",
            "newsContent2": "Liu Jinpeng, General Manager of HIKBOREI, warmly received the delegation and guided them through the corporate exhibition hall and production workshop. In the exhibition hall, Liu detailed the company's development history, core technologies, and industry innovations, with special emphasis on the innovative application of its self-developed temperature-sensing chips in medical fields. He stated that these chips utilize high-precision temperature sensing technology to enable real-time, accurate body temperature monitoring, currently applied in smart medical devices that play vital roles in chronic disease management and post-operative rehabilitation monitoring, significantly enhancing the intelligence level of medical services.",
            "newsContent3": "Entering the production workshop, modern equipment, rigorous processes, and efficient management systems came into view. Liu provided detailed explanations about production scale, quality control, and capacity, allowing visitors to directly experience HIKBOREI's core strengths and innovative vitality.",
            "newsContent4": "This visit provided an excellent opportunity for the research association delegation to gain deeper understanding of HIKBOREI and enhanced mutual communication. HIKBOREI's active exploration in technological innovation and industrial development, especially the practical application of temperature-sensing chips in medical fields, received recognition and praise from the visitors."
        },
        "newsdetail16": {
            "newsContent1": "On June 20th, an inspection team composed of members from the Jining Taihu Lake New District Party Working Committee, Management Committee, New District Financial Bureau, and New District Investment Promotion Department visited Jiangsu Haikan Borui for an on-site investigation. The focus was on the company's technological innovation in RF technology, leading RFID solutions, and intelligent industrial applications. General Manager Liu Jinpeng accompanied the delegation throughout the visit, and both sides engaged in in-depth discussions on deepening industrial cooperation and promoting project implementation.",
            "newsContent2": "Inspecting Smart Manufacturing Lines, Focusing on Core Technological Breakthroughs",
            "newsContent3": "During the visit to the smart exhibition hall, General Manager Liu Jinpeng showcased the company's innovative breakthroughs in intelligent sensing and smart terminal R&D through a 'Trinity' display system, including digital panels, product prototype matrices, and immersive holographic projections. The presentation comprehensively demonstrated the core patented technology matrix and industrial application ecosystem (covering industries such as smart healthcare, cold-chain logistics, retail traceability, industrial internet, and ecological livestock farming).",
            "newsContent4": "Subsequently, the delegation moved to Haikan Borui's production workshop to observe the company's intelligent production lines. At the SMT assembly section, the officials gained a detailed understanding of the fully automated production process and experienced real-time monitoring and optimization of production operations.",
            "newsContent5": "Accelerating Focus on Industrial Layout, Collaboratively Drawing a Development Blueprint",
            "newsContent6": "This inspection and exchange laid a solid foundation for deeper cooperation between the two parties. Both sides reached a consensus on a collaborative development model, marking an important step in Haikan Borui's national strategic expansion. In the future, the two parties will continue to strengthen communication and coordination to ensure the prompt and effective implementation of cooperative projects."
        },
        newsdetail17: {
            newsContent1: 'In recent years, RFID (Radio Frequency Identification) technology has evolved from an early logistics tracking tool to widespread adoption in retail, healthcare, manufacturing, smart cities, and other fields. According to market research firm IDTechEx, the global RFID market is projected to exceed $40 billion by 2032, with a compound annual growth rate (CAGR) of over 10%. So why will RFID tags experience explosive growth in the future?',
            newsContent2: '1. Retail Industry Smart Upgrade: Moving Beyond Traditional Barcodes to the "Cashier-less Retail" Era',
            newsContent3: 'Traditional barcodes require individual scanning, while RFID tags enable batch reading, significantly improving inventory counting speed. For example, after adopting RFID, Walmart increased inventory accuracy to 98% and reduced out-of-stock rates by 16%. Amazon Go and Alibaba\'s "Tao Cafe" cashier-less stores rely on RFID+AI vision technology to enable "grab-and-go" payments. Luxury brands (like LV and Gucci) use RFID anti-counterfeiting tags, allowing consumers to verify authenticity via smartphone NFC. The food industry (such as fresh produce and wine) also uses RFID for full traceability, enhancing brand trust. In the future, RFID tags will combine with dynamic pricing and smart shelves to create smoother shopping experiences.',
            newsContent4: '2. Industry 4.0 and Smart Manufacturing: RFID as a Key Component of "Digital Twins"',
            newsContent5: 'In industries like automotive manufacturing and electronics assembly, RFID tags can track component flow, enabling full production process visibility. For example, Tesla uses RFID to manage battery pack assembly, reducing error rates by 30%. Industrial equipment (like machine tools and robots) embedded with RFID tags can monitor operational status in real-time, combining with AI to predict failures and reduce downtime losses. RFID enables "one item, one code," supporting small-batch, multi-variety production models to meet consumer customization needs (like custom footwear and 3D-printed products).',
            newsContent6: '3. Healthcare: From Pharmaceutical Management to Smart Wearables',
            newsContent7: 'The FDA requires high-value medical consumables (like cardiac stents) to use UDI (Unique Device Identification), making RFID the optimal solution to reduce medication errors and supply chain waste. RFID wristbands are used for patient identification, combining with IoT devices for infusion monitoring and emergency dispatch to improve medical safety. In the future, flexible RFID tags could integrate temperature and heart rate sensors to create "electronic skin" for chronic disease management (like diabetes and hypertension).',
            newsContent8: '4. Smart Cities and IoT: RFID Builds the Foundation for "Internet of Everything"',
            newsContent9: 'Smart Transportation & Vehicle Management: Electronic license plates (RFID+license recognition) enable automatic congestion charge deduction and violation tracking. Sharing Economy: Shared bikes and power banks use RFID to optimize scheduling and reduce operational costs. Waste Sorting & Environmental Monitoring. Smart Agriculture & Livestock Management: RFID ear tags enable livestock traceability and monitor breeding environments (like temperature, humidity, and disease warnings), increasing agricultural product value.',
            newsContent10: '5. Technological Breakthroughs: Cost Reduction and Performance Improvement',
            newsContent11: 'Lower Costs Drive Adoption: Traditional RFID tag costs have already decreased and may drop further in the next 5 years. Printed Electronics (like nano-silver ink) enables direct printing of RFID on packaging, reducing labeling steps. Next-gen RFID Tech: Battery-free Sensor RFID: Harvests RF energy to collect environmental data (temperature, humidity). UHF RFID Long-range Reading: Extends from meters to tens of meters, ideal for warehousing. Integration with AI & Blockchain: AI+RFID: Optimizes inventory forecasting (like dynamic retail replenishment). Blockchain+RFID: Ensures immutable supply chain data (for diamond and luxury goods traceability).',
            newsContent12: 'The Future of RFID Tags: From "Optional" to "Essential". In the past, RFID was limited by higher costs, but with technological maturity and mass production, it will become as ubiquitous as QR codes. Driven by retail digitization, Industry 4.0, smart healthcare, and smart cities, the RFID tag market is poised for rapid growth.',
            newsContent13: 'For businesses, early adoption of RFID means gaining a competitive edge in data-driven operations. For consumers, RFID will deliver safer, more convenient, and smarter living experiences. This "silent revolution" has only just begun.',
            newsContent14: '(Partial data sources: IDTechEx, GS1, Walmart Supply Chain Reports)'
        },
        hardone: {
            "performance_params": "Performance Parameters",
            "cpu": "CPU: Octa-core 2.3GHz",
            "ram_rom": "RAM + ROM: 4GB + 64GB ",
            "expansion_memory": "Expandable Memory: MicroSD (TF) card expandable up to 256GB",
            "os": "Operating system: Android 11",
            "physical_params": "Physical Parameters",
            "dimensions": "Dimensions: 177.0 x 80.2 x 14.8 mm",
            "weight": "Weight: 626g (including battery)",
            "display": "Display 5-inch (with fingerprint): 1280 x 720 / 6-inch, 2160 x 1080",
            "battery": "Battery capacity: Removable 6700mAh / 13400mAh grip battery; Built-in 100mAh battery backup, support battery hot-swapping",
            "camera": "Camera",
            "front_camera": "Front camera: 5 megapixels",
            "rear_camera": "Rear camera: 13 megapixels with flash support",
            "rfid_ghf": "RFID UHF",
            "protocol_standard1": "Protocol standard: EPCglobal Gen 2 (ISO18000-6C)",
            "protocol_standard2": "Protocol Standard: EPCglobal Gen 2 (ISO18000-6C)",
            "frequency": "Operating Frequency: 920-925MHz / 902-928MHz / 865-868MHz",
            "engine": "Engine: CM710-1, based on Impinj E710 chip",
            "output_power": "Output power: 1W (30dBm, support +5~+30dBm adjustable) 2W (33dBm, for Latin America, etc.)",
            "antenna_params": "Antenna parameters: circular polarisation; 5dBi ",
            "max_read_distance": "Maximum reading distance",
            "max_read_distance_5dBi_1": "5dBi",
            "max_read_distance_5dBi_2": "30m (Impinj MR6 tag, size 70 x 15mm) ",
            "max_read_distance_5dBi_3": "32m (Impinj M750 tag, size 70 x 15mm)",
            "max_read_distance_5dBi_4": "33m (Alian H3 metal-resistant tag, size 130 x 42mm) ",
            "max_read_distance_4dBi_1": "4dBi : 4dBi",
            "max_read_distance_4dBi_2": "22m (Impinj MR6 labels, size 70 x 15mm)",
            "max_read_distance_4dBi_3": "26m (Impinj M750 label, size 70 x 15mm) ",
            "max_read_distance_4dBi_4": "27m (Alian H3 anti-metal tag, size 130 x 42mm)",
            "read_rate": "Group read rate: up to 1300+ tags/sec (circularly polarised)",
            "environment": "Operating Environment",
            "operating_temperature": "Operating Temperature: -20 °C to 50 °C",
            "storage_temperature": "Storage temperature: -40 °C to 70 °C",
            "humidity": "Ambient humidity: 5%RH - 95%RH (non-condensing)",
        },
        hardtwo: {
            "hardware-title1": "Performance Parameters",
            "hardware-li1": "CPU: Octa-core, 2.0 GHz",
            "hardware-li2": "RAM+ROM: 8GB+256GB",
            "hardware-li3": "Expandable Memory: MicroSD (TF) card expandable up to 256G",
            "hardware-title2": "Physical Parameters",
            "hardware-li4": "Dimensions: 165.0 x 83.8 x 138.0mm",
            "hardware-li5": "Weight: 697g (including battery)",
            "hardware-li6": "Battery: Removable battery for main unit 5000mAh",
            "hardware-li7": " Removable battery for handle 5200mAh",
            "hardware-li8": " Support QC3.0 fast charging and RTC",
            "hardware-li9": "Display: 6-inch HD full screen, 1440 x 720 (18:9)",
            "hardware-li10": "Communication ports: USB Type-C, USB 3.1, OTG",
            "hardware-title3": "Camera",
            "hardware-li11": "Front camera: 5 megapixel",
            "hardware-li12": "Rear camera: 16M colour camera with autofocus and flash support",
            "hardware-title4": "UHF RFID",
            "hardware-li13": "Engine: Based on Impinj E710 chip",
            "hardware-li14": "Operating frequency: 920-925MHz / 902-928MHz / 865-868MHz",
            "hardware-li15": "Protocol standards: EPC C1 GEN2 / ISO18000-6C",
            "hardware-li16": "Antenna parameters: circularly polarised antenna (4dBi)",
            "hardware-li17": "Power: 1 W (30 dBm, supports +5 dBm ~ +30 dBm adjustment)",
            "hardware-li18": "Optional 2 W (33 dBm, for Latin America, etc.)",
            "hardware-li19": "Maximum reading distance: 26m (Impinj MR6 tag, size 70 x 15mm) ",
            "hardware-li20": " 28m (Impinj M750 tag, size 70 x 15mm) ",
            "hardware-li21": " 30m (Alian H3 anti-metal tag, size 130 x 42mm)",
            "hardware-li22": "Group read rate: up to 1300+ tags/sec (circularly polarised)",
            "hardware-title5": "Operating Environment",
            "hardware-li23": "Operating Temperature: -20 °C ~ +50 °C",
            "hardware-li24": "Storage temperature: -40 ℃~+70 ℃",
            "hardware-li25": "Ambient Humidity: 5%RH~95%RH (non-condensing)",
        },
        hardthree: {
            "hardware-title1": "Performance Parameters",
            "hardware-li1": "MCU Type: Cortex-M3",
            "hardware-li2": "Main frequency: 72MHz",
            "hardware-li3": "Storage capacity 50,000 labels",
            "hardware-title2": "Physical parameters",
            "hardware-li4": "Machine size: 282x117.5x32mm",
            "hardware-li5": "Machine weight: 334g (including battery)",
            "hardware-li6": "Appearance Material: Plastic",
            "hardware-li7": "Battery capacity: Battery specification: 5200mAh, removable",
            "hardware-li8": "Standby time > 70 hours (Bluetooth connection status)",
            "hardware-li9": "Charging time 3-4 hours (using the standard power adapter and data cable)",
            "hardware-li10": " Charging time 3 - 4 hours(using the standard power adapter and data cable)",
            "hardware-li11": " Display: 1.77 inch, 128X160",
            "hardware-title3": "RFID UHF",
            "hardware-li12": " Engine: Based on Impinj E710 ",
            "hardware-li13": " Antenna: Line polarised antenna (4dBi)",
            "hardware-li14": " Frequency: 920-925MHz/902-928MHz/865-868MHz",
            "hardware-li15": "Protocol standard: EPC C1 GEN2 / ISO18000-6C",
            "hardware-li16": " Module power: 1W (30dBm, support +5~+30dBm adjustable)",
            "hardware-li17": " Optional 2W (33dBm, for Latin America, etc.)",
            "hardware-title4": "Maximum reading distance",
            "hardware-li18": "26m (Impinj MR6 tag, size 70 x 15mm)",
            "hardware-li19": "27m (Impinj M750 tag, size 70 x 15mm) ",
            "hardware-li20": " 31m (Alien H3 metal-resistant tag, size 130 x 42mm)",
            "hardware-li21": "Group read rate: up to 900 tags/sec.",
            "hardware-title5": "Operating Environment",
            "hardware-li22": "Operating temperature -20℃~+50",
            "hardware-li23": "Storage Temperature -40℃~+70",
            "hardware-li24": "Ambient Humidity 5%RH~95%RH (non-condensing)",
        },
        hardfour: {
            hardwareTitle: 'Mechanical part',
            internalDimensions: 'Internal size: 2200*3000*1800',
            externalDimensions: 'External size: 2600*3100*2200',
            dimensionsCustomizable: '(Size support customisation)',
            electricalTitle: 'Electrical part',
            powerSource: 'Power supply: single-phase 220V',
            powerConsumption: 'Power: 1.5KW',
            controlSystem: 'Control system: Siemens PLC',
            pcSpecification: 'PC: 17 inch; 8G memory; 256G SSD; Win10 system; touch all-in-one (fingerprint recognition, face recognition, card can be customised)',
            antiCollisionSensor: 'Anti-collision photoelectricity: SICK background suppression diffuse reflection sensor switch',
            alarmLight: 'Alarm light: three colours + sound',
            rfidTitle: 'RFID Part',
            readerModel: 'Reader Model: Impinj R420',
            antennaModel: 'Antenna model: Laird9028*24',
            detectionQuantity: 'Detection quantity: 350 pieces',
            shieldingMethod: 'Shielding method: conductive cloth automatic roller shutter',
            shieldingPerformance: 'Shielding performance: 20cm away from no signal leakage',
            shieldingDoorsCustomizable: '(Support single and double door customisation)',
        },
        hardfive: {
            mechanical_part: 'Mechanical Part',
            internal_dimensions: 'Internal size: 1110*1500*1300mm',
            external_dimensions: 'External size: 1400*1600*1600mm',
            dimensions_customizable: '(Size support customisation)',
            electrical_part: 'Electrical Part',
            power: 'Power supply: single-phase 220V',
            power_consumption: 'Power: 0.6KW',
            control_system: 'Control system: Siemens PLC',
            pc_specifications: 'PC: 17 inch; 8G memory; 256G solid state hard drive; Win10 system; touch all-in-one machine',
            collision_prevention_sensor: 'Anti-collision photoelectricity: SICK background suppression diffuse reflection sensor switch',
            alarm_light: 'Alarm light: three colours + sound',
            weighing_accuracy: 'Weighing accuracy: 50g (10g can be customised)',
            rfid_part: 'RFID Part',
            reader_model: 'Reader model: Impinj R420',
            antenna_model: ' Antenna model: Laird9028*4',
            detection_quantity: 'Detection quantity: 350 pieces',
            shielding_method: 'Shielding method: conductive cloth automatic roller shutter',
            shielding_performance: 'Shielding performance: 20cm away from no signal leakage',
            customizable_doors: '(Support single and double door customisation)',
        },
        hardsix: {
            mechanical: 'Mechanical Part',
            channelSize: 'Channel size：900*830*1600mm',
            conveyorLoad: ' Load capacity of conveying line： 50 Kg',
            maxCarton: 'Maximum carton size： 700 * 500 * 550 mm',
            conveyorType: 'Conveyor line form: roller',
            customizable: ' (The above size supports customisation)',
            electrical: 'Electrical Part',
            powerSource: 'Power supply: single - phase 220 V',
            powerConsumption: ' Power: 1.5 KW',
            controlSystem: ' Control system: Siemens PLC',
            pcSpecs: ' PC: 17 inches;8 G memory;256 G SSD;Win10 system;touch all - in -one(fingerprint recognition, face recognition, card can be customised)',
            collisionPhotoelectric: 'Anti - collision photoelectricity: SICK background suppression diffuse reflection sensor   switch',
            baojing: ' Alarm light: three colours + sound',
            rfid: 'RFID Part',
            readerModel: ' Reader Model: Impinj R420',
            antennaModel: ' Antenna model: Laird9028 * 24',
            detectionQuantity: 'Detection quantity: 350 pieces',
            shieldingMethod: ' Shielding method: conductive cloth automatic roller shutter',
            shieldingPerformance: ' Shielding performance: 20 cm away from no signal leakage',
            customizableDoors: '(Support single and double door customisation)',
        },
        hardsenven: {
            mechanical_title: "Mechanical Part",
            mechanical_dimensions: "Appearance size: main body 900*960*1800mm",
            mechanical_conveyor_length: "Length of front and rear conveying line: 1.2 m",
            mechanical_conveyor_weight: "Load capacity of conveying line: 50 kg",
            mechanical_conveyor_height: "Height of conveying line: 60± 5 cm",
            mechanical_box_size: "Testing box size: 70 * 50 * 55 cm Max",
            electrical_title: "Electrical Part",
            electrical_power: "Rated power: 800 W",
            electrical_voltage: "Working voltage: AC~220 V",
            electrical_computer: "Industrial computer: 8 G memory,256 G solid state hard drive,17 inch resistance typeTouch Monitor",
            rfid_title: "RFID Part",
            rfid_reader: " RFID reader: Impinj R420",
            rfid_antenna: "Antenna Configuration: 9 dBi circularly polarised antenna * 4",
            rfid_speed: " Detection speed: 7 - 8 boxes / min",
            rfid_quantity: "Detection quantity: 350 pieces / box",
            rfid_frequency: "Operating frequency: 920 - 925 MHz",
            environment_title: "Use of the environment",
            environment_working_temp: " Operating temperature: -10℃～ + 40℃",
            environment_storage_temp: "Storage temperature: -20℃～ + 80℃",
        },
        hardeight: {
            mechanical_title: "Mechanical part",
            mechanical_dimensions: "Internal size: 4200mm*800mm*3600mm",
            mechanical_conveyor_length: "External dimension: 4720*800*3860",
            electrical_title: "Electrical part",
            electrical_power: "Power supply: single-phase 220V",
            electrical_voltage: "Power: 0.4KW",
            electrical_computer: "Control system: Siemens PLC",
            electrical_computer2: "PC: 17 inch; 8G memory; 256G SSD; Win10 system; touch all-in-one machine",
            electrical_computer3: "Alarm light: three colours + sound",
            electrical_computer4: "Forklift identification: geomagnetic switch or radar",
            rfid_title: "RFID part",
            rfid_reader: "RFID reader: Impinj R420",
            rfid_antenna: "Antenna Model: 9028*8",
        },
        hardware1: "Hardware",
        hardware2: "High-performance RFID hardware all in one",
        software1: "Software",
        software2: "Professional and efficient digital software platform",
    },
    zh: {
        footertitile: "版权所有© 江苏海康博瑞电子有限公司 备案号：苏ICP备19071766号",
        menu: "菜单",
        adress: "江苏省徐州市云龙区民主南路景染名居2号楼",
        home: "首页",
        Viewdocument: "查看文档",
        Viewdocument2: "海康博瑞产品介绍",
        Technical: "技术文档",
        productsdectitle: "产品详情",
        newsdectitle: "新闻详情",
        solutions: "解决方案",
        solutionssub1: "资产管理",
        solutionssub2: "展会人员管理",
        solutionssub3: "图书馆管理",
        solutionssub4: "畜牧管理",
        products: "产品中心",
        productssub1: "RFID标签",
        productssub2: "智能硬件",
        productssub3: "软件平台",
        support: "服务支持",
        ServiceProcess1: "服务流程",
        ServiceProcess2: "需求分析与设计",
        ServiceProcess3: "实施与部署",
        ServiceProcess4: "运维与优化",
        ServiceProcess5: "需求整理分析",
        ServiceProcess6: "专业咨询服务",
        ServiceProcess7: "需求验证服务",
        ServiceProcess8: "与您深入沟通，识别核心需求，评估需求的可行性。",
        ServiceProcess9: "根据行业最佳实践与专业知识为您提供可靠的RFID解决方案。",
        ServiceProcess10: "与您一起对方案需求进行反复确认，确保准确性。",
        ServiceProcess11: "实施过程",
        ServiceProcess12: "协助验收",
        ServiceProcess13: "专业培训",
        ServiceProcess14: "安装RFID智能硬件，按需求开发软件。",
        ServiceProcess15: "专业人士协助您进行功能验收、性能验收，并按需求整改。",
        ServiceProcess16: "对相关人员进行专业培训，确保方案在实际场景中的熟练使用。",
        ServiceProcess17: "问题跟进",
        ServiceProcess18: "性能优化",
        ServiceProcess19: "提供技术支持热线，确保快速响应并及时解决方案应用过程中的问题。",
        ServiceProcess20: "跟进软件的运行情况和用户反馈，对软件的性能进行更新优化。",
        ServiceProcess21: "如有您想进一步了解我们的产品与RFID方案，欢迎填写表单，我们将尽快安排专人与您联系。",
        ServiceProcess22: "公司名称",
        ServiceProcess23: "联系人",
        ServiceProcess24: "联系方式",
        ServiceProcess25: "您的需求",
        ServiceProcess26: "提交",
        news: "新闻动态",
        about: "关于我们",
        slidetitle: "围绕以RFID技术为核心的智能物联网解决方案供应商",
        slidesubtitle: "",
        slidebuttonText: "查看详情",
        solutiontitle: "RFID行业解决方案",
        solution: {
            items: [{
                    title: '资产管理',
                    description: '资产一站式、全生命周期管理，助力企业降本增效。'
                },
                {
                    title: '展会人员管理',
                    description: '展会人员的智能化、精细化管理，提升活动的管理效率与参与体验。'
                },
                {
                    title: '图书馆管理',
                    description: '图书资源全生命周期管理，全面提升图书馆的综合利用价值。'
                },
                {
                    title: '畜牧管理',
                    description: '智能化生物资产监管，提高养殖效益，实现精准核保、快速理赔。'
                },
            ],
        },
        producttile: {
            items: [{
                    title: 'RFID标签',
                    description: '不干胶/抗金属标签/洗涤标签/吊牌'
                },
                {
                    title: '智能硬件',
                    description: '手持机/盘点柜/通道机/龙门架'
                },
                {
                    title: '软件平台',
                    description: '轻蜓资产云/海康助农牧云'
                },
            ],
        },
        serviceprovider: "领先的RFID和物联网技术解决方案供应商",
        producttitle: "产品中心",
        cooperativetitle: "合作伙伴",
        homedec: "江苏海康博瑞电子有限公司，由中电海康集团子公司控股成立，是行业领先的RFID及物联网技术解决方案供应商。企业专注于物联网RFID标签、RFID模块与读写器产品、RFID芯片的设计与研发以及RFID行业集成软件的研究和开发。海康博瑞致力于打造淮海地区RFID物联网产业园，是一家拥有广阔市场前景和发展空间的高科技物联网企业。",
        serviceprovidertitle: {
            label1: '工厂年标签产能超8亿枚',
            label2: '标签战略合作客户超500家',
            label3: '行业方案服务客户超100家',
            label4: '业务覆盖全球30余个国家与地区',
            dec1: '亿+',
            dec2: '+'
        },
        bannertitle: '服务与支持',
        bannerdescription: '我们拥有专业的服务团队，提供涵盖产品/方案咨询、演示到开发部署、用户培训的一站式服务体系，帮助您轻松开启数字化体验。',
        newbannertitle: '新闻动态',
        newbannerdescription: '为您提供关于海康博瑞的第一手资讯',
        aboutbannertitle: '关于我们',
        aboutbannerdescription: '领先的RFID及物联网技术解决方案供应商',
        companyprofile: '公司简介',
        companyIntroduction: "江苏海康博瑞电子有限公司，由中电海康集团子公司控股成立，是行业领先的RFID及物联网技术解决方案供应商。企业专注于物联网RFID标签、RFID模块与读写器产品、RFID芯片的设计与研发以及RFID行业集成软件的研究和开发。海康博瑞致力于打造淮海地区RFID物联网产业园，是一家拥有广阔市场前景和发展空间的高科技物联网企业。",
        capacity: "8亿+：年标签产能超8亿枚",
        strategicPartners: "500+：标签战略合作客户超500家",
        industrySolutions: "100+：行业方案服务客户超100家",
        globalCoverage: "30+：业务覆盖全球30余个国家与地区",
        technologyCombination: "凭借持续的技术研发和创新，海康博瑞将强大的RFID标签研发制造能力与物联网、大数据技术完美结合，为资产管理、畜牧管理、图书管理、智慧医疗、仓储物流、防伪溯源等领域提供高价值的解决方案。",
        smartProductionBase: "RFID智能生产基地",
        productionBaseDescription: "海康博瑞RFID生产基地坐落于江苏省徐州市鼓楼区半导体产业园，占地15000㎡，厂房占地8000㎡，已建设完成10万级洁净车间、企业智慧展厅、智能仓库，拥有先进的绑定、复合等生产设备以及质检设备，满足各类RFID标签（NFC、低频、高频、超高频）的生产。",
        honors: "荣誉奖项",
        partners: "合作伙伴",
        contactUs: "联系我们",
        phone: "电话：0516-8300 0001",
        marketingDepartment: "企划部：+86 19961919596",
        salesDepartment: "销售部：+86 19051668932",
        WhatsApp: "企划部",
        WhatsApp2: " 销售部",
        email: "邮箱:info@haikangborui.com",
        address: "地址:江苏省徐州市鼓楼半导体产业园",
        WhatsAppvalue: "+86 19961919596",
        WhatsApp2value: " +86 19051668932",
        codedec: "扫描二维码联系我们",
        companyNews: '企业动态',
        industryNews: '行业新闻',
        newsTitle: '新闻标题',
        newsSummary: '新闻摘要',
        newsTime: '发布时间',
        hardwarelistone: {
            items: [{
                id: 1,
                title: "超高频RFID手持机",
                image: require("./assets/img/ying1.jpg"),
                model: "HKBR-RH-C5",
            }, {
                id: 2,
                title: "超高频RFID手持机",
                image: require("./assets/img/ying2.jpg"),
                model: "HKBR-RH-MC50",
            }, {
                id: 3,
                title: "超高频RFID蓝牙读写器",
                image: require("./assets/img/ying3.jpg"),
                model: "HKBR-RB-R2",
            }, {
                id: 4,
                title: "RFID叉车盘点柜",
                image: require("./assets/img/ying4.jpg"),
                model: "HKBR-RInventory-S02DR",
            }, {
                id: 5,
                title: "RFID称重盘点柜",
                image: require("./assets/img/ying5.jpg"),
                model: "HKBR-RInventory-W06R",
            }, {
                id: 6,
                title: "RFID电动盘点车",
                image: require("./assets/img/ying6.jpg"),
                model: "HKBR-RInventory-09D ",
            }, {
                id: 7,
                title: "RFID通道机",
                image: require("./assets/img/ying7.jpg"),
                model: "HKBR-RG-T10",
            }, {
                id: 8,
                title: "RFID龙门架",
                image: require("./assets/img/ying8.jpg"),
                model: "HKBR-RL-L08",
            }, ]
        },
        newsone: {
            items: [{
                    "id": 16,
                    title: '加速聚焦智能产业布局，协同共绘发展蓝图！',
                    summary: "6月20日，由济宁太白湖新区党工委委员、管委会、新区财政金融局、新区投资促进事务部等部门组成的考察组，莅临江苏海康博瑞进行实地调研",
                    image: require("./assets/img/anews16.jpg"),
                    createTime: "2025-06-20",
                }, {
                    "id": 15,
                    title: '市人大领导考察海康博瑞：见证智能物联创新势能',
                    summary: "5 月 23 日，徐州市人大工作理论研究会领导张赴宁、冯其谱、袁建芬、周建洪、王立峰率全体理事、会员，在区领导陪同下参观海康博瑞。",
                    image: require("./assets/img/anews15.jpg"),
                    createTime: "2025-05-23",
                },
                {
                    id: 14,
                    title: '科技赋能・政企校共访海康博瑞创新现场',
                    summary: "5 月 20 日，江苏师范大学党委书记芮国强率党委办公室主任赵玉苏、国内合作处处长顾振中、党委研究生工作部部长吴迪、学生工作处副处长韩洪政等领导，在区领导陪同下莅临海康博瑞考察交流。海康博瑞总经理刘金鹏热情接待，深入介绍企业发展情况。",
                    image: require("./assets/img/anews14.jpg"),
                    createTime: "2025-05-20",
                },
                {
                    id: 13,
                    title: '中沙企业交流|沙特客户到访海康博瑞，夯实国际化合作根基 ',
                    summary: "5月15日，沙特客户代表到访海康博瑞及生产基地参观考察。公司总经理刘金鹏携高层领导热情接待，双方围绕深化合作、共谋发展主题展开深入交流。",
                    image: require("./assets/img/anews13.jpg"),
                    createTime: "2025-05-12",
                },
                {
                    id: 12,
                    title: '鼓楼区领导走访海康博瑞|送政策、解难题，赋能企业创新发展 ',
                    summary: "5 月 7 日，鼓楼区委书记罗德清，区委副书记程峰，区政府常务副区长刘一等区领导率队深入江苏海康博瑞电子有限公司走访调研，实地了解企业发展状况，面对面倾听诉求建议，助力企业破解发展难题。海康博瑞总经理刘金鹏全程陪同并汇报工作。",
                    image: require("./assets/img/anews12.jpg"),
                    createTime: "2025-05-07",
                },
                {
                    id: 11,
                    title: '启新岁 赴新篇 赢战2025丨海康博瑞2025迎新年会圆满召开 ',
                    summary: "1月26日，海康博瑞全体员工齐聚一堂，隆重举行2025迎新年会！这不仅是回顾过去、展望未来的重要时刻，更是激发斗志、凝聚力量的关键节点。",
                    image: require("./assets/img/anews11.jpg"),
                    createTime: "2025-01-26",
                },
                {
                    id: 10,
                    title: '开拓海外市场新机遇 寻求合作共赢新发展 ——海康博瑞赴沙特考察',
                    summary: "深度拜访海外客户，主动开发国际市场。近日，江苏海康博瑞电子有限公司总经理刘金鹏带队开启沙特客户拜访之行，收获丰硕，为海康博瑞加速海外市场的开拓奠定了坚实的基础。",
                    image: require("./assets/img/anews10.jpg"),
                    createTime: "2025-01-20",
                },
                {
                    id: 9,
                    title: '实力见证！海康博瑞通过省级“专精特新企业”认定',
                    summary: "近日，江苏省工业和信息化厅公布了江苏省2024年度省级专精特新企业认定名单，海康博瑞凭借优秀的创新能力和专业的技术实力榜上有名!",
                    image: require("./assets/img/anews9.jpg"),
                    createTime: "2024-12-31",
                }, {
                    id: 1,
                    title: '省级认定+1！海康博瑞获评江苏省"四星级上云企业” ',
                    summary: "近日，徐州市工信局公示了徐州市2024年度第二批省三、四星级上云企业拟认定名单，经网上申报、初审推荐、专家评审、现场核查、信用审查等程序，江苏海康博瑞电子有限公司成功入选江苏省四星级上云企业。",
                    image: require("./assets/img/anews1.jpg"),
                    createTime: "2024-12-02",
                },
                {
                    id: 2,
                    title: "标签出货量破亿！海康博瑞火力全开 再攀高峰",
                    summary: "2024年11月1日，海康博瑞迎来高光时刻，RFID标签2024年全球累计出货量突破1亿枚。",
                    image: require("./assets/img/anews2.jpg"),
                    createTime: "2024-11-15",
                },
                {
                    id: 3,
                    title: "沙特阿拉伯客户来信致谢：合作之花绽放，感谢与信任同在！",
                    summary: "沙特阿拉伯客户来信致谢",
                    image: require("./assets/img/anews3.jpg"),
                    createTime: "2024-05-04",
                },
                {
                    id: 4,
                    title: '海康博瑞受邀参加全市畜禽养殖"防保联动 科技助农”座谈会',
                    summary: '10月16日，全市畜禽养殖"防保联动 科技助农” 座谈会召开。 市农业农村局党委委员、 副局长、 机关党委书记周伟出席会议并讲话。 各县区农业农村局分管领导、 防疫站负责人、 保险公司代表参加会议。 ',
                    image: require("./assets/img/anews4.jpg"),
                    createTime: "2024-10-17",
                },
            ]
        },
        newsotwo: {
            items: [{
                    id: 17,
                    title: "RFID标签：未来十年高速增长的五大驱动力",
                    summary: "近年来，RFID（射频识别）技术已经从早期的物流追踪工具，逐渐渗透到零售、医疗、制造、智慧城市等多个领域。",
                    image: require("./assets/img/anews17.jpg"),
                    createTime: "2025-06-27",
                },
                {
                    id: 5,
                    title: "RFID电子标签：产线管理智能化的得力助手",
                    summary: "RFID电子标签的运用使得产线管理更加智能化，显著提高了工作效率和准确性，同时降低了生产成本和人力投入。",
                    image: require("./assets/img/anews5.jpg"),
                    createTime: "2023-03-09",
                },
                {
                    id: 6,
                    title: "RFID智慧仓储管理系统，开启企业仓储智能化之旅！",
                    summary: '"发展、 改革、 创新”， 是企业成长过程中永恒不变的话题。 市场对产品的需求日新月异、 工厂对人员的需求日趋迫切…… 众多制造企业的发展面临着严峻的考验。 ',
                    image: require("./assets/img/anews6.jpg"),
                    createTime: "2023-10-10",
                },
                {
                    id: 7,
                    title: "RFID技术改变零售业：提高库存管理效率，提升顾客体验",
                    summary: "RFID技术在零售业的广泛应用正在推动零售行业向智能、高效、精细化管理转型。它以一种高效的方式，使供应链系统能够更简易、自动地追踪商品动态，让物品实现真正的自动化管理。",
                    image: require("./assets/img/anews7.jpg"),
                    createTime: "2023-08-03",
                },
                {
                    id: 8,
                    title: "RFID不干胶标签的行业应用及优势",
                    summary: "RFID不干胶标签具有识别速度快、读取方便快捷、芯片容量大、芯片数据可改写、使用寿命长、安全性高等特点，在许多行业发挥着重要作用。",
                    image: require("./assets/img/anews8.jpg"),
                    createTime: "2023-05-11",
                },
            ]
        },
        Solutiondec1: "行业洞察",
        Solutiondec2: "业务挑战",
        Solutiondec3: "解决方案架构",
        Solutiondec4: "应用场景",
        Solutiondec5: "应用价值",
        Solutiondec6: "应用产品",
        Solutiondec7: "企业资产存在数量大、种类多、分布广的情况，缺少精细化的管理方式，导致资产浪费、闲置，使用效能低。",
        Solutiondec337: "海康博瑞提供涵盖专业硬件软件、RFID标签和服务的全套解决方案，以“一物一码”实现资产的快速登记、高效盘点、轻松管理。",
        Solutiondec8: "管理流程乱",
        Solutiondec9: "盘点效率低",
        Solutiondec10: "状态追溯难",
        Solutiondec11: "资产利用率低",
        Solutiondec12: "传统纸质记录留存，效率低，更新难且易出错。",
        Solutiondec13: "盘点工作量大，传统模式速度慢，易出现错盘漏盘。",
        Solutiondec14: "传统管理方式下，资产状态变更不及时，容易遗漏出错。",
        Solutiondec15: "资产的调拨和分配不合理，重复购置和闲置情况严重。",
        Solutiondec16: '海康博瑞提供涵盖专业硬件软件、RFID标签和服务的全套解决方案，以"一物一码” 实现资产的快速登记、 高效盘点、 轻松管理。 ',
        Solutiondec17: "资产录入",
        Solutiondec18: "资产盘点",
        Solutiondec19: "资产管理",
        Solutiondec20: "批量导入/建立资产台账",
        Solutiondec21: "批量盘点/非接触式盘点/多人同时盘点",
        Solutiondec22: "全生命周期管理/计提折旧/多样化报表/自定义审批流程",
        Solutiondec23: "管理效率提升60%",
        Solutiondec24: "盘点成本降低75%",
        Solutiondec25: "资产利用率提升60%",
        Solutiondec26: "账实不符降低80%",
        Solutiondec27: "RFID标签",
        Solutiondec28: "手持机",
        Solutiondec29: "标签打印机",
        Solutiondec30: "安全门",
        Solutiondec31: "多样化的RFID标签，包括不干胶标签、PET标签、抗金属标签等",
        Solutiondec32: "读取距离5-8米，高效完成资产盘点",
        Solutiondec33: "功能齐全，满足不同用途的标签打印",
        Solutiondec34: "实时监控、追溯资产变动信息",
        Solutiondec35: "在大型展会或活动中，面对庞大的参展人流，传统的管理方式已无法满足现代展会的需求，常常面临人流拥堵、签到遗漏等问题，且无法实现人员的动态管理。",
        Solutiondec36: "参与体验感差",
        Solutiondec37: "数据记录不精准",
        Solutiondec38: "人员管理效率低",
        Solutiondec39: "缺少数据反馈",
        Solutiondec40: "签到流程复杂，等待时间长。",
        Solutiondec41: "人数统计有遗漏，身份信息不明。",
        Solutiondec42: "无法实现人员的动态管理，缺少有效的数据反馈。",
        Solutiondec43: "无法形成有效地活动统计数据。",
        Solutiondec44: "海康博瑞以RFID技术为基础，利用RFID腕带结合数据分析等技术手段，实现对活动全流程、全场景、全人员的实时监控和智能化管理。",
        Solutiondec45: "人员签到",
        Solutiondec46: "人员管理",
        Solutiondec47: "节点管理",
        Solutiondec48: "数据分析",
        Solutiondec49: "快速签到/人员数量统计/身份确认与安全筛查",
        Solutiondec50: "位置信息跟踪/检查点快速通行/区域身份限制",
        Solutiondec51: "统计每个活动节点参与人员信息",
        Solutiondec52: "区域热力图 /历史轨迹、历史数据等可查询",
        Solutiondec53: "增强安全性",
        Solutiondec54: "优化参与体验",
        Solutiondec55: "提升管理效率",
        Solutiondec56: "提供数据支持",
        Solutiondec57: "通过身份确认与区域管制，预警潜在安全隐患，提高展会安全性。",
        Solutiondec58: "减少签到环节的等待时间与操作流程，提升参与体验。",
        Solutiondec59: "减少了人为操作，实现人员的精细化、智能化管理。",
        Solutiondec60: "收集参与者的行为模式等数据为未来的资源配置与场地管理提供有力支持。",
        Solutiondec61: "RFID腕带",
        Solutiondec62: "手持机",
        Solutiondec63: "轻量化设计，佩戴舒适，提高信息识别效率",
        Solutiondec64: "快速、准确读取RFID腕带信息，最远读取距离30米",
        Solutiondec65: "图书馆文献信息数量大、类型复杂、形式多样，面临借还、盘点、查找及乱架图书整理等多重挑战，影响着图书馆的管理效率及读者体验。",
        Solutiondec66: "管理方式落后",
        Solutiondec67: "读者体验不佳",
        Solutiondec68: "资源整合能力差",
        Solutiondec69: "信息化建设不足",
        Solutiondec70: "条形码管理，盘点、查找困难，书籍容易遗漏、失窃和错架‌。",
        Solutiondec71: "查书、借还书过程繁琐，读者体验不佳，借阅积极性降低。",
        Solutiondec72: "纸质图书、期刊、文献等无法整合，实现统一的数字化管理。",
        Solutiondec73: "图书流通等数据无法收集，借阅情况和图书流通率无法汇总。",
        Solutiondec74: "海康博瑞将RFID技术与门禁、图书标签、自助借还书机、盘点设备以及馆员工作站系统软件融合为一体，实现了便捷的图书管理功能。",
        Solutiondec75: "图书入库",
        Solutiondec76: "图书借还",
        Solutiondec77: "图书管理",
        Solutiondec78: "标签打印与粘贴",
        Solutiondec79: "自助借还/归还上架/安全管理",
        Solutiondec80: "图书盘点/图书定位/图书分拣",
        Solutiondec81: "提升流通效率",
        Solutiondec82: "增强安全性",
        Solutiondec83: "改善用户体验",
        Solutiondec84: "提供数据支持",
        Solutiondec85: "简化借还图书流程，减少人工干预，提高流通效率。",
        Solutiondec86: "图书安全管理功能有效防止了图书被盗取的情况发生。",
        Solutiondec87: "自助式服务和智能化管理满足读者的高效服务需求。",
        Solutiondec88: "数据统计与分析可以更好地了解读者需求，优化管理。",
        Solutiondec89: "RFID标签",
        Solutiondec90: "标签打印机",
        Solutiondec91: "手持机",
        Solutiondec92: "智能门禁",
        Solutiondec93: "自助借还书机",
        Solutiondec94: "图书标签与层架标签",
        Solutiondec95: "功能齐全，满足不同用途的标签打印",
        Solutiondec96: "远距离识别、批量高速盘点书籍",
        Solutiondec97: "图书离馆信息监控、防盗",
        Solutiondec98: "自助操作，提升效率",
        Solutiondec99: "由于牲畜健康监测、监管追踪等技术的不匹配经常引发养殖风险与理赔风险，这正是阻碍养殖户与保险机构实现正向效益的关键因素。",
        Solutiondec100: "农户风险意识淡薄，参保积极性低。",
        Solutiondec101: "道德风险防范难、骗保问题严重。",
        Solutiondec102: "保险业务工作难度大，信息核实困难。",
        Solutiondec103: "理赔手续繁琐，赔付不及时。",
        Solutiondec104: "海康博瑞以大数据平台＋智能硬件＋RFID电子耳标（温感耳标）的全方位解决方案，满足养殖户风险监控、保险机构数据治理运营的双重需求。",
        Solutiondec105: "戴标",
        Solutiondec106: "稽查",
        Solutiondec107: "理赔",
        Solutiondec108: "监测",
        Solutiondec109: "养殖户信息上传/耳标佩戴/牲畜数据采集",
        Solutiondec110: "畜只投保数据复核/风险区域随机稽查",
        Solutiondec111: "牲畜真实性核对/远程便捷理赔",
        Solutiondec112: "牲畜体温监测，实时反馈/风险预警",
        Solutiondec113: "保障养殖户利益",
        Solutiondec114: "实现保险机构正向效益",
        Solutiondec115: "实现健康监测与疾病预防，降低养殖场经营风险。",
        Solutiondec116: "实现精准理赔，简化理赔流程、提高理赔效率。",
        Solutiondec117: "RFID耳标",
        Solutiondec118: "便携式读标器",
        Solutiondec119: "RFID稽查拍",
        Solutiondec120: "电子耳标/温感耳标",
        Solutiondec121: "戴标时读取耳标，确保牲畜与耳标的信息对应",
        Solutiondec122: "远距离读取耳标，复核投保数据",
        image1: require("./assets/img/guanli1.png"),
        image2: require("./assets/img/guanli2.png"),
        image3: require("./assets/img/guanli3.png"),
        image4: require("./assets/img/guanli4.png"),
        image5: require("./assets/img/guanli5.png"),
        image6: require("./assets/img/er.png"),
        product1: "帮助实现管理的可视化、智能化",
        product2: "远距离批量读取/支持快速读写/支持定制尺寸/面材/logo/可应用于多场景",
        product3: "远距离读取耳标，复核投保数据",
        product4: "远距离读取耳标，复核投保数据",
        product5: "轻蜓资产云",
        product6: "一站式资产管理解决方案，让资产管理更轻松",
        product7: "海康助农牧云",
        product8: "帮助保险行业开展面向农户的养殖保险业务，实现精准核保与理赔。",
        product9: "预约演示",
        product10: "我们很乐意为您提供以下帮助，以加深您对产品的了解。",
        product11: "海康助农牧云以大数据平台＋智能硬件＋RFID电子耳标的全方位解决方案，实现投保牲畜的身份识别与追踪，满足保险数据治理和运营的核心需求，提升养殖业保险的合规性，提高牲畜保险的管理效率，降低理赔风险。",
        product12: "轻蜓资产云，以RFID（无线射频识别）技术为核心，打造智能化资产管理新生态。提供全面覆盖、实时精准的资产追踪与监控服务，帮助企业实现资产信息快速采集与高效管理。通过云端智能分析洞察资产动态，优化资源配置，助力企业提升运营效率与决策能力。",
        product13: "需求分析",
        product14: "解决方案",
        product15: "提供报价",
        product16: "专业的产品顾问，深入了解使用场景及需求",
        product17: "针对需求，打造最优的软硬件解决方案",
        product18: "根据产品需求，提供最优的价格方案",
        adhesiveLabels: '不干胶标签',
        flexibleMetalLabels: '柔性抗金属标签',
        antiMetalLabels: '抗金属标签',
        washingLabels: '洗涤标签',
        hangtags: '吊牌',
        animalEarTags: '动物耳标',
        wristbands: '腕带',
        chip: '芯片',
        frequency: '频率',
        material: '材质',
        weight: '重量',
        size: '尺寸',
        operatingTemperature: '工作温度',
        readingDistance: '读取距离',
        readingDistance2: '',
        installation: '安装方式',
        AntennaSize: '天线尺寸',
        ProductSize: '成品尺寸',
        Storage: '存储',
        ApplicationSurface: '应用表面',
        Color: '颜色',
        Tensilestrength: '可承受拉力',
        Operatingtemperature: '工作温度',
        advone1: '优势',
        advone2: '特点',
        advone3: '应用场景',
        advone4: '1、粘贴方便，不需要其他辅助工具。2、防水耐油，长时间依然清晰可读。3、可承受高温环境，不易变形或脱落',
        advone5: '1、良好的粘附性，能牢固地粘附在各种材质表面。2、质感细腻，图案与文字印刷清晰美观。3、能很好地承载各类油墨印刷，标签的生产便利。4、适用范围广，在各行业均有广泛的应用。',
        advone6: '食品饮料行业、医疗行业、物流运输、服装行业、轮胎行业等',
        advone7: '1、可在金属曲面安装识别。 2、支持多标签群读识别。 3、支持RFID打印机打印、发卡。',
        advone8: '1、可弯曲，适合贴在各种形状的金属物体上。 2、抗金属性好，不受金属环境的影响。3、读取距离远，方向性好，易于识别。4、可打印，可定制化。',
        advone9: '设备管理、气缸追踪、交通控制、物流管理、危险品管理等',
        advone10: '1、真正达到和超越200次以上的工业洗涤寿命。2、材质和设计均经过可靠性测试。3、已经出厂近亿只，获全球众多客户认可。',
        advone11: '1、通过MRI检测，能通过CT及检针测试。2、通过GB18401测试，对皮肤无害。3、通过RoHS测试，无有毒及无致癌物质。4、通过欧盟SVHC测试，无有毒及无致癌物质。5、通过欧盟OEKO-TEX Std 100测试，无有毒物质。6、软质，不伤纺织品。',
        advone12: '酒店用品管理、工装制服管理、医院布草管理、布草租赁管理等',
        advone13: '1、纸卡制作，可用做商品挂牌、吊牌。2、印刷美观，方便打印文字、图案及其它内容。3、符合国际最新标准，应用于更多行业和领域。4、支持国际协议，适用于更多国家。',
        advone14: '1、可同时读取多个标签，大大提高了商品盘点的速度和准确性。 2、读取距离远，无需直接接触，使得商品的快速扫描成为可能。3、可以存储商品信息，用于商品追溯，例如批次号、生产日期和供应链信息。',
        advone15: '产线制造管理、品牌管理、物流仓储盘点和门店管理等',
        advone16: '1、电子耳标性能优异，使用寿命长。 2、信号传输稳定，识别更精准。3、读取距离更稳定，不受养殖环境影响。',
        advone17: '畜牧保险、动物流行病预防、智能识别和盘点、智能称重、出栏记录等。',
        advone18: '1、轻量化设计，佩戴舒适。2、读取距离远、识别速度快、抗干扰能力强。',
        advone19: '展会、赛事、医疗行业等。',
        advone20: '1、标签性能稳定可靠。 2、拥有全球唯一识别码(TID码)。3、最远读取距离可达10米+。',
        advone21: '1、读取灵敏度高，100%通过读取性能测试。2、数据保存时间>50年。3、支持尺寸、颜色定制。',
        advone22: '工具管理、机械设备管理、仓储物流管理、生产流程追溯等',
        productlistone: {
            items: [{
                id: 1,
                title: "UHF 42*16mm",
                image: require("./assets/img/one1.jpg"),
                chip: "NXPU9/Impinj MR6",
                AntennaSize: "42*16mm",
                ProductSize: "44*19mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "6.5m~9m",
            }, {
                id: 2,
                title: "UHF 70*14mm",
                image: require("./assets/img/one2.jpg"),
                chip: "NXPU9/Impinj M730 lmpinj M750",
                AntennaSize: "70*14mm",
                ProductSize: "76*20mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "10m~16m",
            }, {
                id: 3,
                title: "UHF 30*50mm",
                image: require("./assets/img/one3.jpg"),
                chip: "NXPU9/lmpinjM730/凯路威",
                AntennaSize: "30*50mm",
                ProductSize: "34*54mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "11.5m~16m",
            }, {
                id: 4,
                title: "UHF 95*3mm",
                image: require("./assets/img/one4.jpg"),
                chip: "NXPU9/Alien H10",
                AntennaSize: "95*3mm",
                ProductSize: "125*7mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "5m~15m",
            }, {
                id: 5,
                title: "UHF 10*27mm",
                image: require("./assets/img/one5.jpg"),
                chip: "NXPU9",
                AntennaSize: "10*27mm",
                ProductSize: "30*14mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "3m~4.5m",
            }, {
                id: 6,
                title: "超高频44*44mm",
                image: require("./assets/img/one6.jpg"),
                chip: "Impinj M4E",
                AntennaSize: "44*44mm",
                ProductSize: "50*50mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "3m~7m",
            }, {
                id: 7,
                title: "UHF 11*42mm",
                image: require("./assets/img/one7.jpg"),
                chip: "NXPU9",
                AntennaSize: "11*42mm",
                ProductSize: "68*26mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "2m~3.5m",
            }, {
                id: 8,
                title: "UHF 15*40mm",
                image: require("./assets/img/one8.jpg"),
                chip: "NXPU9/ImpinjMR6P",
                AntennaSize: "15*40mm",
                ProductSize: "44*19mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "5m~9m",
            }, {
                id: 9,
                title: "UHF 70*17mm",
                image: require("./assets/img/one9.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*17mm",
                ProductSize: "76*20mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "9m~12m",
            }, {
                id: 10,
                title: "UHF 70*15mm",
                image: require("./assets/img/one10.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*15mm",
                ProductSize: "76*20mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "8m~17m",
            }, {
                id: 11,
                title: "UHF 19*93mm",
                image: require("./assets/img/one11.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "19*93mm",
                ProductSize: "97*25mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "5m~12m",
            }, {
                id: 12,
                title: "UHF 8.15*94.8mm",
                image: require("./assets/img/one12.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "8.15*94.8mm",
                ProductSize: "100*15mm或可定制",
                material: "PET或铜版纸",
                frequency: "860~960MHz",
                readingDistance: "10m~12m",
            }, {
                id: 13,
                title: "HF calibre 22mm",
                image: require("./assets/img/one13.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "直径22mm",
                ProductSize: "直径25mm或可定制",
                material: "PET或铜版纸",
                frequency: "13.56MHz",
                readingDistance: "30cm~50cm",
            }, {
                id: 14,
                title: "HF calibre15mm",
                image: require("./assets/img/one14.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "直径15mm",
                ProductSize: "直径18mm或可定制",
                material: "PET或铜版纸",
                frequency: "13.56MHz",
                readingDistance: "5cm~15cm",
            }, {
                id: 15,
                title: "HF 76*45mm",
                image: require("./assets/img/one15.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "76*45mm",
                ProductSize: "86*54mm或可定制",
                material: "PET或铜版纸",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, {
                id: 16,
                title: "HF 45*45mm",
                image: require("./assets/img/one16.jpg"),
                chip: "ICODE-SLIX/F01N",
                AntennaSize: "45*45mm",
                ProductSize: "50*50mm或可定制",
                material: "PET或铜版纸",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, ]
        },
        productlisttwo: {
            items: [{
                id: 1,
                title: "60*25*1.25mm",
                image: require("./assets/img/two1.jpg"),
                chip: "NXP UCODE 8",
                frequency: "920-925MHz",
                Storage: "TID 96bits EPC 128bits",
                ApplicationSurface: "金属表面",
                size: "60*25*1.25mm",
                readingDistance: "固定式:650cm；手持机:500cm",
            }, {
                id: 2,
                title: "60x6x1.0mm",
                image: require("./assets/img/two2.jpg"),
                chip: "NXP UCODE 8",
                frequency: "美标902-928MHz；欧标865-868MHz",
                Storage: "EPC128bits 用户区 0bits TlD96bits",
                ApplicationSurface: "金属表面",
                size: "60x6x1.0mm",
                readingDistance: "固定式:200cm;手持机:130cm",
            }, {
                id: 3,
                title: "70x18x1.0mm",
                image: require("./assets/img/two3.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "美标902-928MHz；欧标865-868MHz",
                Storage: "EPC128bits 用户区 0bits TlD96bits",
                ApplicationSurface: "金属表面",
                size: "70x18x1.0mm",
                readingDistance: "固定式:400cm；手持机:280cm",
            }, {
                id: 4,
                title: "98x42x1.0mm",
                image: require("./assets/img/two4.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "美标902-928MHz；欧标865-868MHz",
                Storage: "TID 128bits 用户区 64bits EPC 96bits",
                ApplicationSurface: "金属表面",
                size: "98x42x1.0mm",
                readingDistance: "固定式:600cm;手持机:600cm",
            }, {
                id: 5,
                title: "60*25*1.25mm",
                image: require("./assets/img/two5.jpg"),
                chip: "Qstar-73GB",
                frequency: "920-925MHz",
                Storage: "TID 96bits 用户区 512bits EPC 160bits",
                ApplicationSurface: "金属表面",
                size: "60*25*1.25mm",
                readingDistance: "固定式:520cm；手持机:400cm",
            }, {
                id: 6,
                title: "60x24x1.2mm",
                image: require("./assets/img/two6.jpg"),
                chip: "NXP U CODE 8",
                frequency: "美标902-928MHz",
                Storage: "EPC 128 bits",
                ApplicationSurface: "金属表面",
                size: "60x24x1.2mm",
                readingDistance: "固定式:270cm；手持机:130cm",
            }, {
                id: 7,
                title: "45x8x1.0mm",
                image: require("./assets/img/two7.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "美标902-928MHz；欧标865-868MHz",
                Storage: "EPC128bits 用户区 64bits TID96bits",
                ApplicationSurface: "金属表面",
                size: "45x8x1.0mm",
                readingDistance: "固定式: 150cm；手持机:100cm",
            }, {
                id: 8,
                title: "45x18x1.0mm",
                image: require("./assets/img/two8.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "美标902-928MHz；欧标865-868MHz",
                Storage: "TID 128bits 用户区 64bits EPC 96bit",
                ApplicationSurface: "金属表面",
                size: "45x18x1.0mm",
                readingDistance: "固定式:250cm；手持机:140cm",
            }, ]
        },
        productlistthree: {
            items: [{
                id: 1,
                title: "6*3*T3.0",
                image: require("./assets/img/three1.jpg"),
                Size: "6*3*T3.0",
                Installation: "背胶",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 或NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-928MHz  85cm  欧标：865-868MHz 80cm",
                Readingdistance2: "手持读写器 美标：902-928MHz  50cm  欧标：865-868MHz 45cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 2,
                title: "10*4*T3.0",
                image: require("./assets/img/three2.jpg"),
                Size: "10*4*T3.0",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-925MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 或NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  135cm  欧标：865-868MHz 135cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  90cm  欧标：865-868MHz 75cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 3,
                title: "直径10*T3.7",
                image: require("./assets/img/three3.jpg"),
                Size: "直径10*T3.7",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 或NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  150cm  欧标：865-868MHz 130cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  100cm  欧标：865-868MHz 95cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 4,
                title: "12*4*T1.5",
                image: require("./assets/img/three4.jpg"),
                Size: "12*4*T1.5",
                Installation: "背胶",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "NXP U8",
                Storage: "EPC 128bit  TID96bits",
                Readingdistance: "固定读写器 美标：902-925MHz  150cm  欧标：865-868MHz 150cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  60cm  欧标：865-868MHz 60cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.2g",
            }, {
                id: 5,
                title: "直径20*T2.8",
                image: require("./assets/img/three5.jpg"),
                Size: "直径20*T2.8",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  320cm  欧标：865-868MHz 280cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  240cm  欧标：865-868MHz 230cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "1.9g",
            }, {
                id: 6,
                title: "30*5*T2.8",
                image: require("./assets/img/three6.jpg"),
                Size: "30*5*T2.8",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  310cm  欧标：865-868MHz 280cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  210cm  欧标：865-868MHz 200cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.8g",
            }, {
                id: 7,
                title: "36*13*T3.5",
                image: require("./assets/img/three7.jpg"),
                Size: "36*13*T3.5",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  470cm  欧标：865-868MHz 450cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  270cm  欧标：865-868MHz 250cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "4.2g",
            }, {
                id: 8,
                title: "直径40*T3.0 ",
                image: require("./assets/img/three8.jpg"),
                Size: "直径40*T3.0 ",
                Installation: "背胶",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "IMPINJ RG-P",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  680cm  欧标：865-868MHz 650cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  350cm  欧标：865-868MHz 350cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, {
                id: 9,
                title: "90*20*T3.7",
                image: require("./assets/img/three9.jpg"),
                Size: "90*20*T3.7",
                Installation: "背胶或螺丝",
                Frequency: "美标：902-928MHz 欧标：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (可拓展到480bits)用户区 512bits TID64bits",
                Readingdistance: "固定读写器 美标：902-925MHz  1080cm  欧标：865-868MHz 1050cm",
                Readingdistance2: "手持读写器 美标：902-925MHz  650cm  欧标：865-868MHz 630cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, ]
        },
        productlistfour: {
            items: [{
                id: 1,
                title: "70*15*1.5mm",
                image: require("./assets/img/four1.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "70*15*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, {
                id: 2,
                title: "70*10*1.5mm",
                image: require("./assets/img/four2.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "70*15*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, {
                id: 3,
                title: "35*15*1.5mm",
                image: require("./assets/img/four3.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "35*15*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, {
                id: 4,
                title: "86*16*1.5mm",
                image: require("./assets/img/four4.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "86*16*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, {
                id: 5,
                title: "58*15*1.5mm",
                image: require("./assets/img/four5.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "58*15*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, {
                id: 6,
                title: "60*20*1.5mm",
                image: require("./assets/img/four6.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "纺织品",
                size: "60*20*1.5mm",
                readingDistance: "固定式: ≥6米；手持机:≥3米",
            }, ]
        },
        productlistfive: {
            items: [{
                id: 1,
                title: "39*83mm",
                image: require("./assets/img/five1.jpg"),
                chip: "Impinj WEB M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "7m~15m",
            }, {
                id: 2,
                title: "114*49mm",
                image: require("./assets/img/five2.jpg"),
                chip: "KX2005X-S",
                frequency: "860~960MHz",
                Storage: "EPC 160 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "4m~12m",
            }, {
                id: 3,
                title: "44.45*69.85mm",
                image: require("./assets/img/five3.jpg"),
                chip: "Impinj M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TlD 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, {
                id: 4,
                title: "39*83mm",
                image: require("./assets/img/five4.jpg"),
                chip: "Alien H10",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 48 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "9m~12m",
            }, {
                id: 5,
                title: "114*49mm",
                image: require("./assets/img/five5.jpg"),
                chip: "AD-23xu9",
                frequency: "860~960MHz",
                Storage: "EPC 96 Bits TiD 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "7m~15m",
            }, {
                id: 6,
                title: "44.45*69.85mm",
                image: require("./assets/img/five6.jpg"),
                chip: "Impinj MR6P",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, ]
        },
        productlistsix: {
            items: [{
                id: 1,
                title: "UHF RFID pig ear tag",
                image: require("./assets/img/six1.jpg"),
                frequency: "860~960MHz",
                material: "聚酯型",
                size: "Ф32X13.5mm 厚度5mm",
                Color: "黄色或定制",
                Tensilestrength: "≥450N",
                Operatingtemperature: "-25℃~+70℃(无结冰)",
                readingDistance: "≥2.5m",
            }, {
                id: 2,
                title: "UHF RFID cattle ear tag",
                image: require("./assets/img/six2.jpg"),
                frequency: "860~960MHz",
                material: "聚酯型",
                size: "Ф56*45mm 厚度2mm",
                Color: "黄色",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃~+70℃(无结冰)",
                readingDistance: "≥2.5m",
            }, {
                id: 3,
                title: "39*83mm",
                image: require("./assets/img/six3.jpg"),
                frequency: "860~960MHz",
                material: "聚酯型",
                size: "Ф45X17mm 厚度2mm",
                Color: "黄色或定制",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃~+70℃(无结冰)",
                readingDistance: "≥2.5m",
            }, ]
        },
        productlistsenven: {
            items: [{
                    id: 1,
                    title: "可循环使用硅胶腕带",
                    image: require("./assets/img/wan1.jpg"),
                    chip: "Alien H3/9640",
                    frequency: "902MHZ-928MHZ ",
                    material: "硅胶",
                    weight: "17g",
                    size: "257.5*20.2*9mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "1~1.5m(手持机)",
                },
                {
                    id: 2,
                    title: "可循环使用硅胶腕带",
                    image: require("./assets/img/wan2.jpg"),
                    chip: "NXP U8",
                    frequency: "902MHz-928MHz",
                    material: "硅胶",
                    weight: "16g",
                    size: "248*32*6mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2m",
                }, {
                    id: 3,
                    title: "一次性硅胶腕带",
                    image: require("./assets/img/wan3.jpg"),
                    chip: "Impinj",
                    frequency: "840～960MHZ  ",
                    material: "硅胶",
                    weight: "19 g",
                    size: "260*20*10mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2.6m (30 db手持机) ",
                }, {
                    id: 4,
                    title: "超高频一次性硅胶+织带腕带",
                    image: require("./assets/img/wan4.jpg"),
                    chip: "NXP U8",
                    frequency: "840～960MHz",
                    material: "硅胶+织带",
                    weight: "25 g",
                    size: "塑料盘: 50*40*10mm; 织带：350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30 db手持机) ",
                }, {
                    id: 5,
                    title: "超高频一次性塑料盘+织带腕带",
                    image: require("./assets/img/wan5.jpg"),
                    chip: "NXP U8",
                    frequency: "840MHz～960MHz",
                    material: "塑料盘+织带",
                    weight: "27g",
                    size: "塑料盘: 55*50*10mm; 织带:350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30 db手持机)",
                },
            ]
        },
        newsdetailone: {
            title: '近日，徐州市工信局公示了徐州市2024年度第二批省三、四星级上云企业拟认定名单，经网上申报、初审推荐、专家评审、现场核查、信用审查等程序，江苏海康博瑞电子有限公司成功入选江苏省四星级上云企业。',
            highlight: '值得一提的是，海康博瑞是徐州市鼓楼区2024年度唯一获评四星级上云的企业！',
            description: '省四星级上云企业是指通过互联网技术实现系统与设备信息互通和数据共享，利用云计算资源来实现管理和业务数字化转型的企业，是公司创新能力、经营管理能力、业务能力的直接体现。',
        },
        newsdetailtwo: {
            date: '11月1日',
            title: '海康博瑞迎来高光时刻',
            milestone: 'RFID标签2024年全球累计出货量突破1亿枚',
            milestoneDescription: '这一重要里程碑标志着海康博瑞作为行业的领先的RFID和物联网技术解决方案供应商，以创新的前沿技术和卓越的产品性能，进一步赢得了全球市场的认可。',
            newAchievement: '1亿枚 新成就 新起点',
            achievementDescription: '海康博瑞总经理刘金鹏表示公司取得这一成就是市场、客户、员工共同创造的结果。海康博瑞一直以推动物联网及RFID技术发展为使命，未来RFID芯片还有很大的增长空间，公司将持续加强产品布局，构建多元产品格局，不断打造强劲的产品增长极。获得市场认可的背后离不开海康博瑞多年的专“芯”致志。',
            technologyInnovation: '公司始终坚持围绕技术创新打造差异化市场竞争力。近年来，公司不断加大研发投入，完成了在物联网及RFID产品研发与软件开发领域的核心技术积累，具备成熟的自主研发能力。',
            industryExperience: '目前，厚积薄发的海康博瑞具备成熟的RFID行业应用解决方案研究与开发经验、专业的RFID标签设计与研发人才队伍、领先的RFID标签生产智造基地、全面的RFID模块与读写器产品体系，形成集研发、生产、销售于一体的完整的产业链。',
            customerRecognition: '凭借自身优异的技术实力及产品性能，海康博瑞自主研发的RFID标签产品与定制化物联网解决方案能够及时响应国内外客户的需求，获得全球客户认可，广泛应用于零售、物流、畜牧、医疗等领域。',
            futureVision: '海康博瑞将继续以前瞻性的视野，锁定物联网及RFID技术，向新而行，积极布局未来。',
        },
        newsdetailthree: {
            title: '沙特阿拉伯客户来信致谢',
            subTitle: '原文如下：',
            greeting: '尊敬的Haikangborui团队：',
            content1: '我怀着无限感激之情写下这封邮件，表达我对贵公司在我在中国逗留期间所提供的无微不至的款待与照顾的衷心感谢。',
            content2: '在与贵公司的合作中，我深深感受到了你们的热情和专业。每一位与我接触的贵公司团队成员都展现出非凡的友好与敬业精神，让我感到宾至如归。你们不仅为我提供了舒适的工作环境和高效的支持，还让我了解了中国独特的文化和风俗，让我对这片美丽的土地有了更深的体会和认识。',
            content3: '我衷心感谢贵公司为我提供的一切帮助和支持。贵公司团队的热情款待让我在异国他乡找到了家的温暖，让我在工作之余感受到了更多人间真情和温暖。我将永远珍惜与贵公司建立起的友谊与合作关系，希望未来我们能够继续携手并肩，共同创造更加美好的明天。',
            content4: '再次向贵公司全体员工致以诚挚的感谢和崇高的敬意。希望我们的友谊能够天长地久，业务合作能够蒸蒸日上！',
            closing: '谢谢！',
            closing2: ' 诚挚问候',
        },
        newsdetailfour: {
            title: '10月16日，全市畜禽养殖“防保联动 科技助农”座谈会召开',
            content1: '市农业农村局党委委员、副局长、机关党委书记周伟出席会议并讲话。各县区农业农村局分管领导、防疫站负责人、保险公司代表参加会议。大会旨在为推动“畜牧保险+科技服务支撑”搭建沟通交流的平台。海康博瑞受邀出席会议分享科技助农实践成果。',
            content2: '海康博瑞RFID技术总监齐俊作题为《海康科技助农方案》的分享，结合丰富的行业经验及最新研究成果，详细阐述了海康助农牧云一站式解决方案在科技助农尤其是畜牧保险领域的独特优势及效果评估，为畜牧养殖防疫工作和保险保障体系的完善提供了新的思路与灵感。',
            content3: '交流环节，各保险公司代表提出当前畜牧保险行业的痛点主要集中在流程监管与保险理赔等方面。海康助农牧云解决方案以大数据平台＋智能硬件＋RFID芯片全方位的产品模式，通过技术与行业应用场景的深度融合，满足保险数据治理和运营的核心需求；帮助保险公司快速精准理赔、大大提升养殖业保险的合规性，管控经营风险。',
            content4: '在产品展示区，丰富的耳标产品受到了参会嘉宾的广泛关注，工作人员现场演示智能戴标钳、读写器等智能设备硬件的操作与使用，凭借操作简单、好用易用的特性得到一致的认可与好评。',
            content5: '周伟局长在总结中对在畜牧保险行业开展防保联动的目的及意义做了详细解读，指出各端口要相互配合、统一共识，重视“保险+科技”在畜牧业发展中的重要地位，通过加强科技手段与保险的联动，持续促进产业的良性发展。',
            content6: '解码行业蕴势，探索破局之道。此次大会，海康博瑞不仅展示了强大的技术实力和方案解决能力，也进一步提升了公司在行业中的品牌影响力，为未来的业务扩展打下坚实基础。今后，我们将持续在“防保联动 科技助农”层面进行积极探索与实践，为行业发展贡献更多的智慧与力量。',
        },
        newsdetailfive: {
            "intro1": "RFID电子标签的运用使得产线管理更加智能化，显著提高了工作效率和准确性，同时降低了生产成本和人力投入。",
            "intro2": "RFID电子标签具有体积小、轻便易携带等优点，适用于各种类型的产品。这些标签可以方便地附着在物品表面，或者嵌入产品内部，为每个物品提供唯一的识别码，从而实现精确的追踪和管理。这种技术的应用不仅优化了产线的运作流程，还提高了产品质量和客户满意度。",
            "application": "电子标签在产线管理中的应用",
            "tracking": "1.物品追踪与管理",
            "tracking_desc": "通过RFID电子标签，可以实现对物品的实时追踪和管理。在整个生产过程中，可以通过RFID读写器获取物品的信息，包括进入产线的时间、离开产线的时间、当前所在位置等。通过对物品的追踪，可以提高产线的透明度和可控性，对物料和工艺状态进行有效管理。",
            "automation": "2.自动化生产控制",
            "automation_desc": "RFID电子标签与生产设备相连，可以实现自动化生产控制。通过读取RFID电子标签的信息，生产设备可以自动调整相关参数，实现个性化生产和定制化服务。同时，RFID电子标签可以记录设备运行状态和维护信息，方便设备的检修和维护。",
            "quality": "3.质量追溯与溯源",
            "quality_desc": "RFID电子标签可以记录物品的生产过程和生产环境，实现质量追溯和溯源。在产线管理中，可以通过RFID电子标签获取物品的生产批次、供应商信息、质量检测结果等。一旦发生质量问题，可以快速定位问题原因，采取相应的纠正措施，提高产品质量和供应链管理水平。",
            "advantages": "RFID电子标签助力产线管理智能化的优势",
            "efficiency": "1.提高生产效率",
            "efficiency_desc": "借助RFID电子标签，可以实现生产过程的自动化和数据化。物品在产线上可以自动被扫描和识别，减少了人工操作的时间和错误率。生产过程实现了实时监控和追踪，可以及时发现问题并进行调整，提高了生产效率和生产能力。",
            "cost": "2.降低成本和节约资源",
            "cost_desc": "使用RFID电子标签可以减少人力投入和物料浪费，降低了成本和能源消耗。传统的产线管理需要大量的人工操作和物料处理，而借助RFID电子标签，可以实现自动化和智能化管理，减少了不必要的人工和资源消耗。",
            "product_quality": "3.提升产品质量和安全性",
            "product_quality_desc": "通过RFID电子标签的追溯功能，可以实现对原材料的追踪和质量控制。在生产过程中，可以实时监测物料的质量和温度等关键参数，及时发现异常并采取措施。同时，通过溯源功能，可以追溯到具体的生产环节，提高产品质量和安全性。",
            "supply_chain": "4.优化供应链管理",
            "supply_chain_desc": "RFID电子标签可以实现供应链的全程可视化和动态管理。通过RFID电子标签，可以获取物品在供应链中的实时位置和状态，包括供应商信息、库存情况、运输进度等。基于这些信息，可以优化供应链的配送计划、库存管理和生产调度，提高供应链的灵活性和响应速度。",
            "conclusion": "RFID电子标签对产线管理的智能化起到了至关重要的作用，为企业带来了显著的经济效益和市场竞争优势。随着技术的持续进步和应用领域的不断拓展，RFID电子标签在产线管理领域的潜力将进一步显现，推动产线管理向更高层次的智能化和自动化迈进，为企业带来更大的发展空间和机遇。"
        },
        newsdetailsix: {
            development_reform_innovation: '“发展、改革、创新”，是企业成长过程中永恒不变的话题。',
            many_enterprises_introduce_rfid: '不少大中型企业纷纷引入RFID智慧仓储管理系统，逐步走上了自动化、信息化、智能化之路，助力企业实现转型升级。',
            what_problems_can_rfid_solve: '那么，RFID智慧仓储能帮助企业解决哪些难题？',
            use_rfid_to_improve_efficiency: '利用RFID技术在入库、出库、盘点过程中快速识别的特点，提高仓库核心业务管理的效率，同时大幅节省人力成本。',
            lean_management: '2.精益管理',
            improve_management_accuracy: '改善经营管理，避免人工采集错误的出现，提高业务处理的准确性、管理精度、满足企业精益化管理的需求。',
            cost_saving: '3.节省成本',
            improve_resource_utilization: '提高资源利用率，降低操作的复杂性，并提高对客户的响应速度，降低总体的运营成本。',
            build_new_rfid_system: '使用RFID射频识别技术，构建新的仓储管理信息化系统平台，协调各个环节的运作，保证及时准确的进出库作业和实时透明的库存控制作业，节省劳动力和库存空间，降低运营成本，从而增强企业市场竞争力。',
            system_composition: '系统组成：',
            advantages_of_rfid_in_practice: 'RFID智慧仓储在实际应用中的优势：',
            low_cost_high_efficiency: '1.出入库各个环节，低成本、高效率地采集信息',
            inventory_data_collection: '（1）入库数据采集：鉴于RFID标签的唯一性、RFID设备的群读功能，入库数据的采集变得更加精准、高效，同时简便的操作流程可以降低人工成本。',
            warehouse_inventory_data: '（2）库内盘点数据：批量盘点扫描产品，对数据进行采集、复核，再次确保数据的精确性。',
            outbound_data_collection: '（3）出库数据采集：产品出库进行打包、校核，RFID设备只需一次投入，可以在仓库多环节使用，大大增加了设备使用率。',
            precise_location_management: '2.库位精确定位管理，状态全面监控',
            control_product_information: '每一个产品附着编码唯一的RFID标签，通过RFID便签进行库内盘点，不仅全面把控产品信息，同时精确定位产品位置，充分利用有限的仓库空间，提升仓库的利用效率。',
            warehouse_management_flowchart: '仓储管理流程示意图',
            rfid_system_applications: 'RFID智慧仓储管理系统用途：',
            ensure_data_input_speed: '智慧仓储是物流过程的一个环节，RFID智慧仓储仓储的应用，保证了货物仓库管理各个环节数据输入的速度和准确性，确保企业及时准确地掌握库存的真实数据，合理保持和控制企业库存。',
        },
        newsdetailseven: {
            title1: 'RFID技术在零售业的广泛应用正在推动零售行业向智能、高效、精细化管理转型。它以一种高效的方式，使供应链系统能够更简易、自动地追踪商品动态，让物品实现真正的自动化管理。',
            title2: '此外，RFID还为零售业提供了先进便捷的数据采集方式，便利的顾客交易，高效的运营方式，快速而有洞察力的决策手段等等条码技术无法取代的好处。',
            title3: 'RFID标签在商超零售业的应用主要体现在：',
            item1: '1.库存管理：在商超零售业中，RFID技术主要用于提高库存管理的效率和准确性。通过在商品上贴附RFID标签，利用RFID读取器可以非接触、快速地识别商品的信息，实现库存的快速盘点和实时更新。这大大减少了传统人工盘点的时间和错误率，提高了库存管理的效率。',
            item2: '2.防盗管理：RFID技术也可以用于商超零售业的防盗管理。通过在商品上贴附RFID标签，当商品被非法带出商超时，RFID防盗系统可以自动检测并报警，有效防止商品被盗。',
            item3: '3.销售管理：RFID技术可以用于商超零售业的销售管理。在商品销售过程中，通过RFID读取器可以实时获取商品的销售信息，包括销售数量、销售时间等，从而帮助商超更好地了解销售情况，制定更加合理的销售策略。',
            item4: '4.顾客体验：RFID技术还可以用于提升顾客的购物体验。例如，在商超中设置自助结账系统，顾客可以自己扫描商品上的RFID标签进行结账，无需等待人工结账，提高了结账效率。同时，通过RFID技术还可以实现无人便利店等新型零售模式，为顾客提供更加便捷的购物体验。',
            conclusion: 'RFID标签在零售业的广泛应用正在带来颠覆性的变革，不仅提高了商超的运营效率和准确性，也提升了顾客的购物体验。随着技术的不断革新和普及，RFID在商超零售业的应用必将更加广泛和深入。',
        },
        newsdetaileight: {
            newsTitle: 'RFID不干胶标签',
            newsContent1: 'RFID不干胶标签具有识别速度快、读取方便快捷、芯片容量大、芯片数据可改写、使用寿命长、安全性高等特点，在许多行业发挥着重要作用。',
            newsContent2: 'RFID不干胶标签是一种无源电子标签，由不干胶的底纸、面纸和中间的胶层和RFID Inlay层组成，标签内部可封装不同的射频芯片和天线，产品柔软轻薄，方便粘贴，性价比高。',
            newsContent3: 'RFID不干胶标签材质有合成纸、PET、PVC等，粘贴在包装盒或文件表面，附着力好，耐磨性好，成本低，可在电子标签表面打印产品信息，包括名称、型号、生产日期等。',
            newsContent4: '不干胶材料的表面基材具有多种优势，如易于揭撕、粘性强、使用灵活、耐热、耐潮、不易老化、不污染产品等，使其能够适应各种环境和使用场景。',
            newsSubtitle: 'RFID不干胶标签的行业应用及优势',
            newsContent5: '1、档案/图书管理：在档案图书中贴入RFID不干胶标签，可方便的接收图书信息，进行定位、借出归还登记等，可提高工作效率，避免工作误差。',
            newsContent6: '2、防伪溯源：每个产品都有唯一的RFID电子标签，记录产品从源头厂家到销售终端的所有信息，通过扫描，详尽的信息记录就生成了。',
            newsContent7: '3、生产流水线管理：RFID不干胶标签在生产流水线上可以方便准确地记录工序信息和工艺操作信息，满足柔性化生产需求。对工人工号、时间、操作、质检结果的记录，可以完全实现生产的可追溯性，避免生产环境中手写、眼看信息造成的失误。',
            newsContent8: '4、仓库管理：RFID不干胶标签能有效地解决了仓储货物信息管理，可以实时了解货物位置、存储的情况。对提高仓储效率、指导生产有重要的作用。',
            newsContent9: '5、门店零售管理：RFID不干胶标签支持重复擦写，一般纸质标签价格是固定的，而RFID不干胶电子标签可以更快速的处理商品价格变化，不需要撕毁，直接使用读写器读入更改写入，无需重复投入标签成本，也减少了更换标签的人工成本，工作效率也提高了，即使标签表面的商品信息模糊破损，只要芯片完好，依然可以正确读写，避免了工作疏漏带来的购物纠纷，提升购物体验。',
            newsContent10: 'RFID不干胶标签作为一种便捷的印刷材料，在社会经济生活中发挥着越来越重要的作用。随着市场的不断扩大和技术的不断进步，RFID不干胶标签的市场前景十分广阔，预计将会有更多的创新应用涌现。',
        },
        newsdetailnine: {
            newsTitle: '实力见证！海康博瑞通过省级“专精特新企业”认定',
            newsContent1: '近日，江苏省工业和信息化厅公布了江苏省2024年度省级专精特新企业认定名单，海康博瑞凭借优秀的创新能力和专业的技术实力榜上有名!',
            newsContent2: '“专精特新”中小企业，是具备“专业化、精细化、特色化、新颖化”特征的中小企业，是专注细分市场、市场占有率高、质量效益优的模范企业，同时也是具备持续创新能力并掌握关键核心技术的引领者。',
            newsSubtitle1: '海康博瑞的“专精特新”',
            newsSubtitle2: '专业化深耕',
            newsContent3: '海康博瑞自成立以来，在物联网RFID领域持续深耕，拥有集研发、生产、销售一体的完整产业链。凭借卓越的技术实力，先后荣获“国家高新技术企业”、 省“科技型中小企业”、省“四星级上云企业”等多项科技认证荣誉。',
            newsSubtitle3: '精细化服务',
            newsContent4: '海康博瑞专注于物联网RFID标签、RFID模块与读写器产品、RFID芯片的设计与研发以及RFID行业集成软件的研究和开发，迅速响应全球客户需求，产品与方案服务全球30余个国家与地区。',
            newsSubtitle4: '特色化方案',
            newsContent5: '海康博瑞作为行业领先的RFID及物联网技术解决方案供应商，以市场需求和技术前沿为导向，持续为各行业领域客户提供基于RFID技术的物联网产品和个性化、高价值解决方案。',
            newsSubtitle5: '创新化引领',
            newsContent6: '海康博瑞坚持创新引领，具备成熟的自主研发能力，拥有兼具深厚行业实力与前瞻视野的研发团队，完成了在物联网RFID领域产品研发与软件开发的核心技术积累，以专业创新领先市场。',
            newsContent7: '未来，海康博瑞将持续聚焦物联网RFID技术的研发与创新应用，增强自身核心竞争力，为更多客户提供更高价值的产品和服务。',
        },
        newsdetailten: {
            newsTitle: '开拓海外市场新机遇 寻求合作共赢新发展 ——海康博瑞赴沙特考察',
            newsContent1: '深度拜访海外客户，主动开发国际市场。近日，江苏海康博瑞电子有限公司总经理刘金鹏带队开启沙特客户拜访之行，收获丰硕，为海康博瑞加速海外市场的开拓奠定了坚实的基础。',
            newsContent2: '在数字经济快速发展的背景下，包括沙特在内的中东国家物联网RFID行业发展趋势呈现出强劲的增长潜力。沙特在“2030愿景”中提出“国家转型计划”，支持数字创业、投资数字技术。物联网技术作为其中的重要组成部分，具有巨大的市场潜力和发展前景。',
            newsContent3: '作为深耕物联网RFID领域的专业团队，海康博瑞积极推进海外市场布局，凭借丰富的行业经验以及深厚的技术优势，深受沙特市场青睐。本次沙特之行为期两周，行程紧凑而高效，聚焦关键节点与核心项目，成果显著。',
            newsContent4: '期间，海康博瑞团队先后拜访了沙特当地知名网络运营服务商、RFID解决方案咨询公司、RFID制造服务商等，就当前RFID市场趋势、技术创新、产品需求等议题展开深入的交流与探讨，全面展示了海康博瑞产品与服务的全面性与领先性，进一步增强了客户对海康博瑞的信任和了解，收获了丰富的市场洞察和合作机遇，并针对多个RFID项目达成合作。',
            newsContent5: '此次沙特之行，不仅深化了对当地市场及行业的认知，为海康博瑞海外业务的持续开拓进一步强化了信心，也彰显着我们积极探索海外市场、寻求国际化发展新机遇的积极姿态。',
        },
        newsdetaileleven: {
            newsTitle: '启新岁 赴新篇 赢战2025丨海康博瑞2025迎新年会圆满召开',
            newsContent1: '旧岁已展千重锦，新年再进百尺竿。1月26日，海康博瑞全体员工齐聚一堂，隆重举行2025迎新年会！这不仅是回顾过去、展望未来的重要时刻，更是激发斗志、凝聚力量的关键节点。',
            newsContent2: '昼与夜是时间的双脚，记录着海康博瑞一路走来的足迹。会议伊始，全体员工共同回顾了海康博瑞的发展历程，这些珍贵的记忆不仅记录着公司的成长轨迹，更是全体员工共同奋斗、不断突破的有力见证。',
            newsContent3: '随后，江苏海康博瑞电子有限公司副总经理张侠、销售总监宋池、生产厂长梁磊、技术总监齐俊分享了海康博瑞在研发、生产、经营方面取得的成绩与存在的不足，明确了2025年的奋斗目标。',
            newsContent4: '张总表示，海康博瑞取得今天的成绩离不开大家思想上合心、工作上合力、行动上合拍，同时呼吁全体员工新的一年要坚定目标，补足短板、力争上游，协同一致，取得更加辉煌的成绩。',
            newsContent5: '强化榜样引领，汇聚奋进力量。在分享环节，优秀员工代表真诚地向大家分享了自己在海康博瑞这个优秀平台的成长历程与工作感悟，激励着在场的每一位员工在新的一年里努力奋斗，追求卓越。',
            newsContent6: '优秀员工颁奖盛典将现场气氛推向高潮，大家纷纷登台领奖，公司用满满的诚意回馈大家的一路耕耘，证书和奖杯是对他们努力和奉献的高度认可。这些优秀员工来自不同的部门和岗位，他们以卓越的工作表现、高度的责任心和敬业精神成为全体员工学习的榜样。',
            newsContent7: '随后，江苏海康博瑞电子有限公司总经理刘金鹏总结致辞。刘总对海康博瑞近年的发展做了回顾与总结，他表示，公司在严峻的行业趋势下，依然逆势增长，取得了优异的成绩，背后离不开各位员工的辛勤付出与卓越贡献。',
            newsContent8: '我们对未来充满信心，有能力、也有实力在未来取得更加优异的成绩。同时，刘总为大家送上了新春祝福，也希望大家在新的一年以更加饱满的热情和昂扬的斗志，投入到工作中去，为全新的发展目标共同努力。',
            newsContent9: '此次年会的成功举办，不仅增强了公司内部的凝聚力和向心力，也让每一位员工清晰地感受到了海康博瑞2025前行的方向。相信在公司领导的正确带领下，在全体员工的共同努力下，海康博瑞必将在新的一年里书写更加辉煌的篇章。',
        },
        newsdetailtwelve: {
            newsTitle: '鼓楼区领导走访海康博瑞|送政策、解难题，赋能企业创新发展',
            newsContent1: '5月7日，鼓楼区委书记罗德清，区委副书记程峰，区政府常务副区长刘一等区领导率队深入江苏海康博瑞电子有限公司走访调研，实地了解企业发展状况，面对面倾听诉求建议，助力企业破解发展难题。海康博瑞总经理刘金鹏全程陪同并汇报工作。',
            newsContent2: '座谈交流：聚焦痛点谋发展',
            newsContent3: '在企业会议室，区领导与总经理刘金鹏展开深入交流。罗德清书记首先关切询问企业经营现状、技术研发进展及市场拓展情况，特别关注企业面临的供应链保障、高端人才引进、政策落地衔接等具体问题。刘金鹏总经理详细介绍了公司核心技术优势和未来战略规划，同时坦诚提出当前面临的用地扩容需求、专项政策扶持等发展瓶颈。',
            newsContent4: '实地考察：深入一线送关怀',
            newsContent5: '座谈会后，区领导一行便沿着铺设着浅灰色地砖的开放式办公区步道深入走访。通透的玻璃幕墙映照着 “科技赋能城市生活” 的红色企业愿景标语，在明亮的自然光下格外醒目。开放式办公区里，工程师们专注敲击键盘，此起彼伏的键盘声与远处数据中心设备的嗡鸣声交织成一曲 “科技协奏”。',
            newsContent6: '刘金鹏总经理表示，区领导的走访关怀让企业倍感温暖、信心倍增，加大研发投入，提升核心竞争力，以更优异的成绩回馈社会，为鼓楼区数字经济发展贡献更多力量。',
        },
        newsdetail13: {
            newsTitle: '中沙企业交流|沙特客户到访海康博瑞，夯实国际化合作根基',
            newsContent1: '5月15日，沙特客户代表到访海康博瑞及生产基地参观考察。公司总经理刘金鹏携高层领导热情接待，双方围绕深化合作、共谋发展主题展开深入交流。',
            newsContent2: '客户代表参观生产车间、研发中心与产品展示区，深入了解智能化生产线、质量管控体系及RFID芯片成果，高度认可技术创新。座谈会上，双方围绕战略布局、合作模式等展开探讨，客户期待深化合作。此次交流为拓展国际市场奠定基础。',

        },
        newsdetail14: {
            newsTitle: '科技赋能・政企校共访海康博瑞创新现场',
            newsContent1: '5 月 20 日，江苏师范大学党委书记芮国强率党委办公室主任赵玉苏、国内合作处处长顾振中、党委研究生工作部部长吴迪、学生工作处副处长韩洪政等领导，在区领导陪同下莅临海康博瑞考察交流。海康博瑞总经理刘金鹏热情接待，深入介绍企业发展情况。',
            newsContent2: '在一楼展厅，总经理刘金鹏通过图文展板、实物模型与多媒体演示，生动呈现海康博瑞的发展历程、核心技术及行业应用成果。随后，众人深入生产车间，近距离观摩产品生产工艺，感受智能化生产线的高效运作。参观过程中，区领导不时向江苏师范大学领导介绍海康博瑞在区域科技创新中的示范作用，双方围绕技术研发、生产管理等方面展开深入探讨，对企业发展成果给予高度认可。',
            newsContent3: '此次活动以区领导牵线搭桥为纽带，搭建起高校与企业沟通的桥梁。不仅加深了江苏师范大学对海康博瑞的了解，更为后续深化校企合作、推动产学研融合奠定基础。各方均表示，未来将以此次参观为契机，加强协作，共同为区域经济高质量发展注入科技动能。',
        },
        newsdetail15: {
            newsContent1: '5 月 23 日，徐州市人大工作理论研究会领导张赴宁、冯其谱、袁建芬、周建洪、王立峰率全体理事、会员，在区领导陪同下参观海康博瑞。',
            newsContent2: '海康博瑞总经理刘金鹏热情接待，引领参观团队先后走进企业展厅与生产间。在展厅，刘金鹏详细介绍了企业的发展历程、核心技术及行业创新成果，特别提及自主研发的温感芯片在医疗领域的创新运用。他表示，该芯片通过高精度温度传感技术，可实现对人体体温的实时精准监测，目前已应用于智慧医疗设备，在慢性病管理、术后康复监测等场景中发挥重要作用，有效提升了医疗服务的智能化水平。',
            newsContent3: '步入生产间，现代化的生产设备、严谨的工艺流程和高效的管理模式映入眼帘，刘金鹏就生产规模、质量管控和产能情况等进行细致讲解，让参观人员直观感受到企业的硬核实力与创新活力。',
            newsContent4: '此次参观，为市人大工作理论研究会一行深入了解海康博瑞提供了良好契机，也增进了双方的沟通交流。海康博瑞在技术创新和产业发展上的积极探索，尤其是温感芯片在医疗领域的应用实践，获得了参观人员的肯定与赞赏。',
        },
        newsdetail16: {
            newsContent1: '6月20日，由济宁太白湖新区党工委委员、管委会、新区财政金融局、新区投资促进事务部等部门组成的考察组，莅临江苏海康博瑞进行实地调研，重点了解企业在射频技术领域的技术创新、领先RFID解决方案及智能产业化应用情况，海康博瑞总经理刘金鹏全程陪同，双方就深化产业合作、推动项目落地等事宜进行深入交流。',
            newsContent2: '考察智能制造产线 关注核心技术突破',
            newsContent3: '在智能展厅参观环节，总经理刘金鹏通过"三位一体"展示系统，包括数字化展板、产品原型矩阵及沉浸式全息投影，重点展示企业在智能传感、智能终端研发等领域的创新突破，全方位呈现了核心专利技术矩阵及产业化应用生态（智慧医疗、冷链物流、零售溯源、工业互联网、生态畜牧等多项行业）。',
            newsContent4: '随后，调研考察团移步至海康博瑞生产车间，实地观摩企业智能化产线。在SMT贴装工段，领导们详细了解了全自动生产流程，现场体验了生产过程的实时监控与优化。',
            newsContent5: '加速聚焦产业布局 协同共绘发展蓝图',
            newsContent6: '此次考察交流为两地深化合作奠定了坚实基础，双方就协同发展模式达成共识，标志着海康博瑞全国化战略布局迈出重要一步。未来，双方将继续加强沟通对接，推动合作项目早日落地见效。',
        },
        newsdetail17: {
            newsContent1: '近年来，RFID（射频识别）技术已经从早期的物流追踪工具，逐渐渗透到零售、医疗、制造、智慧城市等多个领域。根据市场研究机构IDTechEx预测，到2032年，全球RFID市场规模将突破400亿美元，年复合增长率（CAGR）超过10%。那么，RFID标签为何会在未来迎来爆发式增长？',
            newsContent2: '一、零售业智能化升级：告别传统条码，迎接“无人零售”时代',
            newsContent3: '传统条码需要逐个扫描，而RFID标签可实现批量读取，大幅提升库存盘点速度。例如，沃尔玛采用RFID后，库存准确率提升至98%，缺货率降低16%。亚马逊Go、阿里“淘咖啡”等无人商店依赖RFID+AI视觉技术，实现“即拿即走”支付。奢侈品（如LV、Gucci）采用RFID防伪标签，消费者可通过手机NFC验证真伪。食品行业（如生鲜、红酒）也借助RFID实现全程溯源，增强品牌信任度。未来，RFID标签将结合动态定价、智能货架，打造更流畅的消费体验。',
            newsContent4: '二、工业4.0与智能制造：RFID成“数字孪生”关键组件',
            newsContent5: '在汽车制造、电子装配等行业，RFID标签可追踪零部件流向，实现生产全流程可视化。例如，特斯拉利用RFID管理电池组装配，错误率降低30%；工业设备（如机床、机器人）嵌入RFID标签，可实时监控运行状态，结合AI预测故障，减少停机损失；RFID使“一物一码”成为可能，支持小批量、多品种生产模式，满足消费者个性化需求（如定制鞋服、3D打印产品）。 ',
            newsContent6: '三、医疗健康：从药品管理到智能穿戴',
            newsContent7: 'FDA要求高值医疗耗材（如心脏支架）必须采用UDI（唯一设备标识），RFID成为最佳解决方案，可减少用药错误和供应链浪费；RFID腕带用于患者身份识别，结合物联网设备实现输液监控、急诊调度，提升医疗安全；未来，柔性RFID标签可集成温度、心率传感器，制成“电子皮肤”，用于慢性病管理（如糖尿病、高血压）。',
            newsContent8: '四、智慧城市与物联网（IoT）：RFID构建“万物互联”基础 ',
            newsContent9: '智能交通与车辆管理 电子车牌（RFID+车牌识别）：实现拥堵费自动扣缴、违章追踪；共享经济：共享单车、充电宝通过RFID优化调度，降低运营成本；垃圾分类与环保监管；智慧农业与畜牧管理，RFID耳标用于牲畜溯源，监测养殖环境（如温湿度、疫情预警），提升农产品附加值。',
            newsContent10: '五、技术突破：成本下降与性能提升',
            newsContent11: '低成本化推动普及，传统RFID标签成本已降，未来5年可能进一步降低。 印刷电子技术（如纳米银墨水）使RFID可直接打印在包装上，减少贴标工序；新一代RFID技术：无源传感RFID：无需电池，通过射频能量采集环境数据（温度、湿度）。UHF RFID远距离识别：读取距离从几米扩展至数十米，适合仓储物流；与AI、区块链融合 ：AI+RFID：优化库存预测（如零售业动态补货）；区块链+RFID：确保供应链数据不可篡改（如钻石、奢侈品溯源）。',
            newsContent12: 'RFID标签的未来——从“可选”到“必选”，过去，RFID因成本较高，而未来，随着技术成熟和规模化生产，它将像二维码一样无处不在。在零售数字化、工业4.0、智慧医疗、智慧城市四大趋势的推动下，RFID标签市场必将迎来高速增长。 ',
            newsContent13: '对于企业而言，尽早布局RFID技术，意味着抢占数据化运营的先机；对于消费者而言，RFID将带来更安全、便捷、智能的生活体验。这场“无声的革命”，才刚刚开始。',
            newsContent14: '（本文部分数据来源：IDTechEx、GS1、沃尔玛供应链报告等）',
        },
        hardone: {
            "performance_params": "性能参数",
            "cpu": "CPU：八核 2.3GHz",
            "ram_rom": "RAM+ROM：4GB + 64GB",
            "expansion_memory": "拓展内存：MicroSD (TF)卡可扩展至256GB",
            "os": "操作系统：Android 11",
            "physical_params": "物理参数",
            "dimensions": "整机尺寸：177.0 x 80.2 x 14.8 mm",
            "weight": "整机重量：626g (含电池)",
            "display": "显示屏 5英寸(带指纹)：1280 x 720 / 6英寸，2160 x 1080",
            "battery": "电池容量：可拆卸 6700mAh / 13400mAh 手柄电池；内置 100mAh 备用电池，支持电池热插拔",
            "camera": "摄像头",
            "front_camera": "前摄像头：500 万像素",
            "rear_camera": "后摄像头：1300 万像素，支持闪光灯",
            "rfid_ghf": "RFID超高频",
            "protocol_standard1": "协议标准：EPCglobal Gen 2 (ISO18000-6C)",
            "protocol_standard2": "协议标准：EPCglobal Gen 2 (ISO18000-6C)",
            "frequency": "工作频率：920-925MHz / 902-928MHz / 865-868MHz",
            "engine": "引擎：CM710-1，基于 Impinj E710 芯片",
            "output_power": "输出功率：1W (30dBm，支持+5~+30dBm可调节)2W (33dBm，用于Latin America等)",
            "antenna_params": "天线参数：圆极化；5dBi",
            "max_read_distance": "最远读卡距离",
            "max_read_distance_5dBi_1": "5dBi :",
            "max_read_distance_5dBi_2": "30m (Impinj MR6标签，尺寸 70 x 15mm)",
            "max_read_distance_5dBi_3": "32m (Impinj M750标签，尺寸 70 x 15mm)",
            "max_read_distance_5dBi_4": "33m (Alian H3 抗金属标签，尺寸 130 x 42mm)",
            "max_read_distance_4dBi_1": "4dBi :",
            "max_read_distance_4dBi_2": "22m (Impinj MR6标签，尺寸 70 x 15mm)",
            "max_read_distance_4dBi_3": "26m (Impinj M750标签，尺寸 70 x 15mm)",
            "max_read_distance_4dBi_4": "27m (Alian H3 抗金属标签，尺寸 130 x 42mm)",
            "read_rate": "群读速率：可达 1300+ 标签/秒 (圆极化)",
            "environment": "使用环境",
            "operating_temperature": "工作温度：-20 °C至50 °C",
            "storage_temperature": "储存温度：-40 °C至70 °C",
            "humidity": "环境湿度：5%RH - 95%RH (无凝结)",
        },
        hardtwo: {
            "hardware-title1": "性能参数",
            "hardware-li1": "CPU：八核 2.3GHz",
            "hardware-li2": "RAM+ROM：8GB+256GB",
            "hardware-li3": "拓展内存：MicroSD (TF)卡可扩展至 256G",
            "hardware-title2": "物理参数",
            "hardware-li4": "整机尺寸：165.0 x 83.8 x 138.0mm",
            "hardware-li5": "整机重量：697g（含电池）",
            "hardware-li6": "电池：主机可拆卸电池 5000mAh",
            "hardware-li7": "手柄可拆卸电池 5200mAh",
            "hardware-li8": "支持 QC3.0 快充和 RTC",
            "hardware-li9": "显示屏：6 英寸高清全面屏，1440 x 720 (18:9)",
            "hardware-li10": "通讯接口：USB Type-C，USB 3.1，OTG",
            "hardware-title3": "摄像头",
            "hardware-li11": "前置摄像头：500万",
            "hardware-li12": "后置摄像头：1600万彩色摄像头，支持自动对焦、闪光灯",
            "hardware-title4": "RFID超高频",
            "hardware-li13": "引擎：基于Impinj E710芯片",
            "hardware-li14": "工作频率：920-925MHz / 902-928MHz / 865-868MHz",
            "hardware-li15": "协议标准：EPC C1 GEN2 / ISO18000-6C",
            "hardware-li16": "天线参数：圆极化天线（4dBi）",
            "hardware-li17": "功率：1 W（30 dBm，支持+5 dBm ~ +30 dBm调节）",
            "hardware-li18": "可选2 W（33 dBm，用于Latin America等）",
            "hardware-li19": "最远读卡距离：26m (Impinj MR6标签，尺寸 70 x 15mm)",
            "hardware-li20": "28m (Impinj M750标签，尺寸 70 x 15mm)",
            "hardware-li21": "30m (Alian H3 抗金属标签，尺寸 130 x 42mm)",
            "hardware-li22": "群读速率：可达 1300+ 标签/秒（圆极化）",
            "hardware-title5": "使用环境",
            "hardware-li23": "工作温度：-20 ℃~+50 ℃",
            "hardware-li24": "储存温度：-40 ℃~+70 ℃",
            "hardware-li25": "环境湿度：5%RH~95%RH（无凝结）",
        },
        hardthree: {
            "hardware-title1": "性能参数",
            "hardware-li1": "MCU类型：Cortex-M3",
            "hardware-li2": "主频：72MHz",
            "hardware-li3": "存储容量5万张标签",
            "hardware-title2": "物理参数",
            "hardware-li4": "整机尺寸：282x117.5x32mm",
            "hardware-li5": "整机重量：334g（含电池）",
            "hardware-li6": "外观材质：塑胶",
            "hardware-li7": "电池容量：电池规格：5200mAh，可拆卸",
            "hardware-li8": "待机时间>70小时（蓝牙连接状态）",
            "hardware-li9": "工作时间6小时左右（UHF群读）",
            "hardware-li10": "充电时间3-4小时（使用标配电源适配器和数据线）",
            "hardware-li11": "显示屏：1.77寸，128X160",
            "hardware-title3": "RFID超高频",
            "hardware-li12": "引擎：基于Impinj E710",
            "hardware-li13": "天线：线极化天线（4dBi）",
            "hardware-li14": "频率：920-925MHz/902-928MHz/865-868MHz",
            "hardware-li15": "协议标准：EPC C1 GEN2 / ISO18000-6C",
            "hardware-li16": "模块功率：1W（30dBm,支持+5~+30dBm可调节）",
            "hardware-li17": "可选2W（33dBm，用于Latin America等）",
            "hardware-title4": "最远读卡距离",
            "hardware-li18": "26m (Impinj MR6标签，尺寸 70 x 15mm)",
            "hardware-li19": "27m (Impinj M750标签，尺寸 70 x 15mm)",
            "hardware-li20": "31m (Alien H3 抗金属标签，尺寸 130 x 42mm)",
            "hardware-li21": "群读速率： 可达 900 标签/秒",
            "hardware-title5": "使用环境",
            "hardware-li22": "工作温度 -20℃~+50℃",
            "hardware-li23": "储存温度 -40℃~+70℃",
            "hardware-li24": "环境湿度 5%RH~95%RH（无凝结）",
        },
        hardfour: {
            hardwareTitle: '机械部分',
            internalDimensions: '内部尺寸：2200*3000*1800',
            externalDimensions: '外部尺寸：2600*3100*2200',
            dimensionsCustomizable: '（尺寸支持定制）',
            electricalTitle: '电气部分',
            powerSource: '电源：单相220V',
            powerConsumption: '功率：1.5KW',
            controlSystem: '控制系统：西门子PLC',
            pcSpecification: 'PC：17寸；8G内存；256G固态硬盘；Win10系统；触控一体机（指纹识别，人脸识别，刷卡可定制）',
            antiCollisionSensor: '防撞光电：SICK背景抑制漫反射感应开关',
            alarmLight: '报警灯：三色+声音',
            rfidTitle: 'RFID部分',
            readerModel: '读写器型号：Impinj R420',
            antennaModel: '天线型号：Laird9028*24',
            detectionQuantity: '检测数量：350枚',
            shieldingMethod: '屏蔽方式：导电布自动卷帘门',
            shieldingPerformance: '屏蔽性能：20公分外无信号外漏',
            shieldingDoorsCustomizable: '（支持单双门定制）',
        },
        hardfive: {
            mechanical_part: '机械部分',
            internal_dimensions: '内部尺寸：1110*1500*1300mm',
            external_dimensions: '外部尺寸：1400*1600*1600mm',
            dimensions_customizable: '（尺寸支持定制）',
            electrical_part: '电气部分',
            power: '电源：单相220V',
            power_consumption: '功率：0.6KW',
            control_system: '控制系统：西门子PLC',
            pc_specifications: 'PC：17寸； 8G内存；256G固态硬盘；Win10系统；触控一体机',
            collision_prevention_sensor: '防撞光电：SICK背景抑制漫反射感应开关',
            alarm_light: '报警灯 ：三色+声音',
            weighing_accuracy: '称重精度：50克（10克可定制）',
            rfid_part: 'RFID部分',
            reader_model: '读写器型号：Impinj R420',
            antenna_model: '天线型号：Laird9028*4',
            detection_quantity: '检测数量：350枚',
            shielding_method: '屏蔽方式：导电布自动卷帘门',
            shielding_performance: '屏蔽性能：20公分外无信号外漏',
            customizable_doors: '（支持单双门定制）',
        },
        hardsix: {
            mechanical: '机械部分',
            channelSize: '通道尺寸：900*830*1600mm',
            conveyorLoad: '输送线承重：50Kg',
            maxCarton: '通过最大纸箱：700*500*550mm',
            conveyorType: '输送线形式：辊筒',
            customizable: '（以上尺寸支持定制）',
            electrical: '电气部分',
            powerSource: '电源：单相220V',
            powerConsumption: '功率：1.5KW',
            controlSystem: '控制系统：西门子PLC',
            pcSpecs: 'PC：17寸；8G内存；256G固态硬盘；Win10系统；触控一体机（指纹识别，人脸识别，刷卡可定制）',
            collisionPhotoelectric: '防撞光电：SICK背景抑制漫反射感应开关',
            baojing: '报警灯：三色+声音',
            rfid: 'RFID部分',
            readerModel: '读写器型号：Impinj R420',
            antennaModel: '天线型号：Laird9028*24',
            detectionQuantity: '检测数量：350枚',
            shieldingMethod: '屏蔽方式：导电布自动卷帘门',
            shieldingPerformance: '屏蔽性能：20公分外无信号外漏',
            customizableDoors: '（支持单双门定制）',
        },
        hardsenven: {
            mechanical_title: "机械部分",
            mechanical_dimensions: "外观尺寸：主体900*960*1800mm",
            mechanical_conveyor_length: "前后输送线长度：1.2m",
            mechanical_conveyor_weight: "输送线承重：50kg",
            mechanical_conveyor_height: "输送线高度：60±5cm",
            mechanical_box_size: "检测箱型尺寸：70*50*55cm Max",
            electrical_title: "电气部分",
            electrical_power: "额定功率：800W",
            electrical_voltage: "工作电压：AC ~220V",
            electrical_computer: "工业电脑： 8G内存，256G固态硬盘，17寸电阻式，触摸显示器",
            rfid_title: "RFID部分",
            rfid_reader: "射频读写器：Impinj R420",
            rfid_antenna: "天线配置：9dBi圆极化天线*4",
            rfid_speed: "检测速度：7-8箱/分钟；",
            rfid_quantity: "检测数量：350件/箱",
            rfid_frequency: "工作频率：920-925MHz",
            environment_title: "使用环境",
            environment_working_temp: "工作温度：-10℃～ +40℃；",
            environment_storage_temp: "存储温度：-20℃～ +80℃",
        },
        hardeight: {
            mechanical_title: "机械部分",
            mechanical_dimensions: "内部尺寸：4200mm*800mm*3600mm",
            mechanical_conveyor_length: "外部尺寸：4720*800*3860",
            electrical_title: "电气部分",
            electrical_power: "电源：单相220V",
            electrical_voltage: "功率：0.4KW",
            electrical_computer: "控制系统：西门子PLC",
            electrical_computer2: "PC：17寸； 8G内存；256G固态硬盘；Win10系统；触控一体机",
            electrical_computer3: "报警灯：三色+声音",
            electrical_computer4: "叉车识别：地磁开关或者雷达",
            rfid_title: "RFID部分",
            rfid_reader: "射频读写器：Impinj R420",
            rfid_antenna: "天线型号：9028*8",
        },
        hardware1: "硬件",
        hardware2: "高性能RFID硬件一站式配齐",
        software1: "软件",
        software2: "专业高效的数字化软件平台",
    },
    ar: {
        productlistone: {
            items: [{
                id: 1,
                title: "UHF 42*16mm",
                image: require("./assets/img/one1.jpg"),
                chip: "NXPU9/Impinj MR6",
                AntennaSize: "42*16mm",
                ProductSize: "44*19mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "6.5m~9m",
            }, {
                id: 2,
                title: "UHF 70*14mm",
                image: require("./assets/img/one2.jpg"),
                chip: "NXPU9/Impinj M730 lmpinj M750",
                AntennaSize: "70*14mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "10m~16m",
            }, {
                id: 3,
                title: "UHF 30*50mm",
                image: require("./assets/img/one3.jpg"),
                chip: "NXPU9/lmpinjM730/Kiloway",
                AntennaSize: "30*50mm",
                ProductSize: "34*54mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "11.5m~16m",
            }, {
                id: 4,
                title: "UHF 95*3mm",
                image: require("./assets/img/one4.jpg"),
                chip: "NXPU9/Alien H10",
                AntennaSize: "95*3mm",
                ProductSize: "125*7mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~15m",
            }, {
                id: 5,
                title: "UHF 10*27mm",
                image: require("./assets/img/one5.jpg"),
                chip: "NXPU9",
                AntennaSize: "10*27mm",
                ProductSize: "30*14mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "3m~4.5m",
            }, {
                id: 6,
                title: "UHF 44*44MM",
                image: require("./assets/img/one6.jpg"),
                chip: "Impinj M4E",
                AntennaSize: "44*44mm",
                ProductSize: "50*50mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "3m~7m",
            }, {
                id: 7,
                title: "UHF 11*42mm",
                image: require("./assets/img/one7.jpg"),
                chip: "NXPU9",
                AntennaSize: "11*42mm",
                ProductSize: "11*42mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "2m~3.5m",
            }, {
                id: 8,
                title: "UHF 15*40mm",
                image: require("./assets/img/one8.jpg"),
                chip: "NXPU9/ImpinjMR6P",
                AntennaSize: "15*40mm",
                ProductSize: "44*19mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~9m",
            }, {
                id: 9,
                title: "UHF 70*17mm",
                image: require("./assets/img/one9.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*17mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "9m~12m",
            }, {
                id: 10,
                title: "UHF 70*15mm",
                image: require("./assets/img/one10.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "70*15mm",
                ProductSize: "76*20mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "8m~17m",
            }, {
                id: 11,
                title: "UHF 19*93mm",
                image: require("./assets/img/one11.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "19*93mm",
                ProductSize: "97*25mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "5m~12m",
            }, {
                id: 12,
                title: "UHF 8.15*94.8mm",
                image: require("./assets/img/one12.jpg"),
                chip: "Alien H3/Alien H9",
                AntennaSize: "8.15*94.8mm",
                ProductSize: "100*15mm or customized",
                material: "PET or Coated Paper",
                frequency: "860~960MHz",
                readingDistance: "10m~12m",
            }, {
                id: 13,
                title: "HF calibre 22mm",
                image: require("./assets/img/one13.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "calibre 22mm ",
                ProductSize: "calibre 25mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "30cm~50cm",
            }, {
                id: 14,
                title: "HF calibre15mm",
                image: require("./assets/img/one14.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "calibre 15mm",
                ProductSize: "calibre 18mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "5cm~15cm",
            }, {
                id: 15,
                title: "HF 76*45mm",
                image: require("./assets/img/one15.jpg"),
                chip: "NTAG213/FM11RF08",
                AntennaSize: "76*45mm",
                ProductSize: "86*54mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, {
                id: 16,
                title: "HF 45*45mm",
                image: require("./assets/img/one16.jpg"),
                chip: "ICODE-SLIX/F01N",
                AntennaSize: "45*45mm",
                ProductSize: "50*50mm or customized",
                material: "PET or Coated Paper",
                frequency: "13.56MHz",
                readingDistance: "50cm~80cm",
            }, ]
        },
        productlisttwo: {
            items: [{
                id: 1,
                title: "60*25*1.25mm",
                image: require("./assets/img/two1.jpg"),
                chip: "NXP UCODE 8",
                frequency: "920-925MHz",
                Storage: "TID 96bits EPC 128bits",
                ApplicationSurface: "Metal Surface",
                size: "60*25*1.25mm",
                readingDistance: "Fixed: 650cm; Handheld: 500cm",
            }, {
                id: 2,
                title: "60x6x1.0mm",
                image: require("./assets/img/two2.jpg"),
                chip: "NXP UCODE 8",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "EPC128bits User 0bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "60x6x1.0mm",
                readingDistance: "Fixed: 200cm; Handheld: 130cm",
            }, {
                id: 3,
                title: "70x18x1.0mm",
                image: require("./assets/img/two3.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "EPC128bits User 0bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "70x18x1.0mm",
                readingDistance: "Fixed: 400cm; Handheld: 280cm",
            }, {
                id: 4,
                title: "98x42x1.0mm",
                image: require("./assets/img/two4.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHZ:EU865-868MHz",
                Storage: "TlD128bits  User 64bits EPC 96bits",
                ApplicationSurface: "Metal Surface",
                size: "98x42x1.0mm",
                readingDistance: "Fixed: 600cm; Handheld: 600cm",
            }, {
                id: 5,
                title: "60*25*1.25mm",
                image: require("./assets/img/two5.jpg"),
                chip: "Qstar-73GB",
                frequency: "920-925MHz",
                Storage: "TlD128bits  User 512bits EPC 160bits",
                ApplicationSurface: "Metal Surface",
                size: "60*25*1.25mm",
                readingDistance: "Fixed: 520cm; Handheld: 400cm",
            }, {
                id: 6,
                title: "60x24x1.2mm",
                image: require("./assets/img/two6.jpg"),
                chip: "NXP U CODE 8",
                frequency: "US902-928MHz",
                Storage: "EPC 128 bits",
                ApplicationSurface: "Metal Surface",
                size: "60x24x1.2mm",
                readingDistance: "Fixed: 270cm; Handheld: 130cm",
            }, {
                id: 7,
                title: "45x8x1.0mm",
                image: require("./assets/img/two7.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHz；EU865-868MHz",
                Storage: "EPC 128bits  User 64bits TlD96bits",
                ApplicationSurface: "Metal Surface",
                size: "45x8x1.0mm",
                readingDistance: "Fixed: 150cm; Handheld: 100cm",
            }, {
                id: 8,
                title: "45x18x1.0mm",
                image: require("./assets/img/two8.jpg"),
                chip: "lmpinj Monza R6-P",
                frequency: "US902-928MHz；EU865-868MHz",
                Storage: "TlD128bits User 64bits EPC 96bits",
                ApplicationSurface: "Metal Surface",
                size: "45x18x1.0mm",
                readingDistance: "Fixed: 250cm; Handheld: 140cm",
            }, ]
        },
        productlistthree: {
            items: [{
                id: 1,
                title: "6*3*T3.0",
                image: require("./assets/img/three1.jpg"),
                Size: "6*3*T3.0",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-928MHz 85cm  EU：865-868MHz 80cm ",
                Readingdistance2: "Handheld Reader US：902-928MHz 50cm  EU：865-868MHz 45cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 2,
                title: "10*4*T3.0",
                image: require("./assets/img/three2.jpg"),
                Size: "10*4*T3.0",
                Installation: "Backing or screws",
                Frequency: "US：902-925MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 135cm  EU：865-868MHz 135cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 90cm  EU：865-868MHz 75cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 3,
                title: "calibre 10*T3.7",
                image: require("./assets/img/three3.jpg"),
                Size: "calibre 10*T3.7",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 150cm  EU：865-868MHz 130cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 100cm  EU：865-868MHz 95cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.5g",
            }, {
                id: 4,
                title: "12*4*T1.5",
                image: require("./assets/img/three4.jpg"),
                Size: "12*4*T1.5",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "NXP U8",
                Storage: "EPC 128bit  TID96bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 150cm  EU：865-868MHz 150cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 60cm  EU：865-868MHz 60cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.2g",
            }, {
                id: 5,
                title: "calibre 20*T2.8",
                image: require("./assets/img/three5.jpg"),
                Size: "calibre 20*T2.8",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 320cm  EU：865-868MHz 280cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 240cm  EU：865-868MHz 230cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "1.9g",
            }, {
                id: 6,
                title: "30*5*T2.8",
                image: require("./assets/img/three6.jpg"),
                Size: "30*5*T2.8",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 310cm  EU：865-868MHz 280cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 210cm  EU：865-868MHz 200cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "0.8g",
            }, {
                id: 7,
                title: "36*13*T3.5",
                image: require("./assets/img/three7.jpg"),
                Size: "36*13*T3.5",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 470cm  EU：865-868MHz 450cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 270cm  EU：865-868MHz 250cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "4.2g",
            }, {
                id: 8,
                title: "calibre40*T3.0",
                image: require("./assets/img/three8.jpg"),
                Size: "calibre40*T3.0",
                Installation: "Backing",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "IMPINJ RG-P",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 680cm  EU：865-868MHz 650cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 350cm  EU：865-868MHz 350cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, {
                id: 9,
                title: "90*20*T3.7",
                image: require("./assets/img/three9.jpg"),
                Size: "90*20*T3.7",
                Installation: "Backing or screws",
                Frequency: "US：902-928MHz  EU：865-868MHz",
                Chip: "Alien Higgs-3 or NXP U8",
                Storage: "EPC 96bits (expandable to 480bits) User  512bits TID 64bits",
                Readingdistance: "Fixed Reader：US：902-925MHz 1080cm  EU：865-868MHz 1050cm",
                Readingdistance2: "Handheld Reader US：902-925MHz 650cm  EU：865-868MHz 630cm",
                Operatingtemperature: "-40℃-100℃",
                Weight: "8.2g",
            }, ]
        },
        productlistfour: {
            items: [{
                id: 1,
                title: "70*15*1.5mm",
                image: require("./assets/img/four1.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "70*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 2,
                title: "70*10*1.5mm",
                image: require("./assets/img/four2.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "70*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 3,
                title: "35*15*1.5mm",
                image: require("./assets/img/four3.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "35*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 4,
                title: "86*16*1.5mm",
                image: require("./assets/img/four4.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "86*16*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 5,
                title: "58*15*1.5mm",
                image: require("./assets/img/four5.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "58*15*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, {
                id: 6,
                title: "60*20*1.5mm",
                image: require("./assets/img/four6.jpg"),
                chip: "NXP Ucode9",
                frequency: "865~940MHz",
                Storage: "EPC 96 bits, User 0 bits",
                material: "Non-woven fabric",
                size: "60*20*1.5mm",
                readingDistance: "Fixed:≥6m; handheld:≥3m",
            }, ]
        },
        productlistfive: {
            items: [{
                id: 1,
                title: "39*83mm",
                image: require("./assets/img/five1.jpg"),
                chip: "Impinj WEB M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "7m~15m",
            }, {
                id: 2,
                title: "114*49mm",
                image: require("./assets/img/five2.jpg"),
                chip: "KX2005X-S",
                frequency: "860~960MHz",
                Storage: "EPC 160 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "4m~12m",
            }, {
                id: 3,
                title: "44.45*69.85mm",
                image: require("./assets/img/five3.jpg"),
                chip: "Impinj M730",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TlD 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, {
                id: 4,
                title: "39*83mm",
                image: require("./assets/img/five4.jpg"),
                chip: "Alien H10",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 48 Bits",
                material: "PET(50μm)",
                size: "39*83mm",
                readingDistance: "9m~12m",
            }, {
                id: 5,
                title: "114*49mm",
                image: require("./assets/img/five5.jpg"),
                chip: "AD-23xu9",
                frequency: "860~960MHz",
                Storage: "EPC 96 Bits TiD 96 Bits",
                material: "PET(50μm)",
                size: "114*49mm",
                readingDistance: "7m~15m",
            }, {
                id: 6,
                title: "44.45*69.85mm",
                image: require("./assets/img/five6.jpg"),
                chip: "Impinj MR6P",
                frequency: "860~960MHz",
                Storage: "EPC 128 Bits TID 96 Bits",
                material: "PET(50μm)",
                size: "44.45*69.85mm",
                readingDistance: "7m~15m",
            }, ]
        },
        productlistsix: {
            items: [{
                id: 1,
                title: "UHF RFID pig ear tag",
                image: require("./assets/img/six1.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф32*13.5mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: "≥450N",
                Operatingtemperature: "-25℃~+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, {
                id: 2,
                title: "UHF RFID cattle ear tag",
                image: require("./assets/img/six2.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф56*45mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, {
                id: 3,
                title: "39*83mm",
                image: require("./assets/img/six3.jpg"),
                frequency: "860~960MHz",
                material: "TPU",
                size: "Ф45*17mm Thickness 2mm",
                Color: "yellow or customized",
                Tensilestrength: ">450N",
                Operatingtemperature: "-25℃+70℃（no icing）",
                readingDistance: "≥2.5m",
            }, ]
        },
        productlistsenven: {
            items: [{
                    id: 1,
                    title: "Recyclable silicone wristband",
                    image: require("./assets/img/wan1.jpg"),
                    chip: "Alien H3/9640",
                    frequency: "902MHZ-928MHZ ",
                    material: "Silicone",
                    weight: "17g",
                    size: "257.5*20.2*9mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "1~1.5m(handset reader)",
                },
                {
                    id: 2,
                    title: "Recyclable silicone wristband",
                    image: require("./assets/img/wan2.jpg"),
                    chip: "NXP U8",
                    frequency: "902MHz-928MHz",
                    material: "Silicone",
                    weight: "16g",
                    size: "248*32*6mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2m",
                }, {
                    id: 3,
                    title: " Disposable silicone wristbands",
                    image: require("./assets/img/wan3.jpg"),
                    chip: "Impinj",
                    frequency: "840～960MHZ  ",
                    material: "Silicone",
                    weight: "19 g",
                    size: "260*20*10mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "2.6m (30db handset reader)",
                }, {
                    id: 4,
                    title: "UHF disposable silicone + fabric tape wristbands",
                    image: require("./assets/img/wan4.jpg"),
                    chip: "NXP U8",
                    frequency: "840～960MHz",
                    material: "Silicone + Fabric tape",
                    weight: "25 g",
                    size: "Tray: 50*40*10mm; Fabric tape：350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30db handset reader) ",
                }, {
                    id: 5,
                    title: "UHF disposable plastic tray + fabric tape wristbands",
                    image: require("./assets/img/wan5.jpg"),
                    chip: "NXP U8",
                    frequency: "840MHz～960MHz",
                    material: "Plastic tray + fabric tape",
                    weight: "27g",
                    size: "Plastic tray: 55*50*10mm; Fabric tape:350*20*0.7mm",
                    Operatingtemperature: "-20℃～+120º℃",
                    readingDistance: "4m (30db handset reader)",
                },
            ]
        },
        "footertitile": "جميع الحقوق محفوظة © لشركة جيانغسو هايكانغ بوروي للإلكترونيات المحدودة. رقم تسجيل ICP: Su ICP Bei 19071766-0",
        "menu": "القائمة",
        "adress": "المبنى 2، جينغران مينغجو، مقاطعة يونلونغ، شوتشو، جيانغسو، الصين",
        "home": "الرئيسية",
        "Viewdocument": "عرض المستند",
        "Viewdocument2": "مقدمة عن منتج HIKBOREI",
        "Technical": "الوثائق التقنية",
        "productsdectitle": "تفاصيل المنتج",
        "newsdectitle": "تفاصيل الأخبار",
        "solutions": "الحلول",
        "solutionssub1": "إدارة الأصول",
        "solutionssub2": "إدارة شؤون الموظفين في المعارض",
        "solutionssub3": "إدارة المكتبات",
        "solutionssub4": "إدارة تربية الحيوانات",
        "products": "المنتجات",
        "productssub1": "علامات RFID",
        "productssub2": "الأجهزة الذكية",
        "productssub3": "منصات البرمجيات",
        "support": "الدعم",
        "ServiceProcess1": "عملية الخدمة",
        "ServiceProcess2": "تحليل وتصميم المتطلبات",
        "ServiceProcess3": "التنفيذ والنشر",
        "ServiceProcess4": "التشغيل والتحسين",
        "ServiceProcess5": "فرز وتحليل المتطلبات",
        "ServiceProcess6": "خدمات استشارية احترافية",
        "ServiceProcess7": "خدمات التحقق من المتطلبات",
        "ServiceProcess8": "تواصل معمق معكم لتحديد الاحتياجات الأساسية وتقييم الجدوى",
        "ServiceProcess9": "توفير حلول RFID موثوقة بناءً على أفضل ممارسات الصناعة والمعرفة المهنية",
        "ServiceProcess10": "التعاون معك لتأكيد متطلبات المخطط للدقة بشكل متكرر",
        "ServiceProcess11": "عملية التنفيذ",
        "ServiceProcess12": "المساعدة في القبول",
        "ServiceProcess13": "التدريب المهني",
        "ServiceProcess14": "تركيب أجهزة RFID الذكية وتطوير البرامج وفقًا للمتطلبات",
        "ServiceProcess15": "يساعدك الموظفون المحترفون في القبول الوظيفي والأداء وتصحيحه حسب الحاجة",
        "ServiceProcess16": "توفير التدريب المهني للموظفين المعنيين لضمان الاستخدام الكفء للحل في السيناريوهات الحقيقية",
        "ServiceProcess17": "تتبع المشكلة",
        "ServiceProcess18": "تحسين الأداء",
        "ServiceProcess19": "توفير خط ساخن للدعم الفني لضمان الاستجابة السريعة والحل في الوقت المناسب للمشكلات في تطبيق الحل",
        "ServiceProcess20": "متابعة تشغيل البرنامج وملاحظات المستخدمين وتحديث وتحسين أداء البرنامج",
        "ServiceProcess21": "إذا كنت ترغب في معرفة المزيد عن منتجاتنا وحلول ، فيرجى ملء النموذج وسوف نقوم بترتيب اتصال أحد المتخصصين بك قريبًا",
        "ServiceProcess22": "اسم الشركة",
        "ServiceProcess23": "جهة الاتصال",
        "ServiceProcess24": "معلومات الاتصال",
        "ServiceProcess25": "متطلباتك",
        "ServiceProcess26": "إرسال",
        "news": "أخبار",
        "about": "نبذة عنا",
        "slidetitle": "RFIDمزود حلول إنترنت الأشياء الذكية التي تركز على تقنية ",
        "slidesubtitle": "",
        "slidebuttonText": "عرض التفاصيل",
        "solutiontitle": "للقطاعات RFID حلول",
        "serviceprovider": "وإنترنت الأشياء RFID المزود الرائد لحلول تقنية",
        "producttitle": "مركز المنتجات",
        "cooperativetitle": "الشركاء",
        "homedec": "تأسست شركة جيانغسو هايكانغ بوروي للإلكترونيات المحدودة (HIKBOREI) من قِبل شركة تابعة لمجموعة سيثيك. تركز الشركة على علامات RFID لإنترنت الأشياء، ووحدات RFID، ومنتجات القراءة والكتابة، وتصميم وتطوير شرائح RFID، بالإضافة إلى البحث والتطوير في برامج تكامل صناعة RFID، وهي مزوّد حلول تطبيقات RFID. تلتزم HIKBOREI ببناء منطقة هوايهاي الصناعية لإنترنت الأشياء RFID، وهي شركة إنترنت أشياء عالية التقنية ذات آفاق سوقية واسعة ومجال تطوير واسع.",
        "serviceprovidertitle.label1": "تتجاوز القدرة الإنتاجية السنوية للملصقات 800 مليون",
        "serviceprovidertitle.label2": "يتجاوز عدد العملاء التعاونيين الاستراتيجيين للعلامات التجارية 500",
        "serviceprovidertitle.label3": "تجاوز عدد عملاء خدمة حلول الصناعة 100",
        "serviceprovidertitle.label4": "تغطية الأعمال في أكثر من 30 دولة ومنطقة",
        "serviceprovidertitle.dec1": "مليار+",
        "serviceprovidertitle.dec2": "+",
        "bannertitle": "الخدمة والدعم",
        "bannerdescription": "لدينا فريق خدمة محترف يقدم نظام خدمة متكامل يغطي استشارات المنتج/الحل، والعرض التوضيحي، والتطوير والنشر، وتدريب المستخدم، مما يساعدك على بدء تجربتك الرقمية بسهولة.",
        "newbannertitle": "الأخبار والتحديثات",
        "newbannerdescription": "تزويدك بأحدث الأخبار والمعلومات حول HIKBOREI",
        "aboutbannertitle": "معلومات عنا",
        "aboutbannerdescription": "وإنترنت الأشياء RFID المزود الرائد لحلول تقنية",
        "companyprofile": "نبذة عن الشركة",
        "companyIntroduction": "تأسست شركة جيانغسو هايكانغ بوروي للإلكترونيات المحدودة (HIKBOREI) من قِبل شركة تابعة لمجموعة سيثيك. تركز الشركة على علامات RFID لإنترنت الأشياء، ووحدات RFID، ومنتجات القراءة والكتابة، وتصميم وتطوير شرائح RFID، بالإضافة إلى البحث والتطوير في برامج تكامل صناعة RFID، وهي مزوّد حلول تطبيقات RFID. تلتزم HIKBOREI ببناء منطقة هوايهاي الصناعية لإنترنت الأشياء RFID، وهي شركة إنترنت أشياء عالية التقنية ذات آفاق سوقية واسعة ومجال تطوير واسع.",
        "capacity": "800 مليون+: القدرة الإنتاجية السنوية لأكثر من 800 مليون علامة",
        "strategicPartners": "500+: أكثر من 500 شريك استراتيجي لحلول العلامات",
        "industrySolutions": "أكثر من 100: تم تقديم الخدمات لأكثر من 100 عميل بحلول خاصة بالصناعة",
        "globalCoverage": "30+: تغطية الأعمال في أكثر من 30 دولة ومنطقة حول العالم",
        "technologyCombination": "بفضل البحث والابتكار التكنولوجي المستمر، تجمع HIKBOREI بسلاسة بين قدراتها القوية في البحث والتطوير والتصنيع لعلامات RFID مع تقنيات إنترنت الأشياء والبيانات الضخمة لتوفير حلول عالية القيمة لإدارة الأصول وإدارة الثروة الحيوانية وإدارة المكتبات والرعاية الصحية الذكية والتخزين والخدمات اللوجستية ومكافحة التزييف والتتبع والمزيد.",
        "smartProductionBase": "قاعدة إنتاج RFID الذكية",
        "productionBaseDescription": "تقع قاعدة إنتاج Hikborei RFID في حديقة صناعة أشباه الموصلات في منطقة Gulou ، مدينة Xuzhou ، مقاطعة Jiangsu ، وتغطي مساحة 15000 متر مربع. يغطي المصنع مساحة 8000 متر مربع وأكمل بناء ورشة عمل نظيفة بمستوى 100000 وصالة عرض ذكية للمؤسسة ومستودع ذكي. لديها معدات إنتاج متقدمة مثل الربط والتركيب ، وكذلك معدات فحص الجودة ، لتلبية إنتاج علامات RFID المختلفة (NFC ، التردد المنخفض ، التردد العالي ، التردد العالي للغاية).",
        "honors": "الأوسمة والجوائز",
        "partners": "الشركاء",
        "contactUs": "تواصل معنا",
        "phone": "الهاتف: 0516-8300 0001",
        "marketingDepartment": "قسم التسويق: 19961919596+86",
        "salesDepartment": "قسم المبيعات: 19051668932+86",
        "WhatsApp": "واتساب",
        "WhatsApp2": "واتساب",
        "email": "info@haikangborui.com :البريد الإلكتروني",
        "address": "العنوان: مجمع شوتشو غولو الصناعي لأشباه الموصلات، مقاطعة جيانغسو",
        WhatsAppvalue: "+86 193 0573 0833",
        WhatsApp2value: " +86 175 9736 3813",
        "codedec": "امسح رمز الاستجابة السريعة للتواصل معنا",
        "companyNews": "أخبار الشركة",
        "industryNews": "أخبار الصناعة",
        "newsTitle": "عنوان الخبر",
        "newsSummary": "ملخص الخبر",
        "newsTime": "وقت الخبر",
        "Solutiondec1": "رؤى الصناعة",
        "Solutiondec2": "تحديات الأعمال",
        "Solutiondec3": "هندسة الحلول",
        "Solutiondec4": "سيناريوهات التطبيق",
        "Solutiondec5": "قيمة التطبيق",
        "Solutiondec6": "منتجات التطبيق",
        "Solutiondec7": "تتواجد أصول المؤسسة بكميات كبيرة وأنواع متنوعة وانتشار واسع، وتفتقر إلى أساليب إدارة متطورة، مما يؤدي إلى هدر الأصول وخمولها وانخفاض كفاءة الاستخدام.",
        "Solutiondec337": "توفر HIKBOREI حلاً كاملاً يغطي الأجهزة والبرامج الاحترافية وعلامات RFID والخدمات، مما يحقق تسجيل الأصول السريع والمخزون الفعال والإدارة السهلة باستخدام \"عنصر واحد، رمز واحد\"",
        "Solutiondec8": "عملية إدارة غير منظمة",
        "Solutiondec9": "كفاءة المخزون المنخفضة",
        "Solutiondec10": "صعوبة في تتبع الحالة",
        "Solutiondec11": "انخفاض استخدام الأصول",
        "Solutiondec12": "السجلات الورقية التقليدية غير فعالة، ويصعب تحديثها، وعرضة للأخطاء",
        "Solutiondec13": "إن عبء العمل على المخزون ثقيل، والوضع التقليدي بطيء، وغالبًا ما تحدث أخطاء مثل المخزون الخاطئ أو المخزون المفقود",
        "Solutiondec14": "في ظل أساليب الإدارة التقليدية، لا تحدث تغييرات في حالة الأصول في الوقت المناسب، ومن السهل إغفالها وارتكاب الأخطاء",
        "Solutiondec15": "التخصيص والنقل غير الفعال للأصول، مما يؤدي إلى حالات خطيرة من المشتريات الزائدة والأصول الخاملة",
        "Solutiondec16": "توفر HIKBOREI مجموعة كاملة من الحلول التي تغطي الأجهزة والبرامج الاحترافية وعلامات RFID والخدمات، مما يحقق تسجيل الأصول السريع والمخزون الفعال والإدارة السهلة من خلال \"كائن واحد، رمز واحد\"",
        "Solutiondec17": "إدخال الأصول",
        "Solutiondec18": "جرد الأصول",
        "Solutiondec19": "إدارة الأصول",
        "Solutiondec20": "استيراد/إنشاء دفتر أصول دفعة واحدة",
        "Solutiondec21": "جرد الدفعات/جرد غير متصل/جرد متزامن لأكثر من شخص",
        "Solutiondec22": "إدارة دورة الحياة الكاملة/الاستهلاك/التقارير المتنوعة/عمليات الموافقة المخصصة",
        "Solutiondec23": "زيادة كفاءة الإدارة بنسبة ٦٠٪",
        "Solutiondec24": "انخفاض تكلفة المخزون بنسبة ٧٥٪",
        "Solutiondec25": "زيادة استخدام الأصول بنسبة ٦٠٪",
        "Solutiondec26": "تم تخفيض التناقض بين الحسابات والأصول الفعلية بنسبة 80٪",
        "Solutiondec27": "بطاقة RFID",
        "Solutiondec28": "جهاز محمول",
        "Solutiondec29": "طابعة ملصقات",
        "Solutiondec30": "بوابة أمنية",
        "Solutiondec31": "علامات RFID المتنوعة، بما في ذلك الملصقات اللاصقة، وملصقات PET، والملصقات المضادة للمعادن، وما إلى ذلك.",
        "Solutiondec32": "مسافة القراءة 5-8 أمتار، واستكمال جرد الأصول بكفاءة",
        "Solutiondec33": "وظيفية بالكامل، وتلبي احتياجات أغراض طباعة الملصقات المختلفة",
        "Solutiondec34": "مراقبة وتتبع معلومات تغيير الأصول في الوقت الفعلي",
        "Solutiondec35": "في المعارض التجارية أو الفعاليات الكبيرة، ومع العدد الهائل من الحضور، لم تعد أساليب الإدارة التقليدية قادرة على تلبية احتياجات المعارض الحديثة. وكثيرًا ما تواجه هذه المعارض مشاكل مثل ازدحام الحشود وإهمال تسجيل الدخول، مما يعجز عن تحقيق إدارة فعالة للموظفين.",
        "Solutiondec36": "تجربة سيئة للمشاركين",
        "Solutiondec37": "تسجيل بيانات غير دقيق",
        "Solutiondec38": "كفاءة منخفضة في إدارة الموظفين",
        "Solutiondec39": "نقص في تغذية راجعة للبيانات",
        "Solutiondec40": "عملية تسجيل دخول معقدة، ووقت انتظار طويل",
        "Solutiondec41": "إحصائيات الأرقام غير كاملة، ومعلومات الهوية غير واضحة",
        "Solutiondec42": "عدم القدرة على تحقيق إدارة ديناميكية للموظفين، ونقص التغذية الراجعة الفعالة للبيانات",
        "Solutiondec43": "غير قادر على تكوين بيانات إحصائيات فعالة للحدث",
        "Solutiondec44": "تستخدم شركة HIKBOREI تقنية RFID كأساس، حيث تجمع بين أساور RFID وتحليل البيانات والوسائل التقنية الأخرى لتحقيق المراقبة في الوقت الفعلي والإدارة الذكية للعملية بأكملها والسيناريوهات وجميع الموظفين في الحدث",
        "Solutiondec45": "تسجيل الموظفين",
        "Solutiondec46": "إدارة الموظفين",
        "Solutiondec47": "إدارة العقد",
        "Solutiondec48": "تحليل البيانات",
        "Solutiondec49": "تسجيل وصول سريع/إحصاء الأفراد/تأكيد الهوية والفحص الأمني",
        "Solutiondec50": "تتبع الموقع/المرور السريع عبر نقطة التفتيش/تقييد هوية المنطقة",
        "Solutiondec51": "معلومات إحصائية عن المشاركين في كل عقدة حدث",
        "Solutiondec52": "خريطة حرارية للمنطقة/مسار تاريخي، بيانات تاريخية قابلة للاستعلام",
        "Solutiondec53": "تعزيز الأمان",
        "Solutiondec54": "تحسين تجربة المشاركين",
        "Solutiondec55": "تحسين كفاءة الإدارة",
        "Solutiondec56": "توفير دعم البيانات",
        "Solutiondec57": "من خلال تأكيد الهوية والتحكم في المنطقة، يتم تحذير المخاطر الأمنية المحتملة، مما يحسن أمن المعرض",
        "Solutiondec58": "يقلل من وقت الانتظار وعملية التشغيل في رابط تسجيل الوصول، مما يعزز تجربة المشاركين",
        "Solutiondec59": "يقلل من العمليات اليدوية، مما يحقق إدارة ذكية ومتطورة للموظفين",
        "Solutiondec60": "يجمع البيانات حول أنماط سلوك المشاركين لتوفير دعم قوي لتخصيص الموارد المستقبلية وإدارة المكان",
        "Solutiondec61": "سوار RFID",
        "Solutiondec62": "جهاز محمول",
        "Solutiondec63": "تصميم خفيف الوزن، مريح في الارتداء، مما يحسن كفاءة التعرف على المعلومات",
        "Solutiondec64": "قراءة سريعة ودقيقة لمعلومات سوار المعصم RFID، أقصى مسافة قراءة 30 مترًا",
        "Solutiondec65": "إن معلومات أدبيات المكتبة كبيرة في الكمية ومعقدة في النوع ومتنوعة في الشكل، وتواجه تحديات متعددة مثل الاستعارة والإرجاع والجرد والبحث وفرز الكتب المفقودة، مما يؤثر على كفاءة إدارة المكتبة وتجربة القارئ.",
        "Solutiondec66": "أساليب إدارة قديمة",
        "Solutiondec67": "تجربة قراءة ضعيفة",
        "Solutiondec68": "قدرة ضعيفة على دمج الموارد",
        "Solutiondec69": "بنية معلومات غير كافية",
        "Solutiondec70": "إدارة الباركود، من الصعب جردها والبحث فيها، والكتب يمكن تفويتها أو سرقتها أو وضعها في مكان غير مناسب",
        "Solutiondec71": "إن عملية البحث عن الكتب واستعارتها وإرجاعها عملية مرهقة وتؤدي إلى تجربة سيئة للقارئ، مما يقلل من حماسه للاقتراض",
        "Solutiondec72": "لا يمكن دمج الكتب الورقية والدوريات والأدبيات لإدارة رقمية موحدة",
        "Solutiondec73": "لا يمكن جمع بيانات تداول المكتبة، ولا يمكن تلخيص معدلات الاقتراض والتداول",
        "Solutiondec74": "تدمج HIKBOREI تقنية RFID مع بوابة الوصول، وعلامات الكتب، وآلات الاستعارة والإرجاع ذاتية الخدمة، ومعدات المخزون، وبرامج نظام محطة عمل أمين المكتبة لتحقيق وظائف إدارة الكتب المريحة",
        "Solutiondec75": "إدراج الكتب",
        "Solutiondec76": "استعارة الكتب وإعادتها",
        "Solutiondec77": "إدارة الكتب",
        "Solutiondec78": "طباعة ولصق الملصقات",
        "Solutiondec79": "خدمة الاستعارة والإرجاع الذاتية/الإرجاع والتخزين/إدارة الأمن",
        "Solutiondec80": "جرد الكتب/موقعها/فرزها",
        "Solutiondec81": "تحسين كفاءة التداول",
        "Solutiondec82": "زيادة الأمان",
        "Solutiondec83": 'تحسين تجربة المستخدم',
        "Solutiondec84": "توفير دعم البيانات",
        "Solutiondec85": "تبسيط عملية استعارة الكتب وإعادتها، وتقليل التدخل اليدوي، وتحسين كفاءة التداول",
        "Solutiondec86": "إدارة أمن الكتب تمنع سرقة الكتب بشكل فعال",
        "Solutiondec87": "الخدمة الذاتية والإدارة الذكية تلبي احتياجات الخدمة الفعالة للقراء",
        "Solutiondec88": "يمكن لإحصاءات البيانات وتحليلها فهم احتياجات القراء بشكل أفضل وتحسين الإدارة",
        "Solutiondec89": "بطاقة RFID",
        "Solutiondec90": "طابعة ملصقات",
        "Solutiondec91": "جهاز محمول",
        "Solutiondec92": "بوابة ذكية",
        "Solutiondec93": "آلة استعارة وإرجاع ذاتية الخدمة",
        "Solutiondec94": "بطاقات كتب وبطاقات رفوف",
        "Solutiondec95": "متكاملة الوظائف، تلبي احتياجات طباعة الملصقات المختلفة",
        "Solutiondec96": "تحديد الهوية عن بُعد، وجرد دفعات الكتب بسرعة عالية",
        "Solutiondec97": "مراقبة معلومات ترك الكتب، ومكافحة السرقة",
        "Solutiondec98": "خدمة ذاتية، وتحسين الكفاءة",
        "Solutiondec99": "نظرًا لعدم التوافق في مراقبة صحة الماشية، والتتبع التنظيمي، وغيرها من التقنيات، غالبًا ما تتفاقم مخاطر التربية ومخاطر المطالبات، وهي العوامل الرئيسية التي تعيق تحقيق فوائد إيجابية للمربين ومؤسسات التأمين",
        "Solutiondec100": "لدى المزارعين وعي ضعيف بالمخاطر وحماس منخفض للتأمين",
        "Solutiondec101": "صعوبة في منع المخاطر الأخلاقية والاحتيال التأميني الخطير",
        "Solutiondec102": "إن العمل في مجال التأمين يشكل تحديًا، كما أن التحقق من المعلومات أمر صعب",
        "Solutiondec103": "إجراءات المطالبات معقدة، والمدفوعات لا تتم في الوقت المناسب",
        "Solutiondec104": "توفر HIKBOREI حلاً شاملاً يجمع بين منصة البيانات الضخمة والأجهزة الذكية وعلامات الأذن الإلكترونية RFID (علامات الأذن التي تستشعر درجة الحرارة) لتلبية الاحتياجات المزدوجة لمراقبة مخاطر المربي وعمليات حوكمة بيانات مؤسسة التأمين",
        "Solutiondec105": "وضع العلامات",
        "Solutiondec106": "التفتيش",
        "Solutiondec107": "المطالبات",
        "Solutiondec108": "المراقبة",
        "Solutiondec109": "تحميل معلومات المربي/ارتداء علامة الأذن/جمع بيانات الثروة الحيوانية",
        "Solutiondec110": "مراجعة بيانات تأمين الثروة الحيوانية/التفتيش العشوائي على مناطق المخاطر",
        "Solutiondec111": "التحقق من صحة الثروة الحيوانية/المطالبات عن بعد",
        "Solutiondec112": "مراقبة درجة حرارة جسم الماشية، وردود الفعل في الوقت الفعلي/تحذير المخاطر",
        "Solutiondec113": "حماية مصالح المربي",
        "Solutiondec114": "تحقيق فوائد إيجابية للمؤسسات التأمينية",
        "Solutiondec115": "تحقيق مراقبة الصحة والوقاية من الأمراض، مما يقلل من المخاطر التشغيلية للمزرعة",
        "Solutiondec116": "تحقيق مطالبات دقيقة وتبسيط عملية المطالبات وتحسين كفاءة المطالبات",
        "Solutiondec117": "بطاقة أذن RFID",
        "Solutiondec118": "قارئ بطاقات محمول",
        "Solutiondec119": "كاميرا فحص RFID",
        "Solutiondec120": "علامة أذن إلكترونية/علامة أذن تستشعر درجة الحرارة",
        "Solutiondec121": "اقرأ علامة الأذن أثناء وضع العلامات للتأكد من التوافق بين الماشية ومعلومات علامة الأذن",
        "Solutiondec122": "قراءة علامات الأذن عن بعد لمراجعة بيانات التأمين",
        image1: require("./assets/img/guanli11.png"),
        image2: require("./assets/img/guanli22.png"),
        image3: require("./assets/img/guanli33.png"),
        image4: require("./assets/img/guanli44.png"),
        image5: require("./assets/img/guanli55.png"),
        image6: require("./assets/img/ers.png"),
        "product1": "تمكين الإدارة البصرية والذكية",
        "product2": "قراءة دفعات طويلة المدى / دعم القراءة/الكتابة السريعة / أحجام/مواد/شعارات مخصصة / تطبيقات متعددة المشاهد",
        "product3": "قراءة علامات الأذن بعيدة المدى للتحقق من بيانات التأمين",
        "product4": "قراءة علامات الأذن بعيدة المدى للتحقق من بيانات التأمين",
        "product5": "سحابة الأصول الخفيفة",
        "product6": "حل شامل لإدارة الأصول، مما يجعل إدارة الأصول أسهل",
        "product7": "هيكفيجن أجري كلاود",
        "product8": "مساعدة قطاع التأمين في إجراء تأمين الثروة الحيوانية للمزارعين، وتحقيق دقة الاكتتاب ومعالجة المطالبات",
        "product9": "جدولة عرض توضيحي",
        "product10": "يسعدنا أن نقدم لك المساعدة التالية لتعميق فهمك لمنتجنا",
        "product11": "توفر سحابة الزراعة والثروة الحيوانية من Hikvision حلاً شاملاً يجمع بين منصة البيانات الضخمة والأجهزة الذكية وعلامات الأذن RFID",
        "product12": "Qingting Asset Cloud، التي تركز على تقنية RFID، تبني نظامًا بيئيًا جديدًا لإدارة الأصول الذكية",
        "product13": "تحليل المتطلبات",
        "product14": "الحل",
        "product15": "عرض الأسعار",
        "product16": "مستشارو المنتجات المحترفون لفهم سيناريوهات الاستخدام والاحتياجات بشكل عميق",
        "product17": "تخصيص أفضل حلول البرامج والأجهزة بناءً على المتطلبات",
        "product18": "توفير حل التسعير الأمثل بناءً على متطلبات المنتج",
        "adhesiveLabels": "ملصقات لاصقة",
        "flexibleMetalLabels": "ملصقات مرنة مضادة للمعادن",
        "antiMetalLabels": "ملصقات مضادة للمعادن",
        "washingLabels": "ملصقات غسيل",
        "hangtags": "بطاقات تعليق",
        "animalEarTags": "علامات أذن الحيوانات",
        "wristbands": "أساور المعصم",
        "chip": "رقاقة",
        "frequency": "التردد",
        "material": "المادة",
        "weight": "الوزن",
        "size": "الحجم",
        "operatingTemperature": "درجة حرارة التشغيل",
        "readingDistance": "مسافة القراءة",
        "installation": "التركيب",
        "AntennaSize": "حجم الهوائي",
        "ProductSize": "حجم المنتج",
        "Storage": "التخزين",
        "ApplicationSurface": "سطح التطبيق",
        "Color": "اللون",
        "Tensilestrength": "قوة الشد",
        "Operatingtemperature": "درجة حرارة التشغيل",
        "advone1": "المزايا",
        "advone2": "الخصائص",
        "advone3": "سيناريوهات التطبيق",
        "advone4": "١. لصق سهل، لا يتطلب أدوات إضافية. ٢. مقاوم للماء والزيت، ويبقى واضحًا وقابلًا للقراءة لفترة طويلة. ٣. يتحمل درجات الحرارة العالية، ولا يتشوه أو يتساقط.",
        "advone5": "١. التصاق ممتاز، يلتصق بقوة بمختلف أسطح المواد. ٢. ملمس ناعم، طباعة واضحة وجميلة للأنماط والنصوص. ٣. مناسب لطباعة أنواع مختلفة من الأحبار، مما يُسهّل إنتاج الملصقات. ٤. مجموعة واسعة من التطبيقات، تُستخدم على نطاق واسع في مختلف الصناعات.",
        "advone6": "صناعة الأغذية والمشروبات، الصناعة الطبية، الخدمات اللوجستية والنقل، صناعة الملابس، صناعة الإطارات، وغيرها.",
        "advone7": "١. يمكن تركيبه وقراءته على الأسطح المعدنية المنحنية. ٢. يدعم قراءة وتعريف مجموعات متعددة من البطاقات. ٣. يدعم طباعة وإصدار البطاقات باستخدام طابعات RFID.",
        "advone8": "١. مرن، مناسب للتثبيت على أجسام معدنية بأشكال متنوعة. ٢. أداء ممتاز ضد المعادن، لا يتأثر بالبيئات المعدنية. ٣. مسافة قراءة طويلة، اتجاهية ممتازة، سهلة التحديد. ٤. قابل للطباعة والتخصيص.",
        "advone9": "إدارة المعدات، وتتبع الأسطوانات، ومراقبة الحركة، وإدارة الخدمات اللوجستية، وإدارة المواد الخطرة، وما إلى ذلك.",
        "advone10": "١. يحقق ويتجاوز عمر الغسيل الصناعي لأكثر من ٢٠٠ دورة. ٢. خضعت المواد والتصميم لاختبارات موثوقية. ٣. تم شحن ما يقرب من ١٠٠ مليون وحدة، وحازت على تقدير العديد من العملاء العالميين.",
        "advone11": "١. اجتاز فحص التصوير بالرنين المغناطيسي، ويجتاز اختبارات التصوير المقطعي المحوسب والكشف عن المعادن. ٢. اجتاز اختبار GB18401، وهو آمن على البشرة. ٣. اجتاز اختبار RoHS، وهو خالٍ من المواد السامة والمسرطنة. ٤. اجتاز اختبار SVHC للاتحاد الأوروبي، وهو خالٍ من المواد السامة والمسرطنة. ٥. اجتاز اختبار EU OEKO-TEX Std 100، وهو خالٍ من المواد السامة. ٦. ناعم، لا يُتلف المنسوجات.",
        "advone12": "إدارة لوازم الفنادق، إدارة الزي الرسمي للعمل، إدارة بياضات المستشفيات، إدارة تأجير البياضات، إلخ.",
        "advone13": "١. إنتاج بطاقات ورقية، مناسبة لبطاقات المنتجات وبطاقات التعليق. ٢. طباعة رائعة، سهلة الطباعة للنصوص والأنماط وغيرها من المحتويات. ٣. متوافقة مع أحدث المعايير الدولية، قابلة للتطبيق في العديد من الصناعات والمجالات. ٤. تدعم البروتوكولات الدولية، ومناسبة للاستخدام في المزيد من الدول.",
        "advone14": "١. قراءة ملصقات متعددة في آنٍ واحد، مما يُحسّن بشكل كبير من سرعة ودقة إدارة المخزون. ٢. مسافة قراءة طويلة، دون الحاجة إلى اتصال مباشر، مما يُتيح مسحًا سريعًا للأصناف. ٣. تخزين معلومات المنتج لسهولة التتبع، مثل أرقام الدفعات وتواريخ الإنتاج ومعلومات سلسلة التوريد.",
        "advone15": "إدارة تصنيع خطوط الإنتاج، وإدارة العلامة التجارية، والخدمات اللوجستية ومخزون التخزين، وإدارة المتاجر، وما إلى ذلك.",
        "advone16": "١. أداء ممتاز في علامات الأذن الإلكترونية، مع عمر خدمة طويل. ٢. نقل إشارة مستقر، مما يتيح تحديدًا أكثر دقة. ٣. مسافة قراءة ثابتة، لا تتأثر بالبيئات الزراعية.",
        "advone17": "تأمين الثروة الحيوانية، والوقاية من الأوبئة الحيوانية، والتعريف الذكي والجرد، والوزن الذكي، وحفظ السجلات لمبيعات الثروة الحيوانية، وما إلى ذلك.",
        "advone18": "١. تصميم خفيف الوزن، مريح للارتداء. ٢. مسافة قراءة طويلة، سرعة تعرف عالية، وقدرة قوية على مقاومة التداخل.",
        "advone19": "المعارض والأحداث الرياضية وصناعة الرعاية الصحية وما إلى ذلك.",
        "advone20": "١. أداء ثابت وموثوق للعلامة. ٢. يمتلك رمز تعريف عالمي فريد (رمز TID). ٣. تصل مسافة القراءة إلى ١٠ أمتار فأكثر.",
        "advone21": "١. حساسية قراءة عالية، ونجاح تام في اختبار أداء القراءة. ٢. مدة حفظ البيانات تزтика الشركة على تعميق خبراتها في مجال تقنية تحديد الهوية بموجات الراديو (RFID) لإنترنت الأشياء (IoT)، حيث تمتلك سلسلة صناعية متكاملة تجمع بين البحث والتطوير والإنتاج والمبيعات. وبفضل قدراتها التقنية المتميزة، حازت الشركة على العديد من الشهادات العلمية والتكنولوجية، مثل \"المؤسسة الوطنية للتكنولوجيا الفائقة\"، و\"الشركة التكنولوجية الصغيرة والمتوسطة الإقليمية\"، و\"المؤسسة السحابية الإقليمية ذات الأربع نجوم\".",
        "hardone.performance_params": "معايير الأداء",
        "hardone.cpu": "وحدة المعالجة المركزية: ثماني النواة بتردد 2.3 جيجاهرتز",
        "hardone.ram_rom": "ذاكرة الوصول العشوائي (RAM) وذاكرة القراءة فقط (ROM): 4 جيجابايت + 64 جيجابايت",
        "hardone.expansion_memory": "الذاكرة القابلة للتوسعة: بطاقة MicroSD (TF) قابلة للتوسعة حتى 256 جيجابايت",
        "hardone.os": "نظام التشغيل: أندرويد 11",
        "hardone.physical_params": "المعايير المادية",
        "hardone.dimensions": "الأبعاد: 177.0 × 80.2 × 14.8 مم",
        "hardone.weight": "الوزن: 626 غرامًا (شامل البطارية)",
        "hardone.display": "شاشة 5 بوصة (مع بصمة الإصبع): 1280 × 720 / 6 بوصة، 2160 × 1080",
        "hardone.battery": "سعة البطارية: بطارية قبضة قابلة للإزالة 6700 مللي أمبير / ساعة / 13400 مللي أمبير / ساعة؛ بطارية احتياطية مدمجة 100 مللي أمبير / ساعة، تدعم تبديل البطارية الساخن",
        "hardone.camera": "آلة تصوير",
        "hardone.front_camera": "الكاميرا الأمامية: 5 ميجابكسل",
        "hardone.rear_camera": "الكاميرا الخلفية: 13 ميجابكسل مع دعم الفلاش",
        "hardone.rfid_ghf": "تقنية تحديد الهوية بموجات الراديو (RFID UHF)",
        "hardone.protocol_standard1": "معيار البروتوكول: EPCglobal Gen 2 (ISO18000-6C)",
        "hardone.protocol_standard2": "معيار البروتوكول: EPCglobal Gen 2 (ISO18000-6C)",
        "hardone.frequency": "",
        "hardone.engine": "المحرك: CM710-1، يعتمد على شريحة Impinj E710",
        "hardone.output_power": "قوة الخرج: 1 وات (30 ديسيبل ميلي واط، دعم +5~+30 ديسيبل ميلي واط قابل للتعديل) 2 وات (33 ديسيبل ميلي واط، لأمريكا اللاتينية، إلخ.)",
        "hardone.antenna_params": "معلمات الهوائي: الاستقطاب الدائري؛ 5 ديسيبل",
        "hardone.max_read_distance": "أقصى مسافة للقراءة",
        "hardone.max_read_distance_5dBi_1": "5 ديسيبل",
        "hardone.max_read_distance_5dBi_2": "30 مترًا (علامة Impinj MR6، مقاس 70 × 15 مم)",
        "hardone.max_read_distance_5dBi_3": "32 م (علامة إمبينج M750، مقاس 70 × 15 ملم)",
        "hardone.max_read_distance_5dBi_4": "33 مترًا (علامة Alian H3 المقاومة للمعادن، مقاس 130 × 42 مم)",
        "hardone.max_read_distance_4dBi_1": "٤ ديسيبل: ٤ ديسيبل",
        "hardone.max_read_distance_4dBi_2": "٢٢ مترًا (ملصقات Impinj MR6، مقاس ٧٠ × ١٥ مم)",
        "hardone.max_read_distance_4dBi_3": "٢٦ مترًا (ملصقات Impinj M750، مقاس ٧٠ × ١٥ مم)",
        "hardone.max_read_distance_4dBi_4": "27 مترًا (علامة Alian H3 المضادة للمعادن، مقاس 130 × 42 مم)",
        "motherboard": "اللوحة الأم",
        "hardone.read_rate": "معدل قراءة المجموعة: ما يصل إلى 1300+ علامة/ثانية (مستقطبة دائريًا)",
        "hardone.environment": "بيئة التشغيل",
        "hardone.operating_temperature": "درجة حرارة التشغيل: من -20 درجة مئوية إلى 50 درجة مئوية",
        "hardone.storage_temperature": "درجة حرارة التخزين: من -40 درجة مئوية إلى 70 درجة مئوية",
        "hardone.humidity": "الرطوبة المحيطة: 5% رطوبة نسبية - 95% رطوبة نسبية (غير متكثفة)",
        "hardtwo.hardware-title1": "معايير الأداء",
        "hardtwo.hardware-li1": "وحدة المعالجة المركزية: ثماني النواة، 2.0 جيجاهرتز",
        "hardtwo.hardware-li2": "ذاكرة الوصول العشوائي (RAM) + ذاكرة القراءة فقط (ROM): 8 جيجابايت + 256 جيجابايت",
        "hardtwo.hardware-li3": "الذاكرة القابلة للتوسعة: بطاقة MicroSD (TF) قابلة للتوسعة حتى 256 جيجابايت",
        "hardtwo.hardware-title2": "المعلمات الفيزيائية",
        "hardtwo.hardware-li4": "الأبعاد: 165.0 × 83.8 × 138.0 ملم",
        "hardtwo.hardware-li5": "الوزن: 697 جرامًا (بما في ذلك البطارية)",
        "hardtwo.hardware-li6": "البطارية: بطارية قابلة للإزالة للوحدة الرئيسية 5000 مللي أمبير في الساعة",
        "hardtwo.hardware-li7": "بطارية قابلة للإزالة للمقبض 5200 مللي أمبير في الساعة",
        "hardtwo.hardware-li8": "يدعم الشحن السريع QC3.0 وRTC",
        "hardtwo.hardware-li9": "الشاشة: شاشة كاملة عالية الدقة مقاس 6 بوصات، بدقة 1440 × 720 (18:9)",
        "hardtwo.hardware-li10": "منافذ الاتصال: USB Type-C، USB 3.1، OTG",
        "hardtwo.hardware-title3": "آلة تصوير",
        "hardtwo.hardware-li11": "الكاميرا الأمامية: 5 ميجابيكسل",
        "hardtwo.hardware-li12": "الكاميرا الخلفية: كاميرا ملونة 16M مع ضبط تلقائي ودعم فلاش",
        "hardtwo.hardware-title4": "تقنية تحديد الترددات الراديوية UHF",
        "hardtwo.hardware-li13": "المحرك: بناء على شريحة Impinj E710",
        "hardtwo.hardware-li14": "تردد التشغيل: 920-925 ميجا هرتز / 902-928 ميجا هرتز / 865-868 ميجا هرتز",
        "hardtwo.hardware-li15": "معايير البروتوكول: EPC C1 GEN2 / ISO18000-6C",
        "hardtwo.hardware-li16": "معلمات الهوائي: هوائي مستقطب دائري (4dBi)",
        "hardtwo.hardware-li17": "الطاقة: 1 واط (30 ديسيبل، يدعم +5 ديسيبل ~ +30 تعديل ديسيبل)",
        "hardtwo.hardware-li18": "اختياري 2 واط (33 ديسيبل، لأمريكا اللاتينية، إلخ.)",
        "hardtwo.hardware-li19": "أقصى مسافة للقراءة: 26 م (علامة إمبينج MR6 ، مقاس 70 × 15 مم)",
        "hardtwo.hardware-li20": "28 م (علامة Impinj M750 ، مقاس 70 × 15 مم)",
        "hardtwo.hardware-li21": "30 م (علامة أليان H3 المضادة للمعادن، مقاس 130 × 42 مم)",
        "hardtwo.hardware-li22": "معدل قراءة المجموعة: ما يصل إلى 1300+ علامة / ثانية (مستقطب بشكل دائري)",
        "hardtwo.hardware-title5": "بيئة التشغيل",
        "hardtwo.hardware-li23": "درجة حرارة التشغيل: -20 درجة مئوية ~ +50 درجة مئوية",
        "hardtwo.hardware-li24": "درجة حرارة التخزين: -40 ℃ ~ + 70 ℃",
        "hardtwo.hardware-li25": "الرطوبة المحيطة: 5% RH ~ 95% RH (غير مكثف)",
        "hardthree.hardware-title1": "معلمات الأداء",
        "hardthree.hardware-li1": "نوع وحدة التحكم الدقيقة: Cortex-M3",
        "hardthree.hardware-li2": "التردد الرئيسي: ٧٢ ميجاهرتز",
        "hardthree.hardware-li3": "سعة التخزين: ٥٠,٠٠٠ ملصق",
        "hardthree.hardware-title2": "المعلمات الفيزيائية",
        "hardthree.hardware-li4": "حجم الجهاز: ٢٨٢ × ١١٧.٥ × ٣٢ مم",
        "hardthree.hardware-li5": "وزن الجهاز: ٣٣٤ غرامًا (شاملًا البطارية)",
        "hardthree.hardware-li6": "مادة المظهر: بلاستيك",
        "hardthree.hardware-li7": "سعة البطارية: مواصفات البطارية: 5200mAh، قابل للإزالة",
        "hardthree.hardware-li8": "وقت الاستعداد> 70 ساعة (حالة اتصال بلوتوث)",
        "hardthree.hardware-li9": "وقت العمل: حوالي 6 ساعات (قراءة مجموعة UHF)",
        "hardthree.hardware-li10": "مدة الشحن 3-4 ساعات (باستخدام محول الطاقة القياسي وكابل البيانات)",
        "hardthree.hardware-li11": "الشاشة: 1.77 بوصة، 128 × 160",
        "hardthree.hardware-title3": "تقنية تحديد الهوية بموجات الراديو (RFID UHF)",
        "hardthree.hardware-li12": "المحرك: مبني على Impinj E710",
        "hardthree.hardware-li13": "الهوائي: هوائي مستقطب خطيًا (4 ديسيبل)",
        "hardthree.hardware-li14": "التردد: 920-925 ميجاهرتز/902-928 ميجاهرتز/865-868 ميجاهرتز",
        "hardthree.hardware-li15": "معيار البروتوكول: EPC C1 GEN2 / ISO18000-6C",
        "hardthree.hardware-li16": "طاقة الوحدة: 1 وات (30 ديسيبل ميلي واط، تدعم إمكانية التعديل من +5 إلى +30 ديسيبل ميلي واط)",
        "hardthree.hardware-li17": "اختياري 2 واط (33 ديسيبل ميلي واط، لأمريكا اللاتينية، وما إلى ذلك)",
        "hardthree.hardware-title4": "أقصى مسافة للقراءة",
        "hardthree.hardware-li18": "26 مترًا (علامة Impinj MR6، مقاس 70 × 15 مم)",
        "hardthree.hardware-li19": "27 م (علامة إمبينج M750، مقاس 70 × 15 مم)",
        "hardthree.hardware-li20": "31 مترًا (علامة Alien H3 المقاومة للمعادن، مقاس 130 × 42 مم)",
        "hardthree.hardware-li21": "معدل قراءة المجموعة: ما يصل إلى 900 علامة/ثانية.",
        "hardthree.hardware-title5": "بيئة التشغيل",
        "hardthree.hardware-li22": "درجة حرارة التشغيل -٢٠ درجة مئوية ~ +٥٠",
        "hardthree.hardware-li23": "درجة حرارة التخزين -٤٠ درجة مئوية ~ +٧٠",
        "hardthree.hardware-li24": "الرطوبة المحيطة 5% رطوبة نسبية ~ 95% رطوبة نسبية (غير مكثفة)",
        "hardfour.hardwareTitle": "الجزء الميكانيكي",
        "hardfour.internalDimensions": "الحجم الداخلي: ٢٢٠٠ × ٣٠٠٠ × ١٨٠٠",
        "hardfour.externalDimensions": "الحجم الخارجي: ٢٦٠٠ × ٣١٠٠ × ٢٢٠٠",
        "hardfour.dimensionsCustomizable": "(يدعم تخصيص الحجم)",
        "hardfour.electricalTitle": "الجزء الكهربائي",
        "hardfour.powerSource": "مصدر الطاقة: أحادي الطور ٢٢٠ فولت",
        "hardfour.powerConsumption": "القدرة: ١.٥ كيلو واط",
        "hardfour.controlSystem": "نظام التحكم: سيمنز PLC",
        "hardfour.pcSpecification": "الكمبيوتر الشخصي: 17 بوصة؛ ذاكرة 8 جيجابايت؛ قرص SSD سعة 256 جيجابايت؛ نظام Win10؛ شاشة تعمل باللمس الكل في واحد (يمكن تخصيص التعرف على بصمات الأصابع والتعرف على الوجه والبطاقة)",
        "hardfour.antiCollisionSensor": "كهروضوئية مضادة للتصادم: مفتاح مستشعر الانعكاس المنتشر لقمع الخلفية المريضة",
        "hardfour.alarmLight": "ضوء التنبيه: ثلاثة ألوان + صوت",
        "hardfour.rfidTitle": "جزء RFID",
        "hardfour.readerModel": "طراز القارئ: Impinj R420",
        "hardfour.antennaModel": "طراز الهوائي: Laird9028*24",
        "hardfour.detectionQuantity": "عدد أجهزة الكشف: 350 قطعة",
        "hardfour.shieldingMethod": "طريقة الحماية: ستارة دوارة أوتوماتيكية من القماش الموصل",
        "hardfour.shieldingPerformance": "أداء الحماية: 20 سم بعيدًا عن أي تسرب للإشارة",
        "hardfour.shieldingDoorsCustomizable": "(يدعم تخصيص الباب المفرد والمزدوج)",
        "hardfive.mechanical_part": "الجزء الميكانيكي",
        "hardfive.internal_dimensions": "الحجم الداخلي: ١١١٠*١٥٠٠*١٣٠٠ مم",
        "hardfive.external_dimensions": "الحجم الخارجي: ١٤٠٠*١٦٠٠*١٦٠٠ مم",
        "hardfive.dimensions_customizable": "(يدعم تخصيص الحجم)",
        "hardfive.electrical_part": "الجزء الكهربائي",
        "hardfive.power": "مصدر الطاقة: أحادي الطور ٢٢٠ فولت",
        "hardfive.power_consumption": "القدرة: ٠.٦ كيلو واط",
        "hardfive.control_system": "نظام التحكم: سيمنز PLC",
        "hardfive.pc_specifications": "الكمبيوتر الشخصي: 17 بوصة؛ ذاكرة 8 جيجابايت؛ محرك أقراص ثابت بسعة 256 جيجابايت؛ نظام تشغيل Windows 10؛ جهاز الكل في واحد يعمل باللمس",
        "hardfive.collision_prevention_sensor": "كهروضوئية مضادة للتصادم: مفتاح مستشعر الانعكاس المنتشر لقمع الخلفية المريضة",
        "hardfive.alarm_light": "ضوء التنبيه: ثلاثة ألوان + صوت",
        "hardfive.weighing_accuracy": "دقة الوزن: 50 جرامًا (يمكن تخصيص 10 جرامًا)",
        "hardfive.rfid_part": "قارئ أجزاء RFID",
        "hardfive.reader_model": "طراز: Impinj R420",
        "hardfive.antenna_model": "طراز الهوائي: Laird9028*4",
        "hardfive.detection_quantity": "عدد الكشف: 350 قطعة",
        "hardfive.shielding_method": "طريقة الحماية: ستارة دوارة أوتوماتيكية من القماش الموصل",
        "hardfive.shielding_performance": "أداء الحماية: 20 سم بعيدًا عن أي تسرب للإشارة",
        "hardfive.customizable_doors": "(يدعم تخصيص الباب المفرد والمزدوج)",
        "hardsix.mechanical": "الجزء الميكانيكي",
        "hardsix.channelSize": "حجم القناة: 900*830*1600 مم",
        "hardsix.conveyorLoad": "سعة حمولة خط النقل: 50 كجم",
        "hardsix.maxCarton": "أقصى حجم للكرتونة: 700*500*550 مم",
        "hardsix.conveyorType": "شكل خط النقل: أسطوانة",
        "hardsix.customizable": "(الحجم المذكور أعلاه قابل للتخصيص)",
        "hardsix.electrical": "الجزء الكهربائي",
        "hardsix.powerSource": "مصدر الطاقة: أحادي الطور 220 فولت",
        "hardsix.powerConsumption": "القدرة: 1.5 كيلو واط",
        "hardsix.controlSystem": "نظام التحكم: وحدة تحكم منطقية قابلة للبرمجة من سيمنز",
        "hardsix.pcSpecs": "الكمبيوتر الشخصي: 17 بوصة؛ ذاكرة 8 جيجابايت؛ 256 جيجابايت SSD؛ نظام Win10؛ الكل في واحد يعمل باللمس (يمكن تخصيص التعرف على بصمات الأصابع والتعرف على الوجه والبطاقة)",
        "hardsix.collisionPhotoelectric": "كهروضوئية مضادة للتصادم: مفتاح مستشعر الانعكاس المنتشر لقمع الخلفية المريضة",
        "hardsix.baojing": "ضوء إنذار: ثلاثة ألوان + صوت",
        "hardsix.rfid": "جهاز قراءة RFID",
        "hardsix.readerModel": "طراز: Impinj R420",
        "hardsix.antennaModel": "طراز الهوائي: Laird9028 * 24",
        "hardsix.detectionQuantity": "عدد أجهزة الكشف: 350 قطعة",
        "hardsix.shieldingMethod": "طريقة الحماية: ستارة دوارة أوتوماتيكية من القماش الموصل",
        "hardsix.shieldingPerformance": "أداء الحماية: 20 سم بعيدًا عن أي تسرب للإشارة",
        "hardsix.customizableDoors": "(يدعم تخصيص الباب المفرد والمزدوج)",
        "hardsenven.mechanical_title": "الجزء الميكانيكي",
        "hardsenven.mechanical_dimensions": "حجم المظهر: الجسم الرئيسي 900*960*1800 مم",
        "hardsenven.mechanical_conveyor_length": "طول خط النقل الأمامي والخلفي: 1.2 متر",
        "hardsenven.mechanical_conveyor_weight": "سعة تحميل خط النقل: ٥٠ كجم",
        "hardsenven.mechanical_conveyor_height": "ارتفاع خط النقل: ٦٠ ± ٥ سم",
        "hardsenven.mechanical_box_size": "حجم صندوق الاختبار: ٧٠ × ٥٠ × ٥٥ سم كحد أقصى",
        "hardsenven.electrical_title": "الجزء الكهربائي",
        "hardsenven.electrical_power": "الطاقة المقدرة: ٨٠٠ واط",
        "hardsenven.electrical_voltage": "جهد التشغيل: تيار متردد ~ ٢٢٠ فولت",
        "hardsenven.electrical_computer": "كمبيوتر صناعي: ذاكرة 8 جيجابايت، محرك أقراص صلبة 256 جيجابايت، شاشة لمس من نوع المقاومة مقاس 17 بوصة",
        "hardsenven.rfid_title": "جزء RFID",
        "hardsenven.rfid_reader": "قارئ RFID: Impinj R420",
        "hardsenven.rfid_antenna": "تكوين الهوائي: هوائي مستقطب دائريًا 9 ديسيبل * 4",
        "hardsenven.rfid_speed": "سرعة الكشف: ٧-٨ صناديق/دقيقة",
        "hardsenven.rfid_quantity": "كمية الكشف: ٣٥٠ قطعة/صندوق",
        "hardsenven.rfid_frequency": "تردد التشغيل: ٩٢٠-٩٢٥ ميجاهرتز",
        "hardsenven.environment_title": "بيئة الاستخدام",
        "hardsenven.environment_working_temp": "درجة حرارة التشغيل: -١٠ درجات مئوية إلى +٤٠ درجة مئوية",
        "hardsenven.environment_storage_temp": "درجة حرارة التخزين: -٢٠ درجة مئوية إلى +٨٠ درجة مئوية",
        "hardeight.mechanical_title": "الجزء الميكانيكي",
        "hardeight.mechanical_dimensions": "الحجم الداخلي: ٤٢٠٠ مم × ٨٠٠ مم × ٣٦٠٠ مم",
        "hardeight.mechanical_conveyor_length": "الأبعاد الخارجية: ٤٧٢٠ × ٨٠٠ × ٣٨٦٠ مم",
        "hardeight.electrical_title": "الجزء الكهربائي",
        "hardeight.electrical_power": "مصدر الطاقة: أحادي الطور ٢٢٠ فولت",
        "hardeight.electrical_voltage": "الطاقة: ٠.٤ كيلوواط",
        "hardeight.electrical_computer": "نظام التحكم: سيمنز PLC",
        "hardeight.electrical_computer2": "الكمبيوتر الشخصي: 17 بوصة؛ ذاكرة 8 جيجابايت؛ قرص SSD سعة 256 جيجابايت؛ نظام تشغيل Windows 10؛ جهاز الكل في واحد يعمل باللمس",
        "hardeight.electrical_computer3": "ضوء التنبيه: ثلاثة ألوان + صوت",
        "hardeight.electrical_computer4": "تحديد الرافعة الشوكية: مفتاح مغناطيسي أرضي أو رادار",
        "hardeight.rfid_title": "قطعة RFID",
        "hardeight.rfid_reader": "قارئ RFID: Impinj R420",
        "hardeight.rfid_antenna": "طراز الهوائي: 9028*8",
        "hardware1": "الأجهزة",
        // "hardware2": "أجهزة RFID عالية الأداء الكل في واحد",
        "hardware2": "RFID أجهزة عالية الأداء الكل في واحد",
        "software1": "البرمجيات",
        "software2": "منصة برمجيات رقمية احترافية وفعالة",
        hardwarelistone: {
            items: [{
                id: 1,
                title: "UHF RFID Handheld",
                image: require("./assets/img/ying1.jpg"),
                model: "HKBR-RH-C5",
            }, {
                id: 2,
                title: "UHF RFID Handheld",
                image: require("./assets/img/ying2.jpg"),
                model: "HKBR-RH-MC50",
            }, {
                id: 3,
                title: "UHF RFID Bluetooth Reader",
                image: require("./assets/img/ying3.jpg"),
                model: "HKBR-RB-R2",
            }, {
                id: 4,
                title: "RFID Forklift Inventory Cabinet",
                image: require("./assets/img/ying4.jpg"),
                model: "HKBR-RInventory-S02DR",
            }, {
                id: 5,
                title: "RFID Weighing and Inventory Cabinet",
                image: require("./assets/img/ying5.jpg"),
                model: "HKBR-RInventory-W06R",
            }, {
                id: 6,
                title: "RFID Electric Inventory",
                image: require("./assets/img/ying6.jpg"),
                model: "HKBR-RInventory-09D ",
            }, {
                id: 7,
                title: "RFID Gate",
                image: require("./assets/img/ying7.jpg"),
                model: "HKBR-RG-T10",
            }, {
                id: 8,
                title: "RFID Gantry",
                image: require("./assets/img/ying8.jpg"),
                model: "HKBR-RL-L08",
            }, ]
        },
        "solution": {
            "items": [{
                    "title": "إدارة الأصول",
                    "description": "إدارة الأصول بعمرها الكامل في مكان واحد لمساعدة الشركات على تقليل التكاليف وتحسين الكفاءة"
                },
                {
                    "title": "إدارة أفراد المعارض",
                    "description": "إدارة ذكية ودقيقة لأفراد المعارض لتعزيز كفاءة إدارة الفعاليات وتجربة المشاركين"
                },
                {
                    "title": "إدارة المكتبات",
                    "description": "إدارة بعمر كامل لموارد المكتبات، مما يعزز بشكل شامل قيمة الاستخدام المتكامل للمكتبات"
                },
                {
                    "title": "إدارة تربية الحيوانات",
                    "description": "الإشراف الذكي على الأصول البيولوجية، وتحسين فوائد التربية، وتحقيق التأمين الدقيق والتسوية السريعة للمطالبات"
                }
            ]
        },
        "producttile": {
            "items": [{
                    "title": "علامات RFID",
                    "description": "ملصقات لاصقة/ملصقات مضادة للمعادن/ملصقات الغسيل/علامات تعليق"
                },
                {
                    "title": "الأجهزة الذكية",
                    "description": "محمول/خزانة الجرد/القناة/البوابة"
                },
                {
                    "title": "منصات البرمجيات",
                    "description": "سحابة أصول Qingting/سحابة Hikvision الزراعية"
                }
            ]
        },
        newsdetailone: {
            "title": "أعلنت هيئة صناعة وتكنولوجيا المعلومات في مدينة شوتشو مؤخرًا عن قائمة الشركات للدفعة الثانية من شركات الحوسبة السحابية الإقليمية ذات الثلاث والأربع نجوم لعام 2024",
            "highlight": "والجدير بالذكر أن شركة HIKBOREI هي الشركة الوحيدة في منطقة Gulou، مدينة Xuzhou، التي تم الاعتراف بها كمؤسسة سحابية ذات أربع نجوم في عام 2024!",
            "description": "تشير المؤسسة السحابية ذات الأربع نجوم إلى الشركة التي حققت التحول الرقمي في إدارتها وعملياتها باستخدام تكنولوجيا الإنترنت لتمكين تبادل المعلومات ومشاركة البيانات بين الأنظمة والأجهزة، والاستفادة من موارد الحوسبة السحابية"
        },
        newsdetailtwo: {
            "title": "هيكوبوروي ترحب بلحظتها المجيدة",
            "date": "01-Nov",
            "milestone": "الشحنات التراكمية العالمية لعلامات RFID تتجاوز 100 مليون في عام 2024",
            "milestoneDescription": "يُعد هذا الإنجاز المهم علامة بارزة على أن تصبح Hikuborui مزودًا رائدًا لحلول تقنية RFID وإنترنت الأشياء",
            "newAchievement": "100 مليون إنجاز جديد، نقطة بداية جديدة",
            "achievementDescription": "صرح المدير العام لشركة هيكوبوري، ليو جين بينج، بأن إنجاز الشركة هو نتيجة عمل السوق والعملاء والموظفين معًا",
            "technologyInnovation": "ركزت الشركة دائمًا على بناء القدرة التنافسية المتميزة في السوق من خلال الابتكار التكنولوجي",
            "industryExperience": "في الوقت الحالي، تمتلك شركة Hikuborui، بفضل قوتها المتراكمة، خبرة ناضجة في البحث والتطوير لحلول تطبيقات RFID في الصناعة",
            "customerRecognition": "بفضل قوتها التقنية الممتازة وأداء المنتج، يمكن لمنتجات علامات RFID التي طورتها Hikuborui بشكل مستقل وحلول إنترنت الأشياء المخصصة الاستجابة بسرعة لاحتياجات العملاء المحليين والدوليين",
            "futureVision": "ستواصل شركة هيكوبوروي المضي قدمًا برؤية مستقبلية، مع التركيز على تقنية إنترنت الأشياء وتحديد الهوية بموجات الراديو"
        },
        newsdetailthree: {
            "title": "رسالة شكر من عميل سعودي",
            "subTitle": "النص الأصلي كما يلي:",
            "greeting": "فريق هايكانغبوروي العزيز،",
            "content1": "أكتب هذا البريد الإلكتروني بامتنان لا نهاية له للتعبير عن خالص شكري على كرم الضيافة والرعاية التي قدمتموها لي أثناء إقامتي في الصين",
            "content2": "في تعاوننا، شعرت بعمق بحماسك واحترافيتك",
            "content3": "أشكر شركتكم بصدق على كل المساعدة والدعم المقدم",
            "content4": "مرة أخرى أتقدم بخالص الشكر والتقدير لجميع موظفي شركتكم",
            "closing": "شكرًا لك!",
            "closing2": "بإخلاص"
        },
        "newsdetailfour": {
            "title": "16 أكتوبر: انعقاد منتدى 'التكنولوجيا للمزارعين' حول تربية الماشية",
            "content1": "في يوم 16 أكتوبر، أقيم منتدى حول 'الوقاية والحماية والتكنولوجيا للمزارعين' لتربية الماشية في المدينة",
            "content2": "ناقش لي لي، مدير التكنولوجيا في شركة GreenDot Technology، الدور الحيوي لتكنولوجيا المعلومات في تحسين قطاع الثروة الحيوانية",
            "content3": "أقيمت الجلسة التطبيقية تحت عنوان 'بناء مستقبل إنتاج الثروة الحيوانية معًا'",
            "content4": "في جناح المعرض خلال المؤتمر، جذبت مجموعة واسعة من المنتجات ذات العلامات التجارية انتباه الزوار",
            "content5": "قدم كويك تحليلاً مفصلاً لأهداف وأهمية إدخال التكامل التكنولوجي في قطاع الثروة الحيوانية",
            "content6": "كان هذا المؤتمر الدولي بمثابة منصة لتبادل الأفكار الرائدة بين البلدان"
        },
        "newsdetailfive": {
            "intro1": "تجعل العلامات الإلكترونية RFID إدارة خط الإنتاج أكثر ذكاءً",
            "intro2": "تتميز العلامات الإلكترونية RFID بحجمها الصغير ووزنها الخفيف وسهولة استخدامها",
            "application": "تطبيقات العلامات الإلكترونية في إدارة خطوط الإنتاج",
            "tracking": "1. تتبع العناصر وإدارتها",
            "tracking_desc": "يمكن تتبع العناصر الفردية وإدارتها بشكل فعال باستخدام العلامات الإلكترونية RFID",
            "automation": "2. التحكم في أتمتة الإنتاج",
            "automation_desc": "يمكن لأنظمة RFID الاتصال بمعدات الإنتاج لتحقيق التحكم في أتمتة العملية",
            "quality": "3. تتبع الجودة والتفتيش",
            "quality_desc": "يمكن لعلامات RFID تسجيل عملية الإنتاج والبيئة لتحقيق إمكانية تتبع الجودة والتفتيش",
            "advantages": "مزايا أنظمة تحديد الهوية بموجات الراديو (RFID) في أتمتة إدارة خطوط الإنتاج",
            "efficiency": "1. زيادة كفاءة الإنتاج",
            "efficiency_desc": "باستخدام العلامات الإلكترونية RFID، يمكن تحقيق الأتمتة والتفتيش الرقمي لعملية الإنتاج",
            "cost": "2. خفض التكاليف وتوفير الموارد",
            "cost_desc": "يمكن أن يؤدي استخدام علامات RFID الإلكترونية إلى تقليل هدر العمالة والمواد",
            "product_quality": "3. تحسين جودة المنتج وسلامته",
            "product_quality_desc": "من خلال وظيفة التتبع للعلامات الإلكترونية RFID، يمكن تتبع المواد الخام ومراقبة جودتها",
            "supply_chain": "4. تحسين إدارة سلسلة التوريد",
            "supply_chain_desc": "تتيح العلامات الإلكترونية RFID إمكانية التصور الشامل والإدارة الديناميكية لسلسلة التوريد",
            "conclusion": "لقد لعبت العلامات الإلكترونية RFID دورًا حاسمًا في تعزيز ذكاء إدارة خط الإنتاج"
        },
        "newsdetailsix": {
            "development_reform_innovation": "التطوير والإصلاح والابتكار هي مواضيع ثابتة في عملية نمو الشركة",
            "many_enterprises_introduce_rfid": "بدأت العديد من الشركات الكبيرة والمتوسطة الحجم في تقديم أنظمة إدارة المستودعات الذكية RFID",
            "what_problems_can_rfid_solve": "ما هي المشاكل التي يمكن لإدارة المستودعات الذكية RFID حلها؟",
            "use_rfid_to_improve_efficiency": "استخدام ميزة التعريف السريع بتقنية RFID لتحسين الكفاءة في عمليات الاستلام والشحن وحساب المخزون",
            "lean_management": "2. الإدارة الهزيلة",
            "improve_management_accuracy": "تحسين إدارة الأعمال، ومنع الأخطاء الناجمة عن جمع البيانات يدويًا",
            "cost_saving": "3. توفير التكاليف",
            "improve_resource_utilization": "زيادة كفاءة استخدام الموارد وتبسيط العمليات",
            "build_new_rfid_system": "استخدام تقنية تحديد الترددات الراديوية RFID لبناء منصة جديدة لنظام معلومات المستودعات",
            "system_composition": "تكوين النظام",
            "advantages_of_rfid_in_practice": "مزايا إدارة المستودعات الذكية بتقنية RFID في الممارسة العملية",
            "low_cost_high_efficiency": "1. جمع المعلومات بتكلفة منخفضة وكفاءة عالية",
            "inventory_data_collection": "(1) تلقي جمع البيانات",
            "warehouse_inventory_data": "(2) جمع بيانات مخزون المستودعات",
            "outbound_data_collection": "(3) جمع البيانات الصادرة",
            "precise_location_management": "2. إدارة دقيقة لموقع المستودعات ومراقبة شاملة للحالة",
            "control_product_information": "أضف علامة RFID فريدة لكل منتج",
            "warehouse_management_flowchart": "مخطط انسيابي لإدارة المستودعات",
            "rfid_system_applications": "تطبيقات نظام إدارة المستودعات الذكي بتقنية RFID",
            "ensure_data_input_speed": "إدارة المستودعات الذكية هي جزء من عملية اللوجستيات"
        },
        "newsdetailseven": {
            "title1": "يؤدي تطوير تقنية RFID إلى دفع صناعة التجزئة نحو إدارة المخزون الذكية والفعالة والمتقدمة",
            "title2": "بالإضافة إلى ذلك، توفر تقنية RFID طرقًا ملائمة ومتقدمة لجمع البيانات والتفاعل مع العملاء والعمليات التشغيلية",
            "title3": "تنعكس تطبيقات علامات RFID في صناعة البيع بالتجزئة بشكل رئيسي في",
            "item1": "1. إدارة المخزون",
            "item2": "2. إدارة منع السرقة",
            "item3": "3. إدارة المبيعات",
            "item4": "4. تجربة العملاء",
            "conclusion": "يمثل الاستخدام الواسع النطاق لعلامات RFID في صناعة البيع بالتجزئة تحولاً أساسياً في كفاءة إدارة البيع بالتجزئة وأمنها"
        },
        "newsdetaileight": {
            "newsTitle": "ملصقات RFID ذاتية اللصق",
            "newsContent1": "توفر ملصقات RFID ذاتية اللصق سرعة تعريف سريعة، وقراءة مريحة وسريعة، وسعة شريحة كبيرة، وبيانات شريحة قابلة لإعادة الكتابة، وعمر خدمة طويل، وأمان عالي، وتلعب دورًا مهمًا في العديد من الصناعات.",
            "newsContent2": "ملصقات RFID ذاتية اللصق هي علامات إلكترونية سلبية تتكون من ورق خلفي، وورق أمامي، وطبقة لاصقة، وبطانة RFID. يمكنها تغليف شرائح وهوائيات RFID مختلفة، وهي ناعمة ورقيقة وسهلة الاستخدام، وتتميز بفعاليتها العالية من حيث التكلفة.",
            "newsContent3": "تُصنع ملصقات RFID ذاتية اللصق من مواد مثل الورق الصناعي، والبولي إيثيلين تيرفثالات (PET)، والبولي فينيل كلوريد (PVC)، مما يوفر التصاقًا جيدًا ومقاومة للتآكل بتكلفة منخفضة. ويمكن طباعة معلومات المنتج، مثل الاسم والطراز وتاريخ الإنتاج، على سطحها.",
            "newsContent4": "تتمتع الطبقة السطحية للمادة اللاصقة بالعديد من المزايا، مثل سهولة التمزيق، والالتصاق القوي، والاستخدام المرن، ومقاومة الحرارة والرطوبة، وعدم الشيخوخة، وعدم التلوث، مما يجعلها مناسبة لمختلف البيئات وسيناريوهات الاستخدام.",
            "newsSubtitle": "تطبيقات ومزايا ملصقات RFID ذاتية اللصق",
            "newsContent5": "1. إدارة الأرشيف/المكتبة: إن تطبيق ملصقات RFID ذاتية اللصق على الأرشيفات والكتب يسمح باستقبال معلومات الكتاب وموقعه والاستعارة وتسجيل الإرجاع بسهولة، مما يحسن كفاءة العمل وتجنب الأخطاء.",
            "newsContent6": "2. مكافحة التزوير وإمكانية التتبع: يحتوي كل منتج على علامة إلكترونية RFID فريدة تسجل جميع المعلومات من الشركة المصنعة المصدر إلى محطة المبيعات، مما يؤدي إلى إنشاء سجلات مفصلة من خلال المسح الضوئي.",
            "newsContent7": "3. إدارة خطوط الإنتاج: تُسجِّل ملصقات RFID ذاتية اللصق معلومات العمليات والتشغيل على خطوط الإنتاج بسهولة ودقة، مُلبِّيةً بذلك احتياجات الإنتاج المرنة. تُسجِّل هذه الملصقات هوية العامل، والوقت، والعمليات، ونتائج فحص الجودة، مما يُتيح إمكانية تتبُّع الإنتاج بشكل كامل، ويُجنِّب الأخطاء الناتجة عن المعلومات المكتوبة بخط اليد أو المرئية في بيئات الإنتاج.",
            "newsContent8": "4. إدارة المستودعات: تعمل ملصقات RFID ذاتية اللصق على إدارة معلومات مخزون المستودعات بشكل فعال، مما يسمح بفهم موقع البضائع وظروف التخزين في الوقت الفعلي، مما يحسن كفاءة المستودع بشكل كبير ويوجه الإنتاج.",
            "newsContent9": "5. إدارة متاجر التجزئة: تدعم ملصقات RFID ذاتية اللصق الكتابة المتكررة. بخلاف الملصقات الورقية ذات السعر الثابت، تستطيع ملصقات RFID التعامل بسرعة مع أسعار المنتجات المتغيرة دون الحاجة إلى إتلاف الملصق، حيث تقرأ التغييرات وتعيد كتابتها مباشرةً باستخدام قارئ. هذا يُلغي تكاليف تكرار الملصقات، ويُقلل من العمل اليدوي لاستبدالها، مما يُحسّن كفاءة العمل. حتى في حال كانت معلومات المنتج على سطح الملصق غير واضحة أو تالفة، طالما أن الشريحة سليمة، يُمكن قراءتها وكتابتها بشكل صحيح، مما يُجنّب نزاعات التسوق الناتجة عن إهمال العمل، ويُحسّن تجربة التسوق.",
            "newsContent10": "تلعب ملصقات RFID ذاتية اللصق، باعتبارها مادة طباعة سهلة الاستخدام، دورًا متزايد الأهمية في الحياة الاقتصادية والاجتماعية. ومع التوسع المستمر في السوق والتقدم التكنولوجي، تبدو آفاق سوق ملصقات RFID ذاتية اللصق واعدة للغاية، ومن المتوقع ظهور المزيد من التطبيقات المبتكرة."
        },
        "newsdetailnine": {
            "newsTitle": "اشهد على القوة! حازت هيكبوري على لقب 'شركة متخصصة، راقية، ومبتكرة' على مستوى المقاطعة.",
            "newsContent1": "أعلنت إدارة الصناعة وتكنولوجيا المعلومات بمقاطعة جيانغسو مؤخرًا عن قائمة الشركات المتخصصة والمتطورة والمبتكرة المعترف بها على مستوى المقاطعة لعام 2024، وقد دخلت شركة HIKBOREI، بقدراتها الابتكارية الممتازة وقوتها التقنية المهنية، في القائمة!",
            "newsContent2": "تتميز الشركات الصغيرة والمتوسطة 'المتخصصة، المتطورة، المبتكرة، والجديدة' بتخصصها، ودقتها، وتميزها، وحداثتها. وهي شركات نموذجية تتمتع بحصة سوقية عالية، وجودة وكفاءة ممتازتين، وريادة في الابتكار المستمر وإتقان التقنيات الأساسية الرئيسية.",
            "newsSubtitle1": "مؤهلات هيكبوري 'المتخصصة، والمتطورة، والمبتكرة، والجديدة'",
            "newsSubtitle2": "التخصص العميق",
            "newsContent3": "منذ تأسيسها، دأبت شركة هيكبوري على تعميق خبراتها في مجال تقنية تحديد الهوية بموجات الراديو (RFID) لإنترنت الأشياء (IoT)، حيث تمتلك سلسلة صناعية متكاملة تجمع بين البحث والتطوير والإنتاج والمبيعات. وبفضل قدراتها التقنية المتميزة، حازت الشركة على العديد من الشهادات العلمية والتكنولوجية، مثل 'المؤسسة الوطنية للتكنولوجيا الفائقة'، و'الشركة التكنولوجية الصغيرة والمتوسطة الإقليمية'، و'المؤسسة السحابية الإقليمية ذات الأربع نجوم'.",
            "newsSubtitle3": "خدمات راقية",
            "newsContent4": "تُركز شركة هيكبوري على تصميم وتطوير علامات تعريف ترددات الراديو (RFID) لإنترنت الأشياء، ووحدات وقارئات تعريف ترددات الراديو، ورقائق تعريف ترددات الراديو، وبرامج تكامل صناعة تعريفات ترددات الراديو. وتستجيب الشركة بسرعة لاحتياجات عملائها العالميين، حيث تُقدم منتجاتها وحلولها لأكثر من 30 دولة ومنطقة حول العالم.",
            "newsSubtitle4": "حلول فريدة",
            "newsContent5": "باعتبارها شركة رائدة في تقديم حلول تقنية RFID وإنترنت الأشياء، تقدم HIKBOREI بشكل مستمر حلولاً ومنتجات مخصصة وعالية القيمة تعتمد على تقنية RFID لمختلف الصناعات، مسترشدة بمتطلبات السوق والحدود التكنولوجية.",
            "newsSubtitle5": "القيادة المبتكرة",
            "newsContent6": "تلتزم شركة هيكبوري بقيادة الابتكار، وتمتلك قدرات بحث وتطوير مستقلة ناضجة، وفريقًا بحثيًا يتمتع بخبرة صناعية عميقة ورؤية استشرافية. وقد تراكمت لديها خبرة تقنية أساسية في البحث والتطوير للمنتجات وتطوير البرمجيات في مجال إنترنت الأشياء وتحديد الهوية بموجات الراديو (RFID)، مما يجعلها رائدة في السوق من خلال الابتكار الاحترافي.",
            "newsContent7": "وفي المستقبل، ستواصل HIKBOREI التركيز على الأبحاث والتطبيقات المبتكرة لتكنولوجيا RFID الخاصة بإنترنت الأشياء، مما يعزز قدرتها التنافسية الأساسية لتوفير منتجات وخدمات ذات قيمة أعلى لمزيد من العملاء."
        },
        "newsdetailten": {
            "newsTitle": "استكشاف فرص جديدة في الأسواق الخارجية والسعي إلى تنمية مربحة للجانبين —— زيارة هيكبوري إلى المملكة العربية السعودية",
            "newsContent1": "نتواصل بشكل وثيق مع العملاء في الخارج ونسعى لتطوير الأسواق الدولية بشكل استباقي. مؤخرًا، قاد ليو جين بينغ، المدير العام لشركة جيانغسو هيكبوري للإلكترونيات المحدودة، فريقًا في زيارة إلى المملكة العربية السعودية، محققًا نتائج مهمة، مما أرسى أساسًا متينًا لتوسع هيكبوري المتسارع في الأسواق الخارجية.",
            "newsContent2": "في سياق التطور السريع للاقتصاد الرقمي، تُظهر صناعة إنترنت الأشياء بتقنية تحديد الترددات الراديوية (RFID) في الشرق الأوسط، بما في ذلك المملكة العربية السعودية، إمكانات نمو قوية. تُركز رؤية المملكة العربية السعودية 2030 على برنامج التحول الوطني، الذي يدعم ريادة الأعمال الرقمية والاستثمار في التقنيات الرقمية. وباعتبارها عنصرًا أساسيًا، تتمتع تقنية إنترنت الأشياء بإمكانيات سوقية هائلة وآفاق تطوير واعدة.",
            "newsContent3": "بفضل خبرتها الواسعة في مجال إنترنت الأشياء وتحديد الهوية بموجات الراديو (RFID)، تعمل شركة هيكبوري بنشاط على تعزيز حضورها في الأسواق الخارجية. وبفضل خبرتها الواسعة في هذا المجال ومزاياها التقنية القوية، حظيت الشركة بقبول واسع في السوق السعودية. وقد اتسمت هذه الزيارة، التي استمرت أسبوعين، بالفعالية والكفاءة، حيث ركزت على نقاط الاتصال الرئيسية والمشاريع الأساسية، محققةً نتائج ملموسة.",
            "newsContent4": "خلال الزيارة، التقى فريق HIKBOREI بمزوّدي خدمات الشبكات المحليين المرموقين، وشركات استشارات حلول تحديد الهوية بموجات الراديو (RFID)، ومزوّدي خدمات تصنيع تحديد الهوية بموجات الراديو. وناقشوا بعمق اتجاهات سوق تحديد الهوية بموجات الراديو الحالية، والابتكارات التكنولوجية، ومتطلبات المنتجات. واستعرض الفريق بشكل شامل شمولية وريادية منتجات وخدمات HIKBOREI، مما عزز ثقة العملاء وفهمهم. وأثمرت الزيارة عن رؤى قيّمة حول السوق وفرص تعاون قيّمة، حيث تم التوصل إلى اتفاقيات بشأن العديد من مشاريع تحديد الهوية بموجات الراديو.",
            "newsContent5": "ولم تساهم هذه الرحلة إلى المملكة العربية السعودية في تعميق فهم الفريق للسوق والصناعة المحلية فحسب، بل عززت ثقة HIKBOREI في استمرار توسع أعمالها في الخارج، كما أظهرت موقفنا الاستباقي في استكشاف الأسواق الدولية والبحث عن فرص جديدة للتنمية الدولية."
        },
        "newsdetaileleven": {
            "newsTitle": "استقبل العام الجديد، وانطلق في فصول جديدة، واربح معركة 2025 | عُقد مؤتمر HIKBOREI للعام الجديد 2025 بنجاح",
            "newsContent1": "لقد زُيّن العام الماضي بألف طبقة من الديباج، وسيبلغ العام الجديد آفاقًا جديدة. في 26 يناير، اجتمع جميع موظفي هيكبوري لعقد مؤتمر عام 2025 رسميًا! هذه ليست مجرد لحظة مهمة لاستحضار الماضي واستشراف المستقبل، بل هي أيضًا نقطة حاسمة لرفع المعنويات واستجماع القوة.",
            "newsContent2": "الليل والنهار هما امتداد الزمن، مسجلين خطوات هيكبوري. في بداية المؤتمر، استعرض جميع الموظفين تاريخ تطور هيكبوري. هذه الذكريات الثمينة لا توثق مسيرة نمو الشركة فحسب، بل تُعدّ أيضًا شهادةً قويةً على الجهود الجماعية والإنجازات المتواصلة لجميع الموظفين.",
            "newsContent3": "وفي وقت لاحق، شارك نائب الرئيس تشانغ شيا، ومدير المبيعات سونغ تشي، ومدير مصنع الإنتاج ليانغ لي، ومدير التكنولوجيا تشي جون من شركة Jiangsu HIKBOREI Electronics Co., Ltd.، الإنجازات والعيوب التي حققتها HIKBOREI في البحث والتطوير والإنتاج والتشغيل، وحددوا الأهداف لعام 2025.",
            "newsContent4": "أكد نائب الرئيس تشانغ أن إنجازات هيكبوري اليوم لا تنفصل عن وحدة الفكر، وتضافر الجهود، واتساق العمل بين الجميع. كما دعا جميع الموظفين إلى وضع أهداف ثابتة للعام الجديد، ومعالجة أوجه القصور، والسعي نحو التميز، والعمل معًا لتحقيق المزيد من النجاح الباهر.",
            "newsContent5": "بتعزيز القدوة، نستمد القوة للمضي قدمًا. خلال جلسة المشاركة، شارك ممثلو الموظفين المتميزون بصدق رحلة نموهم ورؤاهم المهنية في هيكبوري، مما ألهم كل موظف حاضر على السعي الجاد لتحقيق التميز في العام الجديد.",
            "newsContent6": "غمر حفل تكريم الموظفين المتميزين أجواءً حماسية، حيث تناوب الجميع على استلام جوائزهم. وقد عبّرت الشركة عن امتنانها العميق لجهود الجميع، حيث مُنحت الشهادات والكؤوس تقديرًا لجهودهم ومساهماتهم. ينتمي هؤلاء الموظفون المتميزون إلى مختلف الإدارات والمناصب، وقد أصبحوا، بفضل أدائهم المتميز وروح المسؤولية العالية والتفاني، قدوة يُحتذى بها لجميع الموظفين.",
            "newsContent7": "عقب الحفل، ألقى ليو جين بينغ، المدير العام لشركة جيانغسو هيكبوري للإلكترونيات المحدودة، كلمةً موجزةً استعرض فيها تطور الشركة في السنوات الأخيرة، مُشيرًا إلى أنه على الرغم من التحديات الاقتصادية الراهنة، فقد حققت الشركة نموًا ملحوظًا، وهو ثمرة العمل الدؤوب والمساهمات المتميزة لجميع موظفيها.",
            "newsContent8": "نحن واثقون تمامًا بالمستقبل، ولدينا القدرة والقوة لتحقيق نجاحات أكبر. في الوقت نفسه، هنأ المدير العام ليو الجميع بالعام الجديد، آملًا أن يُظهر الجميع حماسًا ونشاطًا أكبر في عملهم في العام الجديد، وأن يعملوا معًا لتحقيق أهداف تنموية جديدة.",
            "newsContent9": "إن الاستضافة الناجحة لهذا المؤتمر لم تعزز التماسك والقوة المركزية داخل الشركة فحسب، بل جعلت كل موظف يدرك بوضوح الاتجاه الذي تتجه إليه HIKBOREI في عام 2025. ونحن نعتقد أنه تحت القيادة الصحيحة لإدارة الشركة والجهود المشتركة لجميع الموظفين، ستكتب HIKBOREI بالتأكيد فصلاً أكثر مجدًا في العام الجديد."
        },
        "newsdetailtwelve": {
            "newsTitle": "زيارة قادة منطقة قولو لشركة HIKBOREI | تقديم السياسات وحل التحديات لتمكين الابتكار",
            "newsContent1": "في 7 مايو، قاد لوه ده تشينغ، سكرتير لجنة حزب منطقة قولو، وتشنغ فنغ، نائب السكرتير، وليو يي، نائب رئيس المنطقة، وفدًا لزيارة شركة جيانغسو HIKBOREI للإلكترونيات. حيث اطلعوا على تطور الشركة واستمعوا إلى ملاحظاتها وناقشوا حلولًا للتحديات. رافقهم المدير العام ليو جين بينغ وقام بتقديم تقرير عن تقدم الشركة.",
            "newsContent2": "مناقشة مستديرة: معالجة التحديات من أجل النمو",
            "newsContent3": "في قاعة الاجتماعات، ناقش قادة المنطقة مع المدير العام ليو جين بينغ بشكل متعمق. استفسر السكرتير لوه ده تشينغ عن عمليات الشركة وتقدم البحث والتطوير والتوسع في السوق، مع التركيز على استقرار سلسلة التوريد وجذب المواهب وتنفيذ السياسات. قدم ليو جين بينغ تقنيات HIKBOREI الأساسية والخطط الاستراتيجية، بينما طرح بصراحة تحديات مثل احتياجات التوسع في الأراضي والدعم السياسي المتخصص.",
            "newsContent4": "التفقد الميداني: إظهار الاهتمام في الخطوط الأمامية",
            "newsContent5": "بعد الاجتماع، تجول الوفد في المكتب المفتوح. عكست الجدران الزجاجية بيان رؤية الشركة الأحمر - 'التكنولوجيا تمكّن الحياة الحضرية' - تحت الضوء الطبيعي. كان المهندسون يكتبون بانتباه، حيث امتزجت نقرات لوحات المفاتيح مع طنين معدات مركز البيانات في 'سمفونية التكنولوجيا'.",
            "newsContent6": "أعرب المدير العام ليو جين بينغ عن امتنانه لزيارة القادة، قائلًا إنها عززت الروح المعنوية والثقة. وتعهد بزيادة استثمارات البحث والتطوير لتعزيز القدرة التنافسية والإسهام أكثر في اقتصاد قولو الرقمي."
        },
        "newsdetail13": {
            "newsTitle": "تبادل الأعمال الصيني-السعودي | زيار عملاء سعوديين لشركة HIKBOREI لتعزيز التعاون العالمي",
            "newsContent1": "في 15 مايو، زار ممثلون عن عملاء سعوديين شركة HIKBOREI وقاعدتها الإنتاجية. حيث رحب بهم المدير العام ليو جين بينغ وكبار المسؤولين بحرارة، وناقشوا تعميق التعاون.",
            "newsContent2": "تجول العملاء في ورشة الإنتاج ومركز البحث والتطوير ومنطقة عرض المنتجات، حيث اطلعوا على التصنيع الذكي ومراقبة الجودة وابتكارات شرائح RFID. وأثنوا على التقدم التكنولوجي. خلال المحادثات، استكشف الجانبان نماذج التعاون الاستراتيجي، حيث أعرب العملاء عن حماسهم لتوسيع الشراكات. وقد مهد هذا التبادل الطريق للتوسع في الأسواق الدولية."
        },
        "newsdetail14": {
            "newsTitle": "الابتكار مدفوع بالتكنولوجيا | زيارة حكومية وشركاتية وأكاديمية لشركة HIKBOREI",
            "newsContent1": "في 20 مايو، زار روي قوه تشيانغ، سكرتير حزب جامعة جيانغسو نورمال، إلى جانب المدراء تشاو يو سو، قو تشن تشونغ، وو دي، وهان هونغ تشنغ، شركة HIKBOREI برفقة قادة المنطقة. حيث قدم المدير العام ليو جين بينغ مقدمة مفصلة عن تطور الشركة.",
            "newsContent2": "في قاعة العرض، عرض ليو جين بينغ إنجازات HIKBOREI وتقنياتها الأساسية وتطبيقاتها الصناعية عبر شاشات ووسائط متعددة. ثم شاهدت المجموعة كفاءة خط الإنتاج الذكي. وأبرز قادة المنطقة دور HIKBOREI في الابتكار الإقليمي، مما أثار مناقشات متعمقة حول البحث والتطوير والإدارة، مع إشادة بالإنجازات.",
            "newsContent3": "هذا الحدث، الذي سهلته قادة المنطقة، ربط الأكاديميا بالصناعة. حيث عمق فهم جامعة جيانغسو نورمال لشركة HIKBOREI ومهد الطريق للتعاون المستقبلي بين الجامعة والشركة. واتفق جميع الأطراف على الاستفادة من هذه الزيارة لتعزيز التعاون وتغذية النمو الاقتصادي الإقليمي بالابتكار التكنولوجي."
        },
        "newsdetail15": {
            "newsContent1": "في 23 مايو، قام قادة جمعية أبحاث نظرية عمل مجلس الشعب لبلدية شويتشو، بما في ذلك تشانغ فونينج، فنغ تشيبو، يوان جيانفن، تشو جيانهونغ، ووانغ ليفينغ، بقيادة جميع أعضاء المجلس والشركاء لزيارة HIKBOREI، برفقة قادة المنطقة.",
            "newsContent2": "استقبل ليو جينبنغ، المدير العام لـ HIKBOREI، الوفد ترحيبًا حارًا وقادهم عبر قاعة المعارض وورشة الإنتاج. في قاعة المعارض، قدم ليو تفاصيل عن تاريخ تطوير الشركة وتقنياتها الأساسية وابتكارات الصناعة، مع التركيز بشكل خاص على التطبيق المبتكر لرقائق استشعار درجة الحرارة التي طورتها الشركة بنفسها في المجالات الطبية. وأشار إلى أن هذه الرقائق تستخدم تقنية استشعار درجة حرارة عالية الدقة لتمكين مراقبة درجة حرارة الجسم بدقة وفي الوقت الفعلي، وتطبق حاليًا في الأجهزة الطبية الذكية التي تلعب أدوارًا حيوية في إدارة الأمراض المزمنة ومراقبة إعادة التأهيل بعد الجراحة، مما يعزز بشكل كبير مستوى الذكاء في الخدمات الطبية.",
            "newsContent3": "عند دخول ورشة الإنتاج، ظهرت المعدات الحديثة والعمليات الدقيقة وأنظمة الإدارة الفعالة. قدم ليو تفسيرات مفصلة حول حجم الإنتاج ومراقبة الجودة والقدرة، مما سمح للزوار بتجربة نقاط القوة الأساسية والحيوية الابتكارية لـ HIKBOREI مباشرة.",
            "newsContent4": "وفرت هذه الزيارة فرصة ممتازة لوفد جمعية الأبحاث لاكتساب فهم أعمق لـ HIKBOREI وتعزيز التواصل المتبادل. تلقى الاستكشاف النشط لـ HIKBOREI في الابتكار التكنولوجي والتطوير الصناعي، وخاصة التطبيق العملي لرقائق استشعار درجة الحرارة في المجالات الطبية، اعترافًا وثناءً من الزوار."
        },
        "newsdetail16": {
            "newsContent1": "في 20 يونيو، قام فريق تفتيش مكون من أعضاء لجنة عمل حي تايهو الجديدة في جينينغ، ولجنة الإدارة، ومكتب المالية بالحي الجديد، وقسم تعزيز الاستثمار بزيارة ميدانية إلى شركة جيانغسو هايكان بوروي للاطلاع على الابتكارات التكنولوجية في مجال تقنية الترددات اللاسلكية، وحلول RFID الرائدة، والتطبيقات الصناعية الذكية. رافق المدير العام ليو جينبنغ الوفد خلال الزيارة، حيث ناقش الجانبان تعميق التعاون الصناعي وتعزيز تنفيذ المشاريع.",
            "newsContent2": "تفقد خطوط التصنيع الذكي والتركيز على اختراقات التكنولوجيا الأساسية",
            "newsContent3": "خلال جولة القاعة الذكية، عرض المدير العام ليو جينبنغ ابتكارات الشركة في مجال الاستشعار الذكي وتطوير الأجهزة الطرفية الذكية عبر نظام عرض 'ثالوث' يشمل لوحات رقمية، مصفوفات نماذج منتجات، وإسقاطات هولوغرافية غامرة. تم عرض مصفوفة براءات الاختراع الأساسية ونظام التطبيقات الصناعية (بما في ذلك الرعاية الصحية الذكية، سلسلة التبريد، تتبع التجزئة، الإنترنت الصناعي، والثروة الحيوانية الإيكولوجية).",
            "newsContent4": "ثم انتقل الوفد إلى ورشة إنتاج هايكان بوروي لمراقبة خطوط الإنتاج الذكية. في قسم تركيب SMT، اطلع المسؤولون على عملية الإنتاج الآلي بالكامل وشهدوا المراقبة والتحسين في الوقت الحقيقي.",
            "newsContent5": "تسريع التركيز على التخطيط الصناعي، والتعاون لرسم خطة التنمية",
            "newsContent6": "وضعت هذه الزيارة أساسًا متينًا لتعاون أعمق بين الطرفين، حيث تم الاتفاق على نموذج تنموي مشترك، مما يمثل خطوة مهمة في التوسع الاستراتيجي الوطني لهايكان بوروي. في المستقبل، سيواصل الطرفان تعزيز التواصل لضمان التنفيذ الفعال للمشاريع التعاونية."
        },
        newsdetail17: {
            newsContent1: 'في السنوات الأخيرة، تطورت تقنية RFID (تحديد الهوية بموجات الراديو) من أداة مبكرة لتتبع اللوجستيات إلى اعتماد واسع النطاق في تجارة التجزئة والرعاية الصحية والتصنيع والمدن الذكية وغيرها من المجالات. وفقًا لشركة أبحاث السوق IDTechEx، من المتوقع أن يتجاوز سوق RFID العالمي 40 مليار دولار بحلول عام 2032، بمعدل نمو سنوي مركب (CAGR) يزيد عن 10٪. فلماذا ستشهد علامات RFID نموًا هائلاً في المستقبل؟',
            newsContent2: '1. ترقية قطاع التجزئة الذكية: تجاوز الرموز الشريطية التقليدية إلى عصر "التجزئة بدون دفع نقدي"',
            newsContent3: 'تتطلب الرموز الشريطية التقليدية مسحًا ضوئيًا فرديًا، بينما تتيح علامات RFID القراءة الدفعية، مما يحسن بشكل كبير سرعة جرد المخزون. على سبيل المثال، بعد اعتماد RFID، زادت دقة المخزون في وول مارت إلى 98٪ وانخفضت معدلات النفاد بنسبة 16٪. تعتمد متاجر "أمازون جو" و"تاو كافيه" التابعة لعلي بابا على تقنية RFID + الذكاء الاصطناعي لتمكين الدفع "خذ وامشي". تستخدم العلامات التجارية الفاخرة (مثل LV وGucci) علامات RFID لمكافحة التزييف، مما يسمح للمستهلكين بالتحقق من الأصالة عبر NFC للهواتف الذكية. تستخدم صناعة المواد الغذائية (مثل المنتجات الطازجة والنبيذ) أيضًا RFID للتتبع الكامل، مما يعزز ثقة العلامة التجارية. في المستقبل، ستجمع علامات RFID بين التسعير الديناميكي والرفوف الذكية لخلق تجارب تسوق أكثر سلاسة.',
            newsContent4: '2. الصناعة 4.0 والتصنيع الذكي: RFID كمكون رئيسي في "التوائم الرقمية"',
            newsContent5: 'في صناعات مثل تصنيع السيارات وتجميع الإلكترونيات، يمكن لعلامات RFID تتبع تدفق المكونات، مما يتيح رؤية كاملة لعملية الإنتاج. على سبيل المثال، تستخدم تسلا RFID لإدارة تجميع حزم البطاريات، مما يقلل معدلات الخطأ بنسبة 30٪. يمكن للمعدات الصناعية (مثل أدوات الماكينات والروبوتات) المدمجة مع علامات RFID مراقبة الحالة التشغيلية في الوقت الفعلي، بالاقتران مع الذكاء الاصطناعي للتنبؤ بالأعطال وتقليل خسائر التوقف. تمكن RFID من "رمز واحد لكل عنصر"، مما يدعم نماذج الإنتاج ذات الدفعات الصغيرة والمتعددة لتلبية احتياجات التخصيص للمستهلكين (مثل الأحذية المخصصة والمنتجات المطبوعة ثلاثية الأبعاد).',
            newsContent6: '3. الرعاية الصحية: من إدارة الأدوية إلى الأجهزة القابلة للارتداء الذكية',
            newsContent7: 'تطلب إدارة الغذاء والدواء الأمريكية (FDA) استخدام UDI (تحديد الجهاز الفريد) للمستلزمات الطبية عالية القيمة (مثل دعامات القلب)، مما يجعل RFID الحل الأمثل للحد من أخطاء الأدوية وهدر سلسلة التوريد. تُستخدم أساور RFID لتحديد هوية المرضى، بالاقتران مع أجهزة إنترنت الأشياء لمراقبة التسريب وإرسال الطوارئ لتحسين السلامة الطبية. في المستقبل، يمكن لعلامات RFID المرنة دمج مستشعرات درجة الحرارة ومعدل ضربات القلب لإنشاء "جلد إلكتروني" لإدارة الأمراض المزمنة (مثل السكري وارتفاع ضغط الدم).',
            newsContent8: '4. المدن الذكية وإنترنت الأشياء: RFID تبني أساس "إنترنت كل شيء"',
            newsContent9: 'النقل الذكي وإدارة المركبات: لوحات الترخيص الإلكترونية (RFID + التعرف على لوحة الترخيص) تمكن خصم رسوم الازدحام تلقائيًا وتتبع المخالفات. الاقتصاد التشاركي: تستخدم الدراجات المشتركة وشواحن الطاقة RFID لتحسين الجدولة وتقليل التكاليف التشغيلية. فرز النفايات والمراقبة البيئية. الزراعة الذكية وإدارة الثروة الحيوانية: علامات RFID للأذن تمكن تتبع الماشية ومراقبة بيئات التربية (مثل درجة الحرارة والرطبية وتحذيرات الأمراض)، مما يزيد من قيمة المنتجات الزراعية.',
            newsContent10: '5. الاختراقات التكنولوجية: انخفاض التكاليف وتحسين الأداء',
            newsContent11: 'انخفاض التكاليف يدفع الاعتماد: انخفضت تكاليف علامات RFID التقليدية بالفعل وقد تنخفض أكثر في السنوات الخمس المقبلة. الإلكترونيات المطبوعة (مثل حبر الفضة النانوية) تتيح طباعة RFID مباشرة على العبوة، مما يقلل من خطوات وضع العلامات. تقنية RFID الجيل التالي: RFID استشعار بدون بطارية: تجمع طاقة التردد اللاسلكي لبيانات البيئة (درجة الحرارة، الرطوبة). RFID UHF للقراءة بعيدة المدى: تمتد من أمتار إلى عشرات الأمتار، مثالية للتخزين. التكامل مع الذكاء الاصطناعي وسلسلة الكتل: الذكاء الاصطناعي + RFID: يحسن توقع المخزون (مثل إعادة التزويد الديناميكي). سلسلة الكتل + RFID: تضمن بيانات سلسلة التوريد غير القابلة للتغيير (لتتبع الماس والسلع الفاخرة).',
            newsContent12: 'مستقبل علامات RFID: من "اختياري" إلى "أساسي". في الماضي، كان RFID محدودًا بسبب التكاليف الأعلى، ولكن مع نضج التكنولوجيا والإنتاج الضخم، سيصبح منتشرًا مثل الرموز QR. مدفوعًا برقمنة التجزئة، الصناعة 4.0، الرعاية الصحية الذكية، والمدن الذكية، فإن سوق علامات RFID على وشك النمو السريع.',
            newsContent13: 'بالنسبة للشركات، يعني اعتماد RFID المبكر الحصول على ميزة تنافسية في العمليات القائمة على البيانات. بالنسبة للمستهلكين، سيوفر RFID تجارب معيشية أكثر أمانًا وراحة وذكاءً. هذه "الثورة الصامتة" قد بدأت للتو.',
            newsContent14: '(مصادر بيانات جزئية: IDTechEx، GS1، تقارير سلسلة توريد وول مارت)'
        },
        "newsone": {
            "items": [{
                    "id": 16,
                    "title": "تسريع التركيز على تخطيط الصناعة الذكية، والتعاون لرسم خطة التنمية!",
                    "summary": "في 20 يونيو، قام فريق تفتيش مكون من أعضاء من لجنة عمل حي تايهو الجديدة في جينينغ، ولجنة الإدارة، ومكتب المالية بالحي الجديد، وقسم تعزيز الاستثمار بزيارة ميدانية إلى جيانغسو هايكان بوروي لإجراء تحقيق ميداني.",
                    image: require("./assets/img/anews16.jpg"),
                    createTime: "2025-06-20",
                },
                {
                    "id": 15,
                    "title": "قيادات مجلس الشعب البلدي تزور هايكفيجن-بور: تشهد طاقة الابتكار في إنترنت الأشياء الذكي",
                    "summary": "في 23 مايو، قاد قادة جمعية أبحاث نظرية عمل مجلس الشعب البلدي في شويتشو، تشمل تشانغ فونينج، فنغ تشيبو، يوان جيانفن، تشو جيانهونغ، ووانغ ليفنغ، جميع أعضاء المجلس لزيارة هايكفيجن-بور، برفقة قادة المنطقة.",
                    image: require("./assets/img/anews15.jpg"),
                    "createTime": "2025-05-23"
                },
                {
                    "id": 14,
                    "title": "التمكين التكنولوجي: وفد من الحكومة والشركات والجامعات يزور موقع الابتكار في HIKBOREI",
                    "summary": "في 20 مايو، قاد روي قوقيانغ، سكرتير اللجنة الحزبية لجامعة جيانغسو للمعلمين، وفدًا يضم تشاو يوسو (مدير مكتب اللجنة الحزبية)، قو تشن تشونغ (مدير التعاون المحلي)، وو دي (مدير شؤون الخريجين)، وهان هونغ تشنغ (نائب مدير شؤون الطلاب) لزيارة HIKBOREI لتبادل الخبرات. ليو جين بنغ، المدير العام لـ HIKBOREI، استقبل الضيوف بحرارة وقدم شرحًا مفصلاً عن تطور الشركة.",
                    image: require("./assets/img/anews14.jpg"),
                    "createTime": "2025-05-20"
                },
                {
                    "id": 13,
                    "title": "تبادل الشركات الصينية السعودية: عملاء سعوديون يزورون HIKBOREI لتعزيز التعاون الدولي",
                    "summary": "في 15 مايو، زار ممثلون عن عملاء سعوديين HIKBOREI وقاعدة الإنتاج الخاصة بها. ليو جين بنغ، المدير العام لـ HIKBOREI، إلى جانب كبار المسؤولين، استقبلوا الضيوف بحرارة، وأجرى الجانبان مناقشات متعمقة حول تعزيز التعاون والتنمية المشتركة.",
                    image: require("./assets/img/anews13.jpg"),
                    "createTime": "2025-05-15"
                },
                {
                    "id": 12,
                    "title": "قادة منطقة غولو يزورون HIKBOREI: تقديم السياسات وحل التحديات لتمكين الابتكار",
                    "summary": "في 7 مايو، قاد لوه دتشينغ، سكرتير اللجنة الحزبية لمنطقة غولو، تشنغ فنغ، نائب السكرتير، وليو يي، نائب رئيس المنطقة التنفيذي، فريقًا لزيارة شركة جيانغسو HIKBOREI للإلكترونيات المحدودة. وقد تعرفوا مباشرة على تطور الشركة واستمعوا إلى الملاحظات للمساعدة في معالجة التحديات. رافق ليو جين بنغ، المدير العام لـ HIKBOREI، الوفد وقدم تقريرًا عن تقدم الشركة.",
                    image: require("./assets/img/anews12.jpg"),
                    "createTime": "2025-05-07"
                },
                {
                    "id": 11,
                    "title": "افتتاح العام الجديد، وانطلاق في فصول جديدة، وانتصار في معركة 2025 - مؤتمر هيكبوري للعام الجديد 2025 يُعقد بنجاح",
                    "summary": "في 26 يناير، اجتمع جميع موظفي هيكبوري لعقد مؤتمر كبير للعام الجديد 2025! هذه ليست فقط لحظة مهمة لاستعراض الماضي والتطلع إلى المستقبل، بل هي أيضًا نقطة حاسمة لرفع الروح المعنوية وتوحيد القوى.",
                    image: require("./assets/img/anews11.jpg"),
                    "createTime": "2025-01-26"
                },
                {
                    "id": 10,
                    "title": "استكشاف فرص جديدة في الأسواق الخارجية والسعي لتحقيق تنمية مربحة للجانبين - زيارة هيكبوري إلى المملكة العربية السعودية",
                    "summary": "زيارة وثيقة للعملاء في الخارج وتطوير الأسواق الدولية بنشاط. مؤخرًا، قاد ليو جين بينغ، المدير العام لشركة جيانغسو هيكبوري للإلكترونيات المحدودة، فريقًا لزيارة عملاء في المملكة العربية السعودية، محققًا نتائج مثمرة وواضعًا أساسًا متينًا لتسريع توسع هيكبوري في الأسواق الخارجية.",
                    image: require("./assets/img/anews10.jpg"),
                    "createTime": "2025-01-20"
                },
                {
                    "id": 9,
                    "title": "اشهد على القوة! حازت هيكبوري على لقب 'شركة متخصصة، راقية، ومبتكرة' على مستوى المقاطعة",
                    "summary": "أعلنت إدارة الصناعة وتكنولوجيا المعلومات بمقاطعة جيانغسو مؤخرًا عن قائمة الشركات المتخصصة والمتطورة والمبتكرة المعترف بها على مستوى المقاطعة لعام 2024، وقد دخلت هيكبوري، بفضل قدراتها الابتكارية الممتازة وقوتها التقنية المهنية، في القائمة!",
                    image: require("./assets/img/anews9.jpg"),
                    "createTime": "2024-12-31"
                },
                {
                    "id": 1,
                    "title": "شهادة إقليمية إضافية! حصلت هاي كانغ بوروي على تصنيف 'مؤسسة سحابية ذات أربع نجوم' في مقاطعة جيانغسو",
                    "summary": "أعلنت هيئة صناعة وتكنولوجيا المعلومات في مدينة شوتشو مؤخرًا عن قائمة الشركات في الدفعة الثانية لعام 2024 للشركات السحابية الإقليمية ذات الثلاث والأربع نجوم. بعد طلب عبر الإنترنت، مراجعة أولية، مراجعة الخبراء، التفتيش الميداني، ومراجعة الائتمان، دخلت شركة جيانغسو هاي كانغ بوروي للإلكترونيات المحدودة بنجاح في قائمة المؤسسات السحابية ذات الأربع نجوم في مقاطعة جيانغسو.",
                    image: require("./assets/img/anews1.jpg"),
                    "createTime": "2024-12-02"
                },
                {
                    "id": 2,
                    "title": "شحنات علامات RFID تتجاوز 100 مليون! هاي كانغ بوروي تعمل بكامل طاقتها، وتصعد إلى آفاق جديدة",
                    "summary": "في الأول من نوفمبر 2024، حققت هاي كانغ بوروي إنجازًا هامًا حيث تجاوزت الشحنات التراكمية العالمية لعلامات RFID 100 مليون.",
                    image: require("./assets/img/anews2.jpg"),
                    "createTime": "2024-11-15"
                },
                {
                    "id": 3,
                    "title": "رسالة شكر من عميل سعودي: أزهار التعاون تتفتح، والامتنان والثقة تسودان!",
                    "summary": "رسالة شكر من عميل سعودي",
                    image: require("./assets/img/anews3.jpg"),
                    "createTime": "2024-05-04"
                },
                {
                    "id": 4,
                    "title": "دعوة هيكربوراي لحضور ندوة تربية الماشية على مستوى المدينة بعنوان 'التعاون في الوقاية والحماية، والتكنولوجيا للزراعة'",
                    "summary": "في 16 أكتوبر، أُقيمت ندوة حول 'التعاون في الوقاية والحماية، والتكنولوجيا للزراعة' لتربية الماشية على مستوى المدينة. حضر الاجتماع زو وي، نائب مدير هيئة الزراعة والشؤون الريفية بالمدينة، وألقى كلمة. وحضر الاجتماع قادة الأقسام من مكاتب الزراعة والشؤون الريفية في المقاطعات والمناطق، ورؤساء محطات الوقاية من الأوبئة، وممثلون من شركات التأمين.",
                    image: require("./assets/img/anews4.jpg"),
                    "createTime": "2024-10-17"
                }
            ]
        },
        "newsotwo": {
            "items": [{
                    "id": 17,
                    title: "علامات RFID: خمسة محركات رئيسية للنمو السريع في العقد القادم",
                    summary: "في السنوات الأخيرة، تطورت تقنية RFID (تحديد الهوية بموجات الراديو) من أداة مبكرة لتتبع اللوجستيات إلى اعتماد واسع النطاق في تجارة التجزئة والرعاية الصحية والتصنيع والمدن الذكية والعديد من المجالات الأخرى.",
                    image: require("./assets/img/anews17.jpg"),
                    createTime: "2025-06-27"
                },
                {
                    "id": 5,
                    "title": "العلامات الإلكترونية RFID: مساعد قوي لإدارة خط الإنتاج الذكي",
                    "summary": "جعلت تطبيقات العلامات الإلكترونية RFID إدارة خط الإنتاج أكثر ذكاءً، مما يحسن كفاءة العمل ودقته بشكل كبير، مع تقليل تكاليف الإنتاج ومدخلات العمالة.",
                    image: require("./assets/img/anews5.jpg"),
                    "createTime": "2023-03-09"
                },
                {
                    "id": 6,
                    "title": "نظام إدارة المستودعات الذكي RFID، يبدأ رحلة ذكية لتخزين الشركات!",
                    "summary": "التطوير والإصلاح والابتكار هي مواضيع أبدية في نمو الشركات. يتغير طلب السوق على المنتجات بسرعة، وتصبح حاجة المصانع للأفراد أكثر إلحاحًا... تواجه العديد من الشركات التصنيعية تحديات شديدة.",
                    image: require("./assets/img/anews6.jpg"),
                    "createTime": "2023-10-10"
                },
                {
                    "id": 7,
                    "title": "تقنية RFID تحول صناعة التجزئة: تحسين كفاءة إدارة المخزون وتعزيز تجربة العملاء",
                    "summary": "يدفع التطبيق الواسع لتقنية RFID في صناعة التجزئة تحول الصناعة نحو إدارة ذكية وفعالة ودقيقة. فهي تمكن نظام سلسلة التوريد من تتبع حركة المنتجات بسهولة وتلقائية بطريقة فعالة، مما يتيح للعناصر تحقيق إدارة آلية حقيقية.",
                    image: require("./assets/img/anews7.jpg"),
                    "createTime": "2023-08-03"
                },
                {
                    "id": 8,
                    "title": "تطبيقات ومزايا ملصقات RFID في الصناعة",
                    "summary": "تتميز ملصقات RFID بسرعة التعرف السريعة، والقراءة المريحة والسريعة، وسعة الشريحة الكبيرة، وبيانات الشريحة القابلة لإعادة الكتابة، وعمر الخدمة الطويل، والأمان العالي. وهي تلعب دورًا مهمًا في العديد من الصناعات.",
                    image: require("./assets/img/anews8.jpg"),
                    "createTime": "2023-05-11"
                }
            ]
        }
    }


}

const i18n = new VueI18n({
    locale: "en",
    messages

})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')